<template>
  <!--    经销商列表新增-->
  <div class="signBox">
    <!--<breadcrumb :routerList="[{to:'/agent/agentCopy',title:'经销商管理'},{title:'经销商详情'}]"/>-->
    <Breadtabsheader />
    <div class="imgBox width" v-loading="loading">
      <div class="bannerBox">
        <div class="whiteBox">
          <div>
            <div class="h-pieceTitle2" style="margin-bottom: 0.2rem;" v-if="!isShangWei">
              <h1>经销商类型</h1>
            </div>
            <div style="margin: 0.2rem 0 0.2rem 0;" v-if="!isShangWei && guanliren">
              <el-radio-group v-model="radio" :disabled="flag==='2'||flag==='3'||flag==='4'" @change="changeType">
                <el-radio-button label="国内客户"></el-radio-button>
                <!--                <el-radio-button label="上海直销"></el-radio-button>-->
                <el-radio-button label="海外客户" :disabled="flag==='5'"></el-radio-button>
                <el-radio-button label="维护经销商" v-if="isWh"></el-radio-button>
              </el-radio-group>
            </div>
            <div style="margin: 0.2rem 0 0.2rem 0;" v-if="!isShangWei && !guanliren && !haiwairen">
              <el-radio-group v-model="radio" :disabled="flag==='2'||flag==='3'||flag==='4'" @change="changeType">
                <el-radio-button label="国内客户"></el-radio-button>
                <el-radio-button label="维护经销商" v-if="isWh"></el-radio-button>
                <!--                <el-radio-button label="上海直销"></el-radio-button>-->
              </el-radio-group>
            </div>
            <div style="margin: 0.2rem 0 0.2rem 0;" v-if="!isShangWei && !guanliren && haiwairen">
              <el-radio-group v-model="radio" :disabled="flag==='2'||flag==='3'||flag==='4'" @change="changeType">
                <el-radio-button label="海外客户"></el-radio-button>
                <el-radio-button label="维护经销商" v-if="isWh"></el-radio-button>
              </el-radio-group>
            </div>
            <div class="h-pieceTitle2" style="margin-bottom: 0.2rem;" v-if="!isShangWei">
              <h1>直单类型（客户性质）</h1>
            </div>
            <div style="margin-top: 5px;" v-if="!isShangWei">
              <div style="font-size: 0.15rem;color: #ff2424;margin-bottom: 0.2rem">*
                如果您是直单用户，请勾选下方按钮，如果不是请不要勾选！
              </div>
              <el-switch :disabled="flag==='2'||flag==='3'||flag==='4'" @change="chooseZhiDan" v-model="isZhiDan" class="zhidangc" active-text="是否是直单用户" style="margin-bottom: 0.2rem;" inactive-text="">
              </el-switch>
              <el-switch :disabled="flag==='2'||flag==='3'||flag==='4'" style="margin-left: 50px;margin-bottom: 0.2rem" v-if="isZhiDan&& agentType != '3'" class="zhidangc" @change="chooseGoverment" v-model="isGoverment" active-text="是否是政府企业/军工企业" inactive-text="">
              </el-switch>
              <span v-if="agentType != '3'">
                <!-- v-if="data.isExpandAuthorityBas != '' " -->
                <el-switch style="margin-left: 50px;margin-bottom: 0.2rem" v-model="isExpandAuthority" active-text="是否开通海外下单权限" :disabled="flag==='2'||flag==='3'||flag==='4'">
                </el-switch>
              </span>
              <span v-if="agentType != '3'">
                <el-switch style="margin-left: 50px;margin-bottom: 0.2rem" v-model="isFenxiao" active-text="是否分销商1.0" :disabled="flag==='2'||flag==='3'||flag==='4'" inactive-text=""></el-switch>
              </span>
              <!--              <span v-else>
                                <el-switch
                                        style="margin-left: 50px;margin-bottom: 0.2rem"
                                        v-model="isExpandAuthority"
                                        @change="chooseDomestic"
                                        active-text="是否开通国内下单权限"
                                        :disabled="this.flag==='2'||this.flag==='3'||this.flag==='4'">
                                </el-switch>
                            </span>-->
              <!--               <span>
                  <el-switch
                  v-if="this.agentType != '3'"
                  style="margin-left: 50px;margin-bottom: 0.2rem"
                  @change="chooseIsBlood"
                  v-model="isBlood"
                  active-text="是否血站专用渠道"
                  inactive-text=""></el-switch>
              </span>-->
            </div>
            <!-- 国内： {{this.data.isExpandAuthorityBas}}
            血站：{{this.data.isBloodBas}} -->
            <el-collapse v-model="activeNames">
              <el-collapse-item name="1" v-if="!isShangWei">
                <template slot="title" v-if="!isShangWei">
                  <div style="display: flex;align-items: center" @click.stop>
                    <span class="collapseTitle" style="color:#0e75e9">客户资质信息</span>
                  </div>
                </template>
                <div class="signsign" v-if="!isShangWei && isShowMassage">
                  <div class="h-formLine" style="margin-top:0.38rem">
                    <el-form :model="formLabelAlign1.bscUserInfoAgentBasic" label-position="right" ref="formLabelAlign1c" :inline="true" :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                      <el-form-item label="公司名称" class="h-elformWrap-2" prop="customerName1" required="">
                        <el-input :readonly="flag==='2'||flag==='3'||flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.customerName1" :title="formLabelAlign1.bscUserInfoAgentBasic.customerName1" :placeholder="flag==='2'||flag==='3'||flag==='4'?'':'请填写完整的公司全称'" oninput="value=value.trim()"   @change="getMdmAgent"></el-input>
                      </el-form-item>
                      <el-form-item label="客户编码" class="h-elformWrap-2" prop="usercode">
                        <el-input :readonly="flag==='2'||flag==='3'||flag==='4'|| (flag==='5' && !creatNewFlag)" v-model="formLabelAlign1.bscUserInfoAgentBasic.usercode" placeholder="请输入客户编码"></el-input>
                      </el-form-item>

                      <el-form-item label="客户" v-if="isExpandAuthority&&agentType == '3'||agentType != '3'" class="h-elformWrap-2" prop="scale">
                        <el-select :disabled="flag==='2'||flag==='3'||flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.scale" :class="{'ljjSelectdisabled':flag==='2'||flag==='3'||flag==='4'}" :placeholder="flag==='2'||flag==='3'||flag==='4'?'':'请选择'">
                          <el-option label="小规模经营者" value="0"></el-option>
                          <el-option label="一般纳税人" value="1"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="公司地址" required class="h-elformWrap-2" prop="companyAddress">
                        <el-input :readonly="flag==='2'||flag==='3'||flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.companyAddress" :title="formLabelAlign1.bscUserInfoAgentBasic.companyAddress" :placeholder="flag==='2'||flag==='3'||flag==='4'?'':'请填写详细的公司地址'"></el-input>
                      </el-form-item>
                      <el-form-item label="公司邮箱" class="h-elformWrap-2" prop="email">
                        <el-input :readonly="flag==='2'||flag==='3'||flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.email" :placeholder="flag==='2'||flag==='3'||flag==='4' ? '' : '请填写' " @change="getBackUserInfo"></el-input>
                      </el-form-item>
                      <span v-if="agentType != 3||agentType==3&&isExpandAuthority">
                    <el-form-item label="传真" class="h-elformWrap-2" prop="faxNumber">
                      <el-input :readonly="flag==='2'||flag==='3'||flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.faxNumber" :placeholder="flag==='2'||flag==='3'||flag==='4' ? '' : '请填写' "></el-input>
                    </el-form-item>
                    <el-form-item label="公司性质" class="h-elformWrap-2" :required="!bitian" v-if="isExpandAuthority&&agentType == '3'||agentType != '3'" prop="companytype">
                      <el-select :disabled="flag==='2'||flag==='3'||flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.companytype" placeholder="请选择">
                        <el-option label="体外诊断类" value="体外诊断类"></el-option>
                        <el-option label="实验室仪器类" value="实验室仪器类"></el-option>
                        <el-option label="实验室EPC类" value="实验室EPC类"></el-option>
                        <el-option label="医疗影像设备类" value="医疗影像设备类"></el-option>
                        <el-option label="试剂耗材" value="试剂耗材"></el-option>
                        <el-option label="医疗科研软件服务类" value="医疗科研软件服务类"></el-option>
                        <el-option label="社区卫生服务类" value="社区卫生服务类"></el-option>
                        <el-option label="其他" value="其他"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="成立时间" class="h-elformWrap-2" prop="founded">
                      <el-date-picker :disabled="flag==='2'||flag==='3'||flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.founded" type="date" :class="{'ljjSelectdisabled':flag==='2'||flag==='3'||flag==='4'}" :placeholder="flag==='2'||flag==='3'||flag==='4'?'':'选择日期'">
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item label="总经理姓名" class="h-elformWrap-2" prop="legal" :required="!bitian">
                      <el-input :readonly="flag==='2'||flag==='3'||flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.legal" :placeholder="flag==='2'||flag==='3'||flag==='4'?'':'请填写'"></el-input>
                    </el-form-item>
                    <el-form-item label="年度营业规模(万元)" class="h-elformWrap-2" prop="achievement" :required="!bitian">
                      <el-input :readonly="flag==='2'||flag==='3'||flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.achievement" :placeholder="flag==='2'||flag==='3'||flag==='4'?'':'请填写'"></el-input>
                    </el-form-item>
                    <el-form-item label="销售人员数量" class="h-elformWrap-2" prop="personnelNum" :required="!bitian">
                      <el-input :readonly="flag==='2'||flag==='3'||flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.personnelNum" :placeholder="flag==='2'||flag==='3'||flag==='4'?'':'请填写'"></el-input>
                    </el-form-item>
                    <el-form-item label="总经理联系方式" class="h-elformWrap-2" prop="legalPhone" :required="!bitian">
                      <el-input :readonly="flag==='2'||flag==='3'||flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.legalPhone" :placeholder="flag==='2'||flag==='3'||flag==='4'?'':'请填写'"></el-input>
                    </el-form-item>
                    <el-form-item label="经营其他品牌" class="h-elformWrap-2" prop="brand" :required="!bitian">
                      <el-input :readonly="flag==='2'||flag==='3'||flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.brand" :placeholder="flag==='2'||flag==='3'||flag==='4'?'':'请填写'"></el-input>
                    </el-form-item>
                  </span>

                      <el-form-item label="联系人" class="h-elformWrap-2" prop="name1" required>
                        <el-input :readonly="flag==='2'||flag==='3'||flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.name1" :placeholder="flag==='2'||flag==='3'||flag==='4'?'':'请填写'"></el-input>
                      </el-form-item>
                      <el-form-item label="联系人手机号" class="h-elformWrap-2" prop="contactMobilePhone" required>
                        <el-input :readonly="flag==='2'||flag==='3'||flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.contactMobilePhone" :placeholder="flag==='2'||flag==='3'||flag==='4'?'':'请填写'"></el-input>
                      </el-form-item>
                      <el-form-item label="所在国家" class="h-elformWrap-2" prop="country" required>
                        <brselectlazy category="YLCountry_agent" :showcode="true" :v="formLabelAlign1.bscUserInfoAgentBasic.country" v-model="formLabelAlign1.bscUserInfoAgentBasic.country" :clearable="true" :disabled="flag==='2'||flag==='3'||flag==='4'" />
                      </el-form-item>
                      <el-form-item label="所在地区" class="h-elformWrap-2" prop="region" required v-if="isShowMassage && agentType != '3'|| isExpandAuthority&&agentType == '3'">
                        <brselectlazy category="YLRegion" :v="formLabelAlign1.bscUserInfoAgentBasic.region" v-model="formLabelAlign1.bscUserInfoAgentBasic.region" :clearable="true" :disabled="flag==='2'||flag==='3'||flag==='4'" />
                      </el-form-item>
                      <el-form-item label="所在城市" class="h-elformWrap-2" prop="contactCity" required v-if="isShowMassage&& agentType != '3'|| isExpandAuthority&&agentType == '3'">
                        <el-select filterable :disabled="flag==='2'||flag==='3'||flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.contactCity" :class="{'ljjSelectdisabled':flag==='2'||flag==='3'||flag==='4'}" :placeholder="flag==='2'||flag==='3'||flag==='4'?'':'请选择'">
                          <el-option v-for="(item,index) in addli" :key="index" :label="item" :value="item">
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="关联公司" class="h-elformWrap-2" prop="associatedCompanyName" v-if="flag==='3'|| radio == '海外客户' || isExpandAuthority == '1'">
                        <el-select v-model="formLabelAlign1.bscUserInfoAgentBasic.associatedCompanyName" :title="formLabelAlign1.bscUserInfoAgentBasic.associatedCompanyName" remote
                                   filterable :readonly="flag==='3'|| radio == '海外客户' || isExpandAuthority == '1'" :filter-method="showAssociationAgent" clearable placeholder="请输入" :disabled="flag==='3'|| radio == '海外客户' || isExpandAuthority == '1'" :remote-method="showAssociationAgent" @change="changeAssociationAgent($event)">
                          <el-option v-for="(item) in associatedCompanyList" :key="item.username" :label="item.username" :value="item">
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="关联公司编码" class="h-elformWrap-2" prop="associatedCompanyCode" v-if="flag==='3'|| radio == '海外客户' || isExpandAuthority == '1'">
                        <el-input :readonly="flag==='3' || radio == '海外客户' || isExpandAuthority == '1'" v-model="formLabelAlign1.bscUserInfoAgentBasic.associatedCompanyCode" disabled></el-input>
                      </el-form-item>
                      <!-- v-if="agentType == '3'" -->
                      <!-- <el-form-item v-if="this.agentType == '3' || this.isExpandAuthority ==true " label="是否国内贸易公司" class="h-elformWrap-2" prop="isTrade" >
                          <brselectlazy category="shifou_keyong"  @input="changeTrade"
                                          :v="formLabelAlign1.bscUserInfoAgentBasic.isTrade"
                                          v-model="formLabelAlign1.bscUserInfoAgentBasic.isTrade"
                                          :clearable="true"
                                          :disabled="this.flag==='2'||this.flag==='3'||this.flag==='4'"/>
                      </el-form-item> -->
                      <el-form-item label="备注" v-if="agentType == '3' || data.isExpandAuthorityBas == '1' " class="h-elformWrap-2">
                        <el-input :readonly="flag==='2'||flag==='3'||flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.remark" :placeholder="flag==='2'||flag==='3'||flag==='4'?'':'请填写'" :clearable="true"></el-input>
                      </el-form-item>

                    </el-form>
                  </div>
                </div>
                <!--                        海外客户-->
                <div class="signsign" v-if="!isShowMassage">
                  <div class="h-formLine" style="margin-top:0.38rem">
                    <el-form :model="formLabelAlign1.bscUserInfoAgentBasic" label-position="right" ref="formLabelAlign1c" :inline="true" :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                      <el-form-item label="公司名称" class="h-elformWrap-2" prop="customerName1">
                        <el-input :readonly="flag==='2'||flag==='3'||flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.customerName1" :title="formLabelAlign1.bscUserInfoAgentBasic.customerName1" :placeholder="flag==='2'||flag==='3'||flag==='4'?'':'请填写完整的公司全称'" oninput="value=value.trim()"></el-input>
                      </el-form-item>

                      <el-form-item label="客户" v-if="agentType == '3'&&isShowByHw" class="h-elformWrap-2" prop="scale">
                        <el-select :disabled="flag==='2'||flag==='3'||flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.scale" :class="{'ljjSelectdisabled':flag==='2'||flag==='3'||flag==='4'}" :placeholder="flag==='2'||flag==='3'||flag==='4'?'':'请选择'">
                          <el-option label="小规模经营者" value="0"></el-option>
                          <el-option label="一般纳税人" value="1"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="公司性质" v-if="agentType == '3'&&isShowByHw" class="h-elformWrap-2" prop="companytype">
                        <el-input :readonly="flag==='2'||flag==='3'||flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.companytype" :placeholder="flag==='2'||flag==='3'||flag==='4'?'':'请填写'"></el-input>
                      </el-form-item>
                      <el-form-item label="所在国家" class="h-elformWrap-2" prop="country">
                        <brselectlazy :showcode="true" category="YLCountry_agent" :v="formLabelAlign1.bscUserInfoAgentBasic.country" v-model="formLabelAlign1.bscUserInfoAgentBasic.country" :clearable="true" :disabled="flag==='2'||flag==='3'||flag==='4'" />
                      </el-form-item>
                      <el-form-item label="所在地区" class="h-elformWrap-2" prop="region" v-if="agentType == '3'&&isShowByHw">
                        <brselectlazy category="YLRegion" :v="formLabelAlign1.bscUserInfoAgentBasic.region" v-model="formLabelAlign1.bscUserInfoAgentBasic.region" :clearable="true" :disabled="flag==='2'||flag==='3'||flag==='4'" />
                      </el-form-item>
                      <el-form-item label="所在城市" class="h-elformWrap-2" prop="contactCity" v-if="agentType == '3'&&isShowByHw">
                        <el-select filterable :disabled="flag==='2'||flag==='3'||flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.contactCity" :class="{'ljjSelectdisabled':flag==='2'||flag==='3'||flag==='4'}" :placeholder="flag==='2'||flag==='3'||flag==='4'?'':'请选择'">
                          <el-option v-for="(item,index) in addli" :key="index" :label="item" :value="item">
                          </el-option>
                        </el-select>
                      </el-form-item>

                      <el-form-item label="公司地址" class="h-elformWrap-2" prop="companyAddress">
                        <el-input :readonly="flag==='2'||flag==='3'||flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.companyAddress" :title="formLabelAlign1.bscUserInfoAgentBasic.companyAddress" :placeholder="flag==='2'||flag==='3'||flag==='4'?'':'请填写详细的公司地址'"></el-input>
                      </el-form-item>
                      <!-- <el-form-item label="是否国内贸易公司" class="h-elformWrap-2" prop="isTrade">
                          <brselectlazy category="shifou_keyong"  @input="changeTrade"
                                          :v="formLabelAlign1.bscUserInfoAgentBasic.isTrade"
                                          v-model="formLabelAlign1.bscUserInfoAgentBasic.isTrade"
                                          :clearable="true"
                                          :disabled="this.flag==='2'||this.flag==='3'||this.flag==='4'"/>
                      </el-form-item> -->
                      <el-form-item label="联系人" class="h-elformWrap-2" prop="name1">
                        <el-input :readonly="flag==='2'||flag==='3'||flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.name1" :placeholder="flag==='2'||flag==='3'||flag==='4'?'':'请填写'"></el-input>
                      </el-form-item>
                      <el-form-item label="联系人手机号" class="h-elformWrap-2" prop="contactMobilePhone">
                        <el-input :readonly="flag==='2'||flag==='3'||flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.contactMobilePhone" :placeholder="flag==='2'||flag==='3'||flag==='4'?'':'请填写'"></el-input>
                      </el-form-item>
                      <el-form-item label="公司邮箱" class="h-elformWrap-2" prop="email">
                        <el-input :readonly="flag==='2'||flag==='3'||flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.email" :placeholder="flag==='2'||flag==='3'||flag==='4' ? '' : '请填写' "></el-input>
                      </el-form-item>
                      <el-form-item label="关联公司" class="h-elformWrap-2" prop="associatedCompanyName">
                        <el-select v-model="formLabelAlign1.bscUserInfoAgentBasic.associatedCompanyName" :title="formLabelAlign1.bscUserInfoAgentBasic.associatedCompanyName" remote filterable :readonly="flag==='3'" :filter-method="showAssociationAgent" clearable placeholder="请输入" :remote-method="showAssociationAgent" @change="changeAssociationAgent($event)">
                          <el-option v-for="(item) in associatedCompanyList" :key="item.username" :label="item.username" :value="item">
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="关联公司编码" class="h-elformWrap-2" prop="associatedCompanyCode">
                        <el-input :readonly="flag==='3'" v-model="formLabelAlign1.bscUserInfoAgentBasic.associatedCompanyCode" disabled></el-input>
                      </el-form-item>
                      <el-form-item label="备注" v-if="agentType == '3'" class="h-elformWrap-2">
                        <el-input :readonly="flag==='2'||flag==='3'||flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.remark" :placeholder="flag==='2'||flag==='3'||flag==='4'?'':'请填写'" :clearable="true"></el-input>
                      </el-form-item>
                      <el-form-item label="客户" v-if="agentType != '3'" class="h-elformWrap-2" prop="scale">
                        <el-select :disabled="flag==='2'||flag==='3'||flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.scale" :class="{'ljjSelectdisabled':flag==='2'||flag==='3'||flag==='4'}" :placeholder="flag==='2'||flag==='3'||flag==='4'?'':'请选择'">
                          <el-option label="小规模经营者" value="0"></el-option>
                          <el-option label="一般纳税人" value="1"></el-option>
                        </el-select>
                      </el-form-item>

                      <el-form-item label="成立时间" class="h-elformWrap-2" prop="founded" :required="!bitian" v-if="isShowByHw">
                        <el-date-picker :disabled="flag==='2'||flag==='3'||flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.founded" type="date" :class="{'ljjSelectdisabled':flag==='2'||flag==='3'||flag==='4'}" :placeholder="flag==='2'||flag==='3'||flag==='4'?'':'选择日期'">
                        </el-date-picker>
                      </el-form-item>
                      <el-form-item label="法人代表" class="h-elformWrap-2" prop="legal" v-if="isShowByHw">
                        <el-input :readonly="flag==='2'||flag==='3'||flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.legal" :placeholder="flag==='2'||flag==='3'||flag==='4'?'':'请填写'"></el-input>
                      </el-form-item>
                      <el-form-item label="年度营业规模(万元)" class="h-elformWrap-2" prop="achievement" v-if="isShowByHw">
                        <el-input :readonly="flag==='2'||flag==='3'||flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.achievement" :placeholder="flag==='2'||flag==='3'||flag==='4'?'':'请填写'"></el-input>
                      </el-form-item>
                    </el-form>
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item name="2" v-if="!isFenxiao2">
                <template slot="title">
                  <div style="display: flex;align-items: center" @click.stop>
                    <span class="collapseTitle" style="color:#0e75e9">开票信息</span>
                    <span style="font-size: 14px;color: #a8a8a8;margin-left:19px;font-weight: normal;">凡是贵公司相关信息的变更请及时通知，以便及时调整，保证开票信息无误</span>
                  </div>
                </template>
                <div class="signsign">
                  <div class="h-formLine" style="margin-top:0.38rem">
                    <el-form :model="formLabelAlign1.bscUserInfoAgentBasic" label-position="right" ref="formLabelAlign1d" :inline="true" :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                      <el-form-item label="客户名称" required class="h-elformWrap-2" prop="customerName1" v-if=" agentType != '3'" :class="{'gccolor':userName1}">
                        <el-input :readonly="flag==='2'||flag==='3'||flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.customerName1" :title="formLabelAlign1.bscUserInfoAgentBasic.customerName1" :placeholder="flag==='2'||flag==='3'||flag==='4'?'':'请填写'"></el-input>
                      </el-form-item>
                      <el-form-item label="开票电话" class="h-elformWrap-2" prop="phoneNumber" required :class="{'gccolor':phoneNumber}">
                        <el-input :readonly="flag==='2'||flag==='3'||flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.phoneNumber" :placeholder="flag==='2'||flag==='3'||flag==='4'?'':'请填写'">
                        </el-input>
                      </el-form-item>
                      <el-form-item label="开票地址" class="h-elformWrap-2" prop="cityStreetRoom" required :class="{'gccolor':cityStreetRoom}">
                        <el-input clearable :readonly="flag==='2'||flag==='3'||flag==='4'" :title="formLabelAlign1.bscUserInfoAgentBasic.cityStreetRoom" v-model="formLabelAlign1.bscUserInfoAgentBasic.cityStreetRoom" :placeholder="flag==='2'||flag==='3'||flag==='4'?'':'请填写'">
                        </el-input>
                      </el-form-item>
                      <el-form-item label="纳税人登记号" class="h-elformWrap-2" prop="taxCode" v-if="agentType!=3 ||agentType==3" :class="{'gccolor':taxCode}" :required="isShowByHw">
                        <el-input :readonly="flag==='2'||flag==='3'||flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBasic.taxCode" :placeholder="flag==='2'||flag==='3'||flag==='4'?'':'请填写'" oninput="value=value.replace(/[^a-zA-Z0-9]/g, '')">
                        </el-input>
                      </el-form-item>
                    </el-form>
                    <el-form :model="formLabelAlign1.bscUserInfoAgentBank" label-position="right" ref="formLabelAlign1e" v-if="agentType != 3||agentType==3" :inline="true" :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">

                      <!--                                    <el-form-item-->
                      <!--                                            :class="{'gccolor':bankBranchCode}"-->
                      <!--                                            label="银行编号"-->
                      <!--                                            v-if="isShowByHw &&  agentType != '3' && formLabelAlign1.bscUserInfoAgentBasic.country!='CN'"-->
                      <!--                                            class="h-elformWrap-2">-->
                      <!--                                        <el-input :readonly="this.flag==='2'||this.flag==='3'||this.flag==='4'"-->
                      <!--                                                  v-model="formLabelAlign1.bscUserInfoAgentBank.bankBranchCode"-->
                      <!--												  :placeholder="this.flag==='2'||this.flag==='3'||this.flag==='4'?'':'请填写'"-->
                      <!--                                                  ></el-input>-->
                      <!--                                    </el-form-item>-->
                      <el-form-item :class="{'gccolor':bankName}" label="银行名称" :required="isShowByHw && !bitian" class="h-elformWrap-2" prop="bankName">
                        <el-select v-model="formLabelAlign1.bscUserInfoAgentBank.bankName" :title="formLabelAlign1.bscUserInfoAgentBank.bankName" remote filterable :readonly="flag==='2'||flag==='3'||flag==='4'" :filter-method="getBackCodeSupply" clearable placeholder="请填写" :remote-method="getBackCodeSupply" @change="changeBackCodeSupply($event)" @clear="clearBackCode">
                          <el-option v-for="(item) in bankList" :key="item.bankBranchCode" :label="item.bankName" :value="item.bankBranchCode">
                          </el-option>
                        </el-select>
                        <!-- <el-input :readonly="flag==='2'||flag==='3'||flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBank.bankName" :title="formLabelAlign1.bscUserInfoAgentBank.bankName" :placeholder="flag==='2'||flag==='3'||flag==='4'?'':'请填写'" @change="getBackCodeSupply()"></el-input> -->
                      </el-form-item>
                      <el-form-item :class="{'gccolor':bankBranchCode}" label="银行编号" :required="isShowByHw && !bitian" class="h-elformWrap-2" prop="bankBranchCode">
                        <el-input :readonly="flag==='2'||flag==='3'||flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBank.bankBranchCode" :placeholder="flag==='2'||flag==='3'||flag==='4'?'':'自带出'" disabled></el-input>
                      </el-form-item>
                      <!--                                    <el-form-item-->
                      <!--                                            :class="{'gccolor':bankName}"-->
                      <!--                                            label="银行名称"-->
                      <!--                                            v-if="isShowByHw && formLabelAlign1.bscUserInfoAgentBasic.country!='CN'"-->
                      <!--                                            class="h-elformWrap-2">-->
                      <!--                                        <el-input :readonly="this.flag==='2'||this.flag==='3'||this.flag==='4'"-->
                      <!--                                                  v-model="formLabelAlign1.bscUserInfoAgentBank.bankName"-->
                      <!--												  :title="formLabelAlign1.bscUserInfoAgentBank.bankName"-->
                      <!--												  :placeholder="this.flag==='2'||this.flag==='3'||this.flag==='4'?'':'请填写'"-->
                      <!--                                                  ></el-input>-->
                      <!--                                    </el-form-item>-->
                      <el-form-item label="银行账户号" class="h-elformWrap-2" :class="{'gccolor':accountHolderName}" prop="accountHolderName" :required="isShowByHw && !bitian">
                        <el-input :readonly="flag==='2'||flag==='3'||flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentBank.accountHolderName" :placeholder="flag==='2'||flag==='3'||flag==='4'?'':'请填写'" onkeyup="if(value.length==1){value=value.replace(/[^1-9]/g,'')}else{value=value.replace(/\D/g,'')}">
                        </el-input>
                      </el-form-item>
                      <!--                                    <el-form-item label="银行账户号" class="h-elformWrap-2" :class="{'gccolor':accountHolderName}"-->
                      <!--                                                  v-if="isShowByHw && formLabelAlign1.bscUserInfoAgentBasic.country!='CN'">-->
                      <!--                                        &lt;!&ndash;                                        prop="accountHolderName"&ndash;&gt;-->
                      <!--                                        <el-input :readonly="flag==='2'||flag==='3'||flag==='4'"-->
                      <!--                                                  v-model="formLabelAlign1.bscUserInfoAgentBank.accountHolderName"-->
                      <!--                                                  onkeyup="if(value.length==1){value=value.replace(/[^1-9]/g,'')}else{value=value.replace(/\D/g,'')}"-->
                      <!--												  :placeholder="flag==='2'||flag==='3'||flag==='4'?'':'请填写'"-->
                      <!--                                                  ></el-input>-->
                      <!--                                    </el-form-item>-->
                      <el-form-item label="银行所属国家" class="h-elformWrap-2" :class="{'gccolor':bankCountry}" :required="isShowByHw && !bitian" prop="bankCountry">
                        <brselectlazy category="YLCountry_agent" :v="formLabelAlign1.bscUserInfoAgentBank.bankCountry" v-model="formLabelAlign1.bscUserInfoAgentBank.bankCountry" :clearable="true" :disabled="flag==='2'||flag==='3'||flag==='4'" />
                      </el-form-item>
                      <!--                                    <el-form-item label="银行所属国家" class="h-elformWrap-2" :class="{'gccolor':bankCountry}"-->
                      <!--                                                   v-if="isShowByHw && formLabelAlign1.bscUserInfoAgentBasic.country!='CN'">-->
                      <!--                                        <brselectlazy category="YLCountry_agent"-->
                      <!--                                                      :v="formLabelAlign1.bscUserInfoAgentBank.bankCountry"-->
                      <!--                                                      v-model="formLabelAlign1.bscUserInfoAgentBank.bankCountry"-->
                      <!--                                                      :clearable="true"-->
                      <!--                                                      :disabled="flag==='2'||this.flag==='3'||this.flag==='4'"/>-->
                      <!--                                    </el-form-item>-->
                    </el-form>
                    <el-form :model="formLabelAlign1.bscUserInfoAgentSell" label-position="right" ref="formLabelAlign1f" :inline="true" :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                      <el-form-item label="发票类型" class="h-elformWrap-2" prop="customerGroup1" :required="this.isShowByHw" v-if="agentType!=3||agentType==3" :class="{'gccolor':customerGroup1}">
                        <el-select :disabled="flag==='2'||flag==='3'||flag==='4'" :placeholder="flag==='2'||flag==='3'||flag==='4'?'':'请选择'" :class="{'ljjSelectdisabled':flag==='2'||flag==='3'||flag==='4'}" v-model="formLabelAlign1.bscUserInfoAgentSell.customerGroup1">
                          <el-option label="增值税发票" value="01"></el-option>
                          <el-option label="普通发票" value="02"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="国际贸易条件" class="h-elformWrap-2" prop="intCommercialTerms" v-if="!isShowMassage || radio == '海外客户' || isExpandAuthority == '1'  ">
                        <brselectlazy category="YlCommercialTerms" :showcode="true" :v="formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms" v-model="formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms" :clearable="true" :disabled="flag==='2'||flag==='3'||flag==='4'" />
                      </el-form-item>
                      <el-form-item label="国际贸易条件2" class="h-elformWrap-2" prop="intCommercialTerms2" v-if="!isShowMassage || radio == '海外客户' || isExpandAuthority == '1'">
                        <brselectlazy category="YlCommercialTerms" :showcode="true" :v="formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms2" v-model="formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms2" :clearable="true" :disabled="flag==='2'||flag==='3'||flag==='4'" />
                      </el-form-item>
                      <el-form-item label="货币种类" required class="h-elformWrap-2" prop="currencyCode">
                        <brselectlazy category="YLCurrency" :v="formLabelAlign1.bscUserInfoAgentSell.currencyCode" v-model="formLabelAlign1.bscUserInfoAgentSell.currencyCode" :clearable="true" :disabled="flag==='2'||flag==='3'||flag==='4'" />
                      </el-form-item>
                      <el-form-item label="电票邮箱" class="h-elformWrap-2" :class="{'gccolor':accountHolderName}" prop="inEmail">
                        <el-input :readonly="flag==='2'||flag==='3'||flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentSell.inEmail" :placeholder="flag==='2'||flag==='3'||flag==='4'?'':'请填写'">
                        </el-input>
                      </el-form-item>
                      <div class="h-formLine Yangbiao">
                        <el-form-item label="开票信息" class="h-elformWrap-3" prop="invInformation" v-if="!isShowMassage || radio == '海外客户' || isExpandAuthority == '1'">
                          <el-input :disabled="flag==='2'||flag==='3'||flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentSell.invInformation" :placeholder="flag==='2'||flag==='3'||flag==='4'?'':'请填写'" type="textarea" :rows="4" show-word-limit maxlength="500">
                          </el-input>
                        </el-form-item>
                      </div>

                    </el-form>
                  </div>
                </div>
              </el-collapse-item>
              <!--邮寄发票信息暂时注释-->
<!--              <el-collapse-item name="3" v-if="!isFenxiao2&&isShowByHw&&agentType!=3||agentType==3&&isExpandAuthority?true:false">-->
<!--                <template slot="title">-->
<!--                  <div style="display: flex;align-items: center" @click.stop>-->
<!--                    <span class="collapseTitle" style="color:#0e75e9">邮寄发票信息</span>-->
<!--                  </div>-->
<!--                </template>-->
<!--                <div class="signsign">-->
<!--                  <div class="h-formLine" style="margin-top:0.38rem">-->
<!--                    <el-form :model="formLabelAlign1.bscUserInfoAgentCompany" label-position="right" ref="formLabelAlign1h" :inline="true" :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">-->
<!--                      <el-form-item label="邮寄接收人" class="h-elformWrap-2" prop="mailreceiver" :class="{'gccolor':mailreceiver}">-->
<!--                        <el-input :readonly="flag==='2'||this.flag==='3'||this.flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentCompany.mailreceiver" :placeholder="this.flag==='2'||this.flag==='3'||this.flag==='4'?'':'请填写'"></el-input>-->
<!--                      </el-form-item>-->
<!--                      <el-form-item label="电话" class="h-elformWrap-2" prop="receiverphone" :class="{'gccolor':receiverphone}">-->
<!--                        <el-input :readonly="this.flag==='2'||this.flag==='3'||this.flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentCompany.receiverphone" :placeholder="this.flag==='2'||this.flag==='3'||this.flag==='4'?'':'请填写'"></el-input>-->
<!--                      </el-form-item>-->
<!--                      &lt;!&ndash;                                    <el-form-item label="邮寄地址" class="h-elformWrap-2" prop="mailaddress">&ndash;&gt;-->
<!--                      &lt;!&ndash;                                        <el-input :readonly="this.flag==='2'||this.flag==='3'||this.flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentCompany.mailaddress"&ndash;&gt;-->
<!--                      &lt;!&ndash;                                                  placeholder="请填写"></el-input>&ndash;&gt;-->
<!--                      <el-form-item label="选择邮寄地址" class="h-elformWrap-2" prop="mailaddress" :class="{'gccolor':mailaddress}">-->
<!--                        <el-input clearable :readonly="this.flag==='2'||this.flag==='3'||this.flag==='4'" :title="formLabelAlign1.bscUserInfoAgentCompany.mailaddress" v-model="formLabelAlign1.bscUserInfoAgentCompany.mailaddress">-->
<!--                          <i v-show="this.flag!=='2'&&this.flag!=='3'&&this.flag!=='4'" class="el-icon-edit el-input__icon" slot="suffix" @click="handleIconClick">-->
<!--                          </i>-->
<!--                        </el-input>-->
<!--                      </el-form-item>-->
<!--                    </el-form>-->

<!--                  </div>-->
<!--                </div>-->
<!--              </el-collapse-item>-->
              <el-collapse-item name="4" v-if="!isShangWei && !isFenxiao2">
                <template slot="title">
                  <div style="display: flex;align-items: center" @click.stop>
                    <span class="collapseTitle" style="color:#0e75e9">上传附件</span>
                  </div>
                </template>
                <div class="h-formLine weekplandetail10">
                  <el-form :model="formLabelAlign1.bscUserInfoAgentBasic" label-position="right" ref="formLabelAlign1i" :inline="true" :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                    <el-form-item label="企业营业执照" class="h-elformWrap-2" prop="upload1" :required="!bitian" v-if="agentType != '3' || (agentType == '3' && isExpandAuthority)">
                      <brupload v-model="formLabelAlign1.bscUserInfoAgentBasic.upload1" v-if="fileShowFlag" :refid="refid" reftype="代理商注册-企业营业执照" :uploadflag="uploadflag" :delflag="delflag" @filecallback="fileBack5" :showtime="false">
                      </brupload>
                    </el-form-item>
                    <el-form-item label="企业营业执照有效截止日期" class="h-elformWrap-2" prop="yyzzEffectiveDate" :required="!bitian" v-if="agentType != '3' || (agentType == '3' && isExpandAuthority)">
                      <el-date-picker style="width: 180px" v-if="fileShowFlag" :disabled="flag==='2'||flag==='3'||flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentSell.yyzzEffectiveDate" type="date" placeholder="选择日期">
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item label="银行开户证明" class="h-elformWrap-2" prop="upload2" :required="!bitian" v-if="agentType != '3' || (agentType == '3' && isExpandAuthority)">
                      <brupload v-model="formLabelAlign1.bscUserInfoAgentBasic.upload2" v-if="fileShowFlag" :refid="refid" reftype="代理商注册-银行开户证明" :uploadflag="uploadflag" :delflag="delflag" @filecallback="fileBack6" :showtime="false">
                      </brupload>
                    </el-form-item>
                    <el-form-item label="法人身份证" class="h-elformWrap-2" prop="upload3" key="upload3" :required="!bitian" v-if="agentType != '3' || (agentType == '3' && isExpandAuthority)">
                      <brupload v-model="formLabelAlign1.bscUserInfoAgentBasic.upload3" v-if="fileShowFlag" :refid="refid" reftype="代理商注册-法人身份证" :uploadflag="uploadflag" :delflag="delflag" @filecallback="fileBack7" :showtime="false">
                      </brupload>
                    </el-form-item>
                    <el-form-item label="一般纳税人提供相关资质证明" class="h-elformWrap-2" prop="upload" v-if="agentType != '3' || (agentType == '3' && isExpandAuthority)">
                      <brupload v-if="fileShowFlag" :refid="refid" reftype="代理商注册-一般纳税人提供相关资质证明" :uploadflag="uploadflag" :delflag="delflag" :showtime="false">
                      </brupload>
                    </el-form-item>

                    <el-form-item label="名称修改见证性资料" class="h-elformWrap-2" prop="upload" v-if="agentType != '3' || (agentType == '3' && isExpandAuthority)">
                      <brupload v-if="fileShowFlag" :refid="refid" reftype="代理商修改名称-见证性资料" :uploadflag="uploadflag" :delflag="delflag" :showtime="false">
                      </brupload>
                    </el-form-item>
                    <el-form-item label="发票类型见证性资料" class="h-elformWrap-2" prop="upload" v-if="agentType != '3' || (agentType == '3' && isExpandAuthority)">
                      <brupload v-if="fileShowFlag" :refid="refid" reftype="代理商修改发票-见证性资料" :uploadflag="uploadflag" :delflag="delflag" :showtime="false">
                      </brupload>
                    </el-form-item>

                    <!-- <div style="margin-left:2.1rem;margin-bottom: 0.5rem;"> -->
                    <!--                                    <el-switch-->
                    <!--                                            :disabled="flag==='2'||flag==='3'||flag==='4'"-->
                    <!--                                            v-model="have2"-->
                    <!--                                            active-text=""-->
                    <!--                                            inactive-text="是否有备案表">-->
                    <!--                                    </el-switch>-->
                    <!-- </div> -->
                    <el-form-item label="备案表" class="h-elformWrap-2" prop="upload5" :required="!bitian" v-if="have2 && (agentType != '3' || (agentType == '3' && isExpandAuthority))">
                      <brupload v-model="formLabelAlign1.bscUserInfoAgentBasic.upload5" v-if="fileShowFlag" :refid="refid" reftype="代理商注册-二类经营许可证" :uploadflag="uploadflag" :delflag="delflag" :showtime="false">
                      </brupload>
                    </el-form-item>
                    <el-form-item style="padding-right:0;width: 100%!important;" label="" class="HAVES-2 h-elformWrap-2" v-if="have2 && (agentType != '3' || (agentType == '3' && isExpandAuthority))">
                      <el-switch :disabled="flag==='2'||flag==='3'||flag==='4'" style="margin-left: 0.4rem;" v-model="havepolicy2017" active-text="" inactive-text="是否包含2017版分类目录">
                      </el-switch>
                      <el-switch :disabled="flag==='2'||flag==='3'||flag==='4'" style="margin-left: 0.3rem;" v-model="have1101" v-if="formLabelAlign1.bscUserInfoAgentSell.havepolicy2017 == 1" active-text="" inactive-text="是否包含11-01">
                      </el-switch>
                      <el-switch :disabled="flag==='2'||flag==='3'||flag==='4'" style="margin-left: 0.3rem;" v-model="have2214" v-if="formLabelAlign1.bscUserInfoAgentSell.havepolicy2017 == 1" active-text="" inactive-text="是否包含22-14">
                      </el-switch>
                      <el-switch :disabled="flag==='2'||flag==='3'||flag==='4'" style="margin-left: 0.3rem;" v-model="have2215" v-if="formLabelAlign1.bscUserInfoAgentSell.havepolicy2017 == 1" active-text="" inactive-text="是否包含22-15">
                      </el-switch>
                      <el-switch :disabled="flag==='2'||flag==='3'||flag==='4'" style="margin-left: 1rem;" v-model="have2216" v-if="formLabelAlign1.bscUserInfoAgentSell.havepolicy2017 == 1" active-text="" inactive-text="是否包含22-16">
                      </el-switch>
                    </el-form-item>
                    <el-form-item style="padding-right:0;width: 50%!important;" label="" class="HAVES-2 h-elformWrap-2" v-if="agentType != '3' || (agentType == '3' && isExpandAuthority)">
                      <el-switch :disabled="flag==='2'||flag==='3'||flag==='4'" style="margin-left: 0.3rem;"
                                 v-model="have6858" active-text="" inactive-text="是否包含6858" v-if="have2">
                      </el-switch>
                      <el-switch :disabled="flag==='2'||flag==='3'||flag==='4'" style="margin-left: 0.3rem;"
                                 v-model="have6840" active-text="" inactive-text="是否包含6840" v-if="have2">
                      </el-switch>
                      <el-switch :disabled="flag==='2'||flag==='3'||flag==='4'" style="margin-left: 0.5rem;"
                                 v-model="have6854" active-text="" inactive-text="是否包含6854" >
                      </el-switch>
                    </el-form-item>
                    <!--  补充  包含III类6840(体外诊断试剂 -->
                    <el-form-item class="h-elformWrap-5" v-if="agentType != '3' || (agentType == '3' && isExpandAuthority)">
                      <el-switch v-if="agentType != '3' || (agentType == '3' && isExpandAuthority)" style="margin-left: -0.5rem;" :disabled="flag==='2'||flag==='3'||flag==='4'" v-model="have3" active-text="" inactive-text="是否有许可证">
                      </el-switch>
                      <el-switch :disabled="flag==='2'||flag==='3'||flag==='4'" style="margin-left: 0.3rem;" v-model="haveThree6840" @change="chooseIVD" inactive-text="是否包含III类6840(体外诊断试剂)">
                      </el-switch>
                    </el-form-item>
                    <el-form-item label="许可证" class="h-elformWrap-2" prop="upload6" :required="!bitian" v-if="have3 && (agentType != '3' || (agentType == '3' && isExpandAuthority))">
                      <div style="display: flex;align-items: center;">
                        <brupload v-model="formLabelAlign1.bscUserInfoAgentBasic.upload6" v-if="fileShowFlag" :refid="refid" reftype="代理商注册-三类经营许可证" :uploadflag="uploadflag" :delflag="delflag" :showtime="false" @filecallback="fileBack2">
                        </brupload>
                      </div>
                    </el-form-item>
                    <el-form-item label="许可证有效截止日期" class="h-elformWrap-2" prop="xkzEffectiveDate" :required="!bitian" v-show="have3&& (agentType != '3' || (agentType == '3' && isExpandAuthority))">
                      <el-date-picker style="width: 180px" :disabled="flag==='2'||flag==='3'||flag==='4'" v-model="formLabelAlign1.bscUserInfoAgentSell.xkzEffectiveDate" type="date" placeholder="选择日期">
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item label="三类经营许可证" class="h-elformWrap-2" :required="!bitian" v-if="(haveThree6840 == 1 ||haveThree6840)&&(agentType != '3' || (agentType == '3' && isExpandAuthority))  " :prop="haveThree6840? 'upload8': '' ">
                      <brupload v-model="formLabelAlign1.bscUserInfoAgentBasic.upload8" v-if="fileShowFlag" :refid="refid" reftype="三类6840经营许可证" :uploadflag="uploadflag" :delflag="delflag" @filecallback="fileBack3" :showtime="false">
                      </brupload>
                    </el-form-item>
                  </el-form>
                  <el-form :model="formLabelAlign1.bscUserInfoAgentBasic" label-position="right" ref="formLabelAlign1w" :inline="true" :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                    <el-form-item label="委托汇款的附件" class="h-elformWrap-2" prop="upload7" v-if="agentType == '3'||agentType != '3'&&isExpandAuthority">
                      <brupload v-model="formLabelAlign1.bscUserInfoAgentBasic.upload5" v-if="fileShowFlag" :refid="refid" reftype="代理商注册-委托汇款的附件" :uploadflag="uploadflag" :delflag="delflag" @filecallback="fileBack1" :showtime="false">
                      </brupload>
                    </el-form-item>
                  </el-form>
                  <el-form :model="formLabelAlign1.bscUserInfoAgentSell" label-position="right" ref="formLabelAlign1i" :inline="true" :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1" v-if="agentType != '3' || (agentType == '3' && isExpandAuthority)">
                    <el-form-item label="许可证号" class="h-elformWrap-2" v-if="haveThree6840 == 1" :prop="haveThree6840? 'licenseNumber': '' ">
                      <el-input v-model="formLabelAlign1.bscUserInfoAgentSell.licenseNumber" placeholder="请输入许可证号" style="width: 100%"/>
                    </el-form-item>
                  </el-form>
                </div>
              </el-collapse-item>
              <el-collapse-item name="5" v-if="isShangWei">
                <template slot="title">
                  <div style="display: flex;align-items: center" @click.stop>
                    <span class="collapseTitle" style="color:#0e75e9">上传附件</span>
                  </div>
                </template>
                <div class="h-formLine weekplandetail10">
                  <el-form :model="formLabelAlign1.bscUserInfoAgentBasic" label-position="right" ref="formLabelAlign1i" :inline="true" :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                    <el-form-item label="名称修改见证性资料" class="h-elformWrap-2" prop="upload">
                      <brupload :refid="refid" reftype="代理商修改名称-见证性资料" :uploadflag="uploadflag" :delflag="delflag" :showtime="false">
                      </brupload>
                    </el-form-item>
                    <el-form-item label="发票类型见证性资料" class="h-elformWrap-2" prop="upload">
                      <brupload :refid="refid" reftype="代理商修改发票-见证性资料" :uploadflag="uploadflag" :delflag="delflag" :showtime="false">
                      </brupload>
                    </el-form-item>
                  </el-form>
                </div>
              </el-collapse-item>
              <el-collapse-item name="6" v-if="quyuflag && (formLabelAlign1.bscUserInfoAgentBasic.agentLevel == '1' || formLabelAlign1.bscUserInfoAgentBasic.agentLevel == '3'
               || formLabelAlign1.bscUserInfoAgentBasic.agentLevel == '5' || formLabelAlign1.bscUserInfoAgentBasic.agentLevel == '6')">
                <template slot="title" v-if="flag==='2'||flag==='3'||flag==='4' || agentType == '3' || agentType == '1' || agentType == '5' || agentType == '6'">
                  <div style="display: flex;align-items: center" @click.stop>
                    <span class="collapseTitle" style="color:#0e75e9">引入评估</span>
                  </div>
                </template>
                <el-button class="h-btn h-bBtn h-bgblueQ2" style="margin-left: 0.1rem;" @click="pinggu">
                  引入评估
                </el-button>
              </el-collapse-item>
              <el-collapse-item name="7"   v-if="(!isShangWei || creatNewFlag  || creatAgent || agentType == '3' || agentType == '1') &&
                                 (flag==='2' || creatAgent|| creatNewFlag ||flag==='3'||flag==='4' || agentType == '3' || agentType == '1')">
                  <template slot="title" v-if="flag==='2' || creatAgent|| creatNewFlag ||flag==='3'||flag==='4' || agentType == '3' || agentType == '1'">
                    <div style="display: flex;align-items: center" @click.stop>
                      <span class="collapseTitle" style="color:#0e75e9">资质审核</span>
                    </div>
                  </template>
                  <div class="signsign" v-if="flag==='2' || creatAgent|| creatNewFlag ||flag==='3'||flag==='4' || agentType == '3' || agentType == '1'">
                    <div class="h-formLine">
                      <div style="font-size: 0.15rem;color: #ff2424;margin-bottom: 0.2rem" v-if="quyuflag">*
                        新注册经销商,请先填写经销商引入评估!
                      </div>
                      <el-form :model="formLabelAlign1.bscUserInfoAgentBasic" label-position="right" ref="formLabelAlign13" :inline="true" :rules="rules1" class="demo-ruleForm h-formbLine h-formbLine1">
                        <el-form-item label="经销商类别" class="h-elformWrap-2" prop="agentLevel">
                          <div style="display: flex;margin-left: 0.1rem;">
                            <brselect category="DealerCategory_type" v-model="formLabelAlign1.bscUserInfoAgentBasic.agentLevel" :v="formLabelAlign1.bscUserInfoAgentBasic.agentLevel" @change="changDealer1($event)" :disabled="flag==='2' || traditionalProducts || daqujl" style="width: 1.5rem!important;margin-left: 0.2rem;" :clearable="true" placeholder="请选择"></brselect>
                          </div>
                        </el-form-item>

                        <el-form-item label="对阵一级经销商" class="h-elformWrap-2" prop="oneLevelAgentName" v-if="formLabelAlign1.bscUserInfoAgentBasic.agentLevel==2 || formLabelAlign1.bscUserInfoAgentBasic.agentLevel==5">
                          <el-select v-model="formLabelAlign1.bscUserInfoAgentBasic.oneLevelAgentName" :title="formLabelAlign1.bscUserInfoAgentBasic.oneLevelAgentName" remote filterable :filter-method="showAgentList" clearable placeholder="请输入" :disabled="flag==='2' || traditionalProducts" :remote-method="showAgentList" @change="changeAgent($event)">
                            <el-option v-for="(item) in oneAgentList" :key="item.customerName" :label="item.customerName" :value="item">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <div v-if="agentType!=3">
                          <el-form :model="formLabelAlign1" label-position="right" ref="formLabelAlign11" :inline="true" :rules="rules1" class="demo-ruleForm h-formbLine h-formbLine1">
                            <div v-for="(listIt, index) in formLabelAlign1.contractList" :key="index">
                              <el-form-item label="合同号" class="h-elformWrap-2" prop="contractId">
                                <el-input :title="formLabelAlign1.contractList[index].id" v-model="formLabelAlign1.contractList[index].id" disabled></el-input>
                              </el-form-item>
                              <el-form-item label="目标对阵用户数量" class="h-elformWrap-2" prop="contractId">
                                <el-input :title="formLabelAlign1.contractList[index].userNum" v-model="formLabelAlign1.contractList[index].userNum" disabled></el-input>
                              </el-form-item>
                            </div>
                          </el-form>
                        </div>
                      </el-form>

                      <el-tabs type="border-card" v-model="cardName" v-if="agentType!=3">
                        <el-tab-pane label="总部" name="总部" >
                          <template>
                            <el-form :model="formLabelAlign1.bscUserInfoAgentSell" label-position="right" ref="formLabelAlign11"
                                     :inline="true" :rules="rules1" class="demo-ruleForm h-formbLine h-formbLine1" v-if="agentType!=3">
                              <div v-for="(item,index) in formLabelAlign1.ctList" :key="index">
                                <el-button
                                    v-if="index === 0"
                                    @click="addIndustry(index)"
                                    type="text"
                                    size="mini"
                                    style="float:right;font-size:20px;margin-right: -5px"
                                    icon="el-icon-circle-plus"
                                    circle
                                    title="添加">
                                </el-button>
                                <el-button
                                    @click="deleteIndustry(index)"
                                    v-if="index !== 0"
                                    type="text"
                                    style="float:right;font-size:20px;margin-right: -5px;color:crimson;"
                                    size="mini"
                                    icon="el-icon-remove"
                                    circle
                                    title="删除"
                                ></el-button>
                                <el-form-item label="产业" class="h-elformWrap-2" prop="goodsCategory"
                                              v-if="ct" style="margin-left: -0.71rem;">
                                  <brselect category="swyl_industry" :disabled="flag==='2' || traditionalProducts || daqujl"  :v="formLabelAlign1.ctList[index].field" v-model="formLabelAlign1.ctList[index].field"
                                            style="width:100%"/>
                                </el-form-item>
                                <el-form-item label="渠道" class="h-elformWrap-2" prop="goodsCategory" v-if="item.field!='C5' && item.field!='C7'"
                                              style="margin-left: -0.71rem;">
                                  <el-select :multiple="true" :disabled="flag==='2' || daqujl" :clearable="true" style="width: 4rem"
                                             v-model="formLabelAlign1.ctList[index].channelList"
                                             :v="formLabelAlign1.ctList[index].channelList" @change="getQudaoCt"
                                             :placeholder="flag==='2'?'':'请选择'">
                                    <el-option v-for="item in qudaoCt"
                                               :key="item.index"
                                               :value="item.code"
                                               :label="item.name"
                                    ></el-option>
                                  </el-select>
                                </el-form-item>

                                <el-form-item label="渠道" class="h-elformWrap-2" prop="goodsCategory"  v-if="item.field=='C5' || item.field=='C7'"
                                              style="margin-left: -0.71rem;">
                                  <el-select :multiple="true" :disabled="flag==='2' || daqujl" :clearable="true" style="width: 4rem"
                                             v-model="formLabelAlign1.ctList[index].channelList"
                                             :v="formLabelAlign1.ctList[index].channelList" @change="getQudaoCt"
                                             :placeholder="flag==='2'?'':'请选择'">
                                    <el-option v-for="item in qudaoND5"
                                               :key="item.index"
                                               :value="item.code"
                                               :label="item.name"
                                    ></el-option>
                                  </el-select>
                                </el-form-item>

                                <el-form-item label="返利类型" class="h-elformWrap-2" prop="goodsCategory" style="margin-left: 1.71rem;" v-if="ct && formLabelAlign1.bscUserInfoAgentBasic.agentLevel!='3'">
                                  <el-select  v-if="ct && formLabelAlign1.bscUserInfoAgentBasic.agentLevel!='3'&& formLabelAlign1.bscUserInfoAgentBasic.agentLevel!='6'" v-model="formLabelAlign1.ctList[index].flType" @change="ctSelect" style="width: 1.5rem!important;margin-left: 0.2rem;" clearable placeholder="请选择">
                                    <el-option label="一级经销商" value="01"></el-option>
                                    <el-option label="地市直营商" value="06"></el-option>
                                    <el-option label="分销商3.0" value="05"></el-option>
                                  </el-select>
                                  <el-select v-if="ct && formLabelAlign1.bscUserInfoAgentBasic.agentLevel=='6'" v-model="formLabelAlign1.ctList[index].flType" @change="ctSelect" style="width: 1.5rem!important;margin-left: 0.2rem;" placeholder="请选择">
                                    <el-option label="地市直营商" value="06"></el-option>
                                  </el-select>
                                </el-form-item>
                                <el-form-item label="产品价格" :style="{marginLeft: ct && formLabelAlign1.bscUserInfoAgentBasic.agentLevel!='3'?'0':'1.71rem'}">
                                  <el-select  v-if="ct && isZhiDan!=1" v-model="formLabelAlign1.ctList[index].level" @change="ctSelect" style="width: 1.5rem!important;margin-left: 0.2rem;" :disabled="flag==='2' || daqujl" placeholder="请选择">
                                    <el-option label="未签约" value=""></el-option>
                                    <el-option label="一级产品价格" value="01"></el-option>
                                    <el-option label="二级产品价格" value="02"></el-option>
                                    <el-option label="三级产品价格" value="03"></el-option>
                                    <!--                                                    <el-option label="直单价格" value="06"></el-option>-->
                                    <el-option label="分销商价格" value="05" v-if="formLabelAlign1.bscUserInfoAgentBasic.agentLevel != '1'"></el-option>
                                  </el-select>
                                  <el-select v-if="ct && isZhiDan==1" v-model="formLabelAlign1.ctList[index].level" @change="ctSelect" style="width: 1.5rem!important;margin-left: 0.2rem;" :disabled="flag==='2' || daqujl" placeholder="请选择">
                                    <el-option label="未签约" value=""></el-option>
                                    <el-option label="直单价格" value="04"></el-option>
                                  </el-select>
                                </el-form-item>
                              </div>
                            </el-form>
                          </template>
                        </el-tab-pane>
                        <el-tab-pane :label="item.companyName" v-for="item in LQList"  :name="item.companyName" :key="item.lianqun">
                          <el-form label-position="right" ref="formLabelAlign11"
                                   :inline="true" :rules="rules1" class="demo-ruleForm h-formbLine h-formbLine1">
                            <el-form-item label="渠道" class="h-elformWrap-2" prop="goodsCategory" style="margin-left: -0.5rem;">
                              <el-select @change="changeQudao" v-model="addForm[`${item.companyCode}Channel`]" :multiple="true" :disabled="flag==='2' || daqujl" filterable placeholder="请选择" style="width: 4.5rem">
                                <el-option
                                    v-for="items in item.channelList"
                                    :key="items.code"
                                    :label="items.name"
                                    :value="items.code">
                                </el-option>
                              </el-select>
                            </el-form-item>
                            <el-form-item label="产品价格" class="h-elformWrap-2" prop="goodsCategory" style="margin-left: 2rem;">
                              <el-select v-if="ct && isZhiDan!=1" v-model="addForm[`${item.companyCode}`]"
                                         placeholder="请选择" :disabled="flag==='2' || daqujl"
                                         @change="changeQudao">
                                <el-option label="未签约" value=""></el-option>
                                <el-option label="一级产品价格" value="01"></el-option>
                                <el-option label="二级产品价格" value="02"></el-option>
                                <el-option label="三级产品价格" value="03"></el-option>
                                <el-option label="分销商价格" value="05" v-if="formLabelAlign1.bscUserInfoAgentBasic.agentLevel != '1'"></el-option>
                              </el-select>
                              <el-select v-if="ct && isZhiDan==1" v-model="addForm[`${item.companyCode}`]"
                                         placeholder="请选择" @change="changeQudao" :disabled="flag==='2' || daqujl">
                                <el-option label="未签约" value=""></el-option>
                                <el-option label="直单价格" value="04"></el-option>
                              </el-select>
                            </el-form-item>
                          </el-form>
                        </el-tab-pane>
                      </el-tabs>

                  <!--    <el-form :model="formLabelAlign1.bscUserInfoAgentBasic" label-position="right"
                               ref="formLabelAlign11"
                               :inline="true" :rules="rules1" class="demo-ruleForm h-formbLine h-formbLine1">

                        <el-form-item label="是否增量" prop="isIncrement" class="h-elformWrap-2" v-if="this.cardName == '总部'">
                          <el-radio-group v-model="formLabelAlign1.bscUserInfoAgentBasic.isIncrement" @change="handleIncrementChange">
                            <el-radio label="1">是</el-radio>
                            <el-radio label="0">否</el-radio>
                          </el-radio-group>
                        </el-form-item>

                        <el-form-item
                                label="增量赋能平台"
                                prop="incrementPt"
                                class="h-elformWrap-2"
                                v-if="formLabelAlign1.bscUserInfoAgentBasic.isIncrement === '1' && this.cardName == '总部'"
                        >
                          <el-select
                                  v-model="formLabelAlign1.bscUserInfoAgentBasic.incrementPt"
                                  placeholder="请选择增量赋能平台"
                          >
                            <el-option
                                    v-for="item in ptOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                            />
                          </el-select>
                        </el-form-item>

                      </el-form>-->


                      <el-form :model="formLabelAlign1.bscUserInfoAgentSell" label-position="right" ref="formLabelAlign11" :inline="true" :rules="rules1" class="demo-ruleForm h-formbLine h-formbLine1">
                        <!--                  <el-form-item label="链群" class="h-elformWrap-2 w-elformWrap other" prop="goodsCategory" v-if="this.agentType!=3" style="margin-left: -0.4rem;">-->
                        <!--                    <el-checkbox-group v-model="lianqunListCt" @change="getLianqunTickct" style="float: left;margin-left: 10px;margin-right: 10px" :disabled="flag==='2' || traditionalProducts || daqujl">-->
                        <!--                      <el-checkbox label="ct">传统产品</el-checkbox>-->
                        <!--                    </el-checkbox-group>-->
                        <!--                    <el-checkbox-group v-model="lianqunList" @change="lianqunOptions" style="float: left;margin-left: 10px;margin-right: 10px" :disabled="flag==='2' || traditionalProducts || daqujl">-->
                        <!--                    </el-checkbox-group>-->
                        <!--                    <el-checkbox-group v-model="LQcheckList" @change="LQSelect" style="float: left;margin-left: 10px;margin-right: 10px" :disabled="flag==='2' || traditionalProducts || daqujl">-->
                        <!--                      <el-checkbox :label="item.lianqun" v-for="(item,index) in LQList" :key="index">{{ item.companyName }}</el-checkbox>-->
                        <!--                    </el-checkbox-group>-->
                        <!--                  </el-form-item>-->
                        <!--                  <div v-if="this.agentType != '3'" style="margin-bottom: -20px;margin-top: 5px">-->
                        <!--                    &lt;!&ndash;                          传统产品&ndash;&gt;-->
                        <!--                    <el-form-item label="" class="h-elformWrap-1" v-if="isCt" prop="scale" style="margin-left: -0.4rem;width: 100%;margin-top: -0.4rem">-->
                        <!--                      &lt;!&ndash;                                        循环&ndash;&gt;-->
                        <!--                      <div v-for="(listIt, index) in formLabelAlign1.ctList" :key="index">-->
                        <!--                        <div style="display: flex;flex-wrap: wrap;margin-top: 0.1rem;margin-bottom: 0.1rem">-->

                        <!--                          <item style="float: left;margin-left: 0.9rem;color: #4a4a4a;">链群 传统(</item>-->
                        <!--                          <el-checkbox-group v-model="formLabelAlign1.ctList[index].lianqunList" :v="formLabelAlign1.ctList[index].lianqunList" :disabled="flag==='2' || traditionalProducts || daqujl" style="float: left;margin-left: 10px;margin-right: 10px">-->
                        <!--                            <el-checkbox label="X02">样本网</el-checkbox>-->
                        <!--                            <el-checkbox label="X01">药品网</el-checkbox>-->
                        <!--                            <el-checkbox label="X08">生物安全类</el-checkbox>-->
                        <!--                            <el-checkbox label="X09">培养箱类</el-checkbox>-->
                        <!--                            <el-checkbox label="X10">离心机</el-checkbox>-->
                        <!--                            <el-checkbox label="X06">疫苗网</el-checkbox>-->
                        <!--                          </el-checkbox-group>-->
                        <!--                          <item style="float: left">)</item>-->
                        <!--                        </div>-->

                        <!--                        <div style="display: flex;flex-wrap: wrap;margin-top: 0.15rem;margin-bottom: 0.1rem">-->
                        <!--                          <div style="color: #4a4a4a;line-height: 0.28rem;margin-left: 0.9rem;">-->
                        <!--                            传统产品-->
                        <!--                          </div>-->
                        <!--                          <div style="display: flex;margin-left: 0.4rem;">-->
                        <!--                            <div class="foundation-box">-->
                        <!--                              领域:-->
                        <!--                            </div>-->
                        <!--                            <el-select v-if="ct" v-model="formLabelAlign1.ctList[index].field" @change="fieldSelect(index)" style="width: 1.3rem!important;margin-left: 0.1rem;" placeholder="请选择">-->
                        <!--                              <el-option v-for="item in fieldList" :key="item.index" :value="item.code" :label="item.name"></el-option>-->
                        <!--                            </el-select>-->
                        <!--                          </div>-->

                        <!--                          <div style="display: flex;margin-left: 0.4rem;">-->
                        <!--                            <div class="qudoa">-->
                        <!--                              渠道:-->
                        <!--                            </div>-->
                        <!--                            &lt;!&ndash;                            <brselectlazy :multiple="true" category="sales_region_field_L1" v-if="formLabelAlign1.ctList[index].field == 'L1'" style="width: 4.5rem"-->
                        <!--                                          :v="formLabelAlign1.ctList[index].channel"-->
                        <!--                                          v-model="formLabelAlign1.ctList[index].channel"-->
                        <!--                                          :class="{'ljjSelectdisabled':true}"-->
                        <!--                                          :clearable="true"/>-->
                        <!--                            <brselectlazy :multiple="true" category="sales_region_field_L2" v-if="formLabelAlign1.ctList[index].field == 'L2'" style="width: 4.5rem"-->
                        <!--                                          :v="formLabelAlign1.ctList[index].channel"-->
                        <!--                                          v-model="formLabelAlign1.ctList[index].channel"-->
                        <!--                                          :class="{'ljjSelectdisabled':true}"-->
                        <!--                                          :clearable="true"/>&ndash;&gt;-->
                        <!--                            <el-select :multiple="true" :disabled="flag==='2' || daqujl" :clearable="true" style="width: 4rem" v-model="formLabelAlign1.ctList[index].channelList" :v="formLabelAlign1.ctList[index].channelList" @change="getQudaoCt" :placeholder="flag==='2'?'':'请选择'">-->
                        <!--                              <el-option v-for="item in formLabelAlign1.ctList[index].field == 'L1'?qudaoL1:qudaoL2" :key="item.index" :value="item.code" :label="item.name"></el-option>-->
                        <!--                            </el-select>-->

                        <!--                          </div>-->
                        <!--                          <div style="display: flex;margin-left: 0.4rem;">-->
                        <!--                            <div class="foundation-box">-->
                        <!--                              销售地区:-->
                        <!--                            </div>-->
                        <!--                            <brselect category="YlSalesArea_chanpin" v-model="formLabelAlign1.ctList[index].area" style="width: 2rem!important;margin-left: 0.2rem;" @change="changeAreaLevel($event)" :v="formLabelAlign1.ctList[index].area"></brselect>-->

                        <!--                            <div style="display: flex;margin-left: 0.2rem;" v-if="index == 0 && !isShangWei && !daqujl">-->
                        <!--                              <template>-->
                        <!--                                <el-button-group style="width: 1.3rem!important;margin-left: 0.2rem;">-->
                        <!--                                  <el-button type="primary" size="mini" @click="addCtList(index)" title="新增">＋-->
                        <!--                                  </el-button>-->
                        <!--                                  <el-button type="primary" size="mini" title="删除" @click="deleteCtList">－</el-button>-->
                        <!--                                </el-button-group>-->
                        <!--                              </template>-->
                        <!--                            </div>-->
                        <!--                          </div>-->
                        <!--                          <div class="h-elformWrap-1" style="display: flex;margin-left: 2rem;float: left;margin-top: 0.15rem;margin-bottom: 0.15rem">-->
                        <!--                            <div class="foundation-box" v-if="ct && formLabelAlign1.bscUserInfoAgentBasic.agentLevel!='3'">-->
                        <!--                              返利类型:-->
                        <!--                            </div>-->
                        <!--                            <el-select v-if="ct && formLabelAlign1.bscUserInfoAgentBasic.agentLevel!='3'&& formLabelAlign1.bscUserInfoAgentBasic.agentLevel!='6'" v-model="formLabelAlign1.ctList[index].flType" @change="ctSelect" style="width: 1.5rem!important;margin-left: 0.2rem;" clearable placeholder="请选择">-->
                        <!--                              <el-option label="一级经销商" value="01"></el-option>-->
                        <!--                              <el-option label="地市直营商" value="06"></el-option>-->
                        <!--                              <el-option label="分销商3.0" value="05"></el-option>-->
                        <!--                            </el-select>-->
                        <!--                            <el-select v-if="ct && formLabelAlign1.bscUserInfoAgentBasic.agentLevel=='6'" v-model="formLabelAlign1.ctList[index].flType" @change="ctSelect" style="width: 1.5rem!important;margin-left: 0.2rem;" placeholder="请选择">-->
                        <!--                              <el-option label="地市直营商" value="06"></el-option>-->
                        <!--                            </el-select>-->
                        <!--                            <div class="foundation-box" style="margin-left: 0.5rem;">-->
                        <!--                              产品价格:-->
                        <!--                            </div>-->
                        <!--                            <el-select v-if="ct && isZhiDan!=1" v-model="formLabelAlign1.ctList[index].level" @change="ctSelect" style="width: 1.5rem!important;margin-left: 0.2rem;" :disabled="flag==='2' || daqujl" placeholder="请选择">-->
                        <!--                              <el-option label="未签约" value=""></el-option>-->
                        <!--                              <el-option label="一级产品价格" value="01"></el-option>-->
                        <!--                              <el-option label="二级产品价格" value="02"></el-option>-->
                        <!--                              <el-option label="三级产品价格" value="03"></el-option>-->
                        <!--                              &lt;!&ndash;                                                    <el-option label="直单价格" value="06"></el-option>&ndash;&gt;-->
                        <!--                              <el-option label="分销商价格" value="05" v-if="formLabelAlign1.bscUserInfoAgentBasic.agentLevel != '1'"></el-option>-->
                        <!--                            </el-select>-->
                        <!--                            <el-select v-if="ct && isZhiDan==1" v-model="formLabelAlign1.ctList[index].level" @change="ctSelect" style="width: 1.5rem!important;margin-left: 0.2rem;" :disabled="flag==='2' || daqujl" placeholder="请选择">-->
                        <!--                              <el-option label="未签约" value=""></el-option>-->
                        <!--                              <el-option label="直单价格" value="04"></el-option>-->
                        <!--                            </el-select>-->
                        <!--                          </div>-->
                        <!--                        </div>-->
                        <!--                      </div>-->
                        <!--                    </el-form-item>-->
                        <!--                    &lt;!&ndash;                            航空温控&ndash;&gt;-->
                        <!--                    <el-form-item label="" class="h-elformWrap-1" v-for="(item,index) in checkLQAfterList" :key="index" prop="scale" style="margin-left: -0.5rem;width: 100%;margin-top: -0.4rem">-->
                        <!--                      <div style="display: flex;flex-wrap: wrap;margin-top: 0.1rem;margin-bottom: 0.1rem">-->
                        <!--                        <div style="font-size: 0.18rem;color: #4a4a4a;line-height: 0.28rem;margin-left: 0.9rem;">-->
                        <!--                          &lt;!&ndash; 航空温控 &ndash;&gt;-->
                        <!--                          {{ item.companyName }}-->
                        <!--                        </div>-->

                        <!--                        <div style="display: flex;margin-left: 2.3rem;">-->
                        <!--                          <div class="foundation-box">-->
                        <!--                          </div>-->
                        <!--                        </div>-->

                        <!--                        <div style="display: flex;margin-left: 0.98rem">-->
                        <!--                          <div class="qudoa">-->
                        <!--                            渠道:-->
                        <!--                          </div>-->
                        <!--                          <el-select @change="changeQudao" v-model="addForm[`${item.companyCode}Channel`]" :multiple="true" filterable placeholder="请选择" style="width: 4rem" :disabled="flag==='2' || daqujl">-->
                        <!--                            <el-option v-for="items in item.channelList" :key="items.code" :label="items.name" :value="items.code">-->
                        <!--                            </el-option>-->
                        <!--                          </el-select>-->
                        <!--                        </div>-->

                        <!--                        <div style="display: flex;margin-left: 0.4rem;">-->
                        <!--                          <div class="foundation-box">-->
                        <!--                            产品价格:-->
                        <!--                          </div>-->
                        <!--                          <el-select v-if="ct && isZhiDan!=1" v-model="addForm[`${item.companyCode}`]" style="width: 1.5rem!important;margin-left: 0.2rem;" placeholder="请选择" @change="changeQudao" :disabled="flag==='2' || daqujl">-->
                        <!--                            <el-option label="未签约" value=""></el-option>-->
                        <!--                            <el-option label="一级产品价格" value="01"></el-option>-->
                        <!--                            <el-option label="二级产品价格" value="02"></el-option>-->
                        <!--                            <el-option label="三级产品价格" value="03"></el-option>-->
                        <!--                            <el-option label="分销商价格" value="05" v-if="formLabelAlign1.bscUserInfoAgentBasic.agentLevel != '1'"></el-option>-->
                        <!--                          </el-select>-->
                        <!--                          <el-select v-if="ct && isZhiDan==1" v-model="addForm[`${item.companyCode}`]" style="width: 1.5rem!important;margin-left: 0.2rem;" placeholder="请选择" @change="changeQudao" :disabled="flag==='2' || daqujl">-->
                        <!--                            <el-option label="未签约" value=""></el-option>-->
                        <!--                            <el-option label="直单价格" value="04"></el-option>-->
                        <!--                          </el-select>-->
                        <!--                        </div>-->
                        <!--                      </div>-->
                        <!--                    </el-form-item>-->
                        <!--                  </div>-->
                        <!--                  <div v-if="this.agentType == '3'">-->
                        <!--                    <el-form-item label="" class="h-elformWrap-1" prop="scale" v-if="data.iszhidanBas != 1 && (flag==='2'||flag==='3'||flag==='4')">-->
                        <!--                      <div style="display: flex;">-->
                        <!--                        <div style="font-size: 0.18rem;color: #4a4a4a;line-height: 0.28rem;margin-left: 0.6rem;">-->
                        <!--                          产品价格-->
                        <!--                        </div>-->
                        <!--                        <div style="display: flex;margin-left: 0.2rem;">-->
                        <!--                          <div style="font-size: 0.18rem;color: #868686;line-height: 0.28rem;">-->
                        <!--                            传统产品:-->
                        <!--                          </div>-->
                        <!--                          <el-select :disabled="flag==='2' || traditionalProducts || daqujl" v-if="ct" v-model="ctLevel" @change="ctSelect" style="width: 1.5rem!important;margin-left: 0.2rem;" :class="{'ljjSelectdisabled':flag==='2'}" :placeholder="flag==='2'?'':'请选择'">-->
                        <!--                            <el-option label="未签约" value=""></el-option>-->
                        <!--                            <el-option label="一级产品价格" value="01"></el-option>-->
                        <!--                            <el-option label="二级产品价格" value="02"></el-option>-->
                        <!--                            <el-option label="三级产品价格" value="03"></el-option>-->
                        <!--                            &lt;!&ndash;                          <el-option label="直单价格" value="06"></el-option>&ndash;&gt;-->
                        <!--                            <el-option label="分销商价格" value="05" v-if="formLabelAlign1.bscUserInfoAgentBasic.agentLevel != '1'"></el-option>-->
                        <!--                          </el-select>-->
                        <!--                        </div>-->
                        <!--                      </div>-->
                        <!--                    </el-form-item>-->
                        <!--                    <el-form-item label="" class="h-elformWrap-1" prop="scale" v-if="data.iszhidanBas == 1 && (flag==='2'||flag==='3'||flag==='4')">-->
                        <!--                      <div style="display: flex;">-->
                        <!--                        <div style="font-size: 0.18rem;color: #4a4a4a;line-height: 0.28rem;margin-left: 0.9rem;">-->
                        <!--                          产品价格-->
                        <!--                        </div>-->
                        <!--                        <div style="display: flex;margin-left: 0.2rem;">-->
                        <!--                          <div style="font-size: 0.18rem;color: #868686;line-height: 0.28rem;">-->
                        <!--                            传统产品:-->
                        <!--                          </div>-->
                        <!--                          <el-select :disabled="flag==='2' || daqujl" v-if="ct" v-model="ctLevel" @change="ctSelect" :class="{'ljjSelectdisabled':flag==='2'}" :placeholder="flag==='2'?'':'请选择'" style="width: 1.5rem!important;margin-left: 0.2rem;">-->
                        <!--                            <el-option label="未签约" value=""></el-option>-->
                        <!--                            <el-option label="直单价格" value="04"></el-option>-->
                        <!--                          </el-select>-->
                        <!--                        </div>-->
                        <!--                      </div>-->
                        <!--                    </el-form-item>-->
                        <el-form-item label="主销售渠道" v-if="agentType == '3'" class="h-elformWrap-2 w-elformWrap other" prop="customerGroup3" ref="formLabelAlign11">
                          <el-select :multiple="true" :disabled="flag==='2' || daqujl" :clearable="true" v-model="formLabelAlign1.bscUserInfoAgentSell.customerGroup3" :v="formLabelAlign1.bscUserInfoAgentSell.customerGroup3" @change="getQudao" :placeholder="flag==='2'?'':'请选择'">
                            <el-option v-for="item in qudaoNotMain" :key="item.index" :value="item.code" :label="item.name" :disabled="hasInclude(formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain,item.code) || daqujl"></el-option>
                          </el-select>
                        </el-form-item>
                        <!--                  </div>-->

                        <el-form-item label="客户种类" class="h-elformWrap-2" prop="accountDistributeGroup" style="padding-right:0">
                          <el-select :disabled="flag==='2' || daqujl" v-model="formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup" :title="
                                                formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup == 10 ? '内销-海尔集团内（指国内市场所有海尔关联公司）':
                                                formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup == 20 ? '内销-海尔集团外（指国内市场所有非海尔关联公司）':
                                                formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup == 30 ? '外销-海尔集团内（指海外市场所有海尔关联公司）':
                                                formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup == 40 ? '外销-海尔集团外（指海外市场非海尔关联公司）':
                                                formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup == 50 ? '外销-合并范围内':
                                                formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup == 60 ? '内销-合并范围内':
                                                ''" :class="{'ljjSelectdisabled':flag==='2'}" :placeholder="flag==='2'?'':'请选择'">
                            <el-option label="内销-海尔集团内（指国内市场所有海尔关联公司）-10" value="10"></el-option>
                            <el-option label="内销-海尔集团外（指国内市场所有非海尔关联公司）-20" value="20"></el-option>
                            <el-option label="外销-海尔集团内（指海外市场所有海尔关联公司）-30" value="30"></el-option>
                            <el-option label="外销-海尔集团外（指海外市场非海尔关联公司）-40" value="40"></el-option>
                            <el-option label="外销-合并范围内 -50" value="50"></el-option>
                            <el-option label="内销-合并范围内 -60" value="60"></el-option>
                          </el-select>
                        </el-form-item>
                        <!--                                    <el-form-item label="客户组1" class="h-elformWrap-2" prop="customerGroup1">-->
                        <!--                                        <el-select :disabled="flag==='2'" v-model="formLabelAlign1.bscUserInfoAgentSell.customerGroup1"-->
                        <!--                                                   placeholder="请选择">-->
                        <!--                                            <el-option label="增值税发票" value="01"></el-option>-->
                        <!--                                            <el-option label="普通发票" value="02"></el-option>-->
                        <!--                                        </el-select>-->
                        <!--                                    </el-form-item>-->
                        <el-form-item label="签约性质" class="h-elformWrap-2" prop="customerGroup2">
                          <el-select :disabled="flag==='2' || daqujl" :class="{'ljjSelectdisabled':flag==='2'}" v-model="formLabelAlign1.bscUserInfoAgentSell.customerGroup2" :placeholder="flag==='2'?'':'请选择'">
                            <el-option label="签约经销商" value="01"></el-option>
                            <el-option label="非签约经销商" value="02"></el-option>
                            <!--                                            <el-option label="直单用户" value="03"></el-option>-->
                          </el-select>
                        </el-form-item>
                        <el-form-item label="分销渠道" class="h-elformWrap-2" prop="distributionChannel">
                          <brselectlazy category="YlSalesChannel_agent" :v="formLabelAlign1.bscUserInfoAgentSell.distributionChannel" v-model="formLabelAlign1.bscUserInfoAgentSell.distributionChannel" :clearable="true" style="width:2.27rem" :disabled="flag==='2' || daqujl" />
                        </el-form-item>
                        <!--                  <el-form-item label="非主销售渠道" class="h-elformWrap-2 w-elformWrap other" prop="customerGroup3NotMain" >
                           <el-select :multiple="true" :disabled="flag==='2' || daqujl"
                                     :clearable="true"
                                     v-model="formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain"
                                     :v="formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain"
                                      @change="getQudaoNotMain"
                                     :placeholder="flag==='2'?'':'请选择'">
                            <el-option v-for="item in qudaoNotMain"
                                       :key="item.index"
                                       :value="item.code"
                                       :label="item.name"
                                       :disabled="hasInclude(formLabelAlign1.bscUserInfoAgentSell.customerGroup3,item.code) || daqujl"
                            ></el-option>
                          </el-select>-->

                        <!--                    <brselectlazy :multiple="true" category="sales_region"-->
                        <!--                                  :v="formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain"-->
                        <!--                                  v-model="formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain"-->
                        <!--                                  :clearable="true"-->
                        <!--                                  :class="{'ljjSelectdisabled':flag==='2'}"-->
                        <!--                                  style="width:4.27rem"-->
                        <!--                                  :disabled="flag==='2'"/>-->
                        <!--                  </el-form-item>-->
                        <el-form-item label="销售区域" class="h-elformWrap-2 w-elformWrap other" prop="salesRegion">
                          <brselect :multiple="true" category="YlSalesArea_chanpin" @change="changeArea($event)" v-if="agentType != '3'" :v="formLabelAlign1.bscUserInfoAgentSell.salesRegion" v-model="formLabelAlign1.bscUserInfoAgentSell.salesRegion" :clearable="true" :disabled="flag==='2' || daqujl" />
                          <brselect :multiple="true" category="YlSalesArea" v-if="agentType == '3' && isExpandAuthority != 1 " :v="formLabelAlign1.bscUserInfoAgentSell.salesRegion" v-model="formLabelAlign1.bscUserInfoAgentSell.salesRegion" :clearable="true" :disabled="flag==='2' || daqujl" />

                          <brselect :multiple="true" category="YlSalesArea_chanpin" v-if="agentType == '3' && isExpandAuthority == '1' " :v="formLabelAlign1.bscUserInfoAgentSell.salesRegion" v-model="formLabelAlign1.bscUserInfoAgentSell.salesRegion" :clearable="true" :disabled="flag==='2' || daqujl" />

                        </el-form-item>

                        <el-form-item label="销售地市" class="h-elformWrap-2 w-elformWrap other" prop="salesCity" v-if="agentType != '3'">
                          <el-select :multiple="true" :clearable="true" v-model="formLabelAlign1.bscUserInfoAgentSell.salesCity" :v="formLabelAlign1.bscUserInfoAgentSell.salesCity" @change="getCity" :placeholder="flag==='2'?'':'请选择'" :disabled="flag==='2' || daqujl">
                            <el-option v-for="item in salesCity" :key="item.index" :value="item.code" :label="item.name"></el-option>
                          </el-select>
                        </el-form-item>

                      </el-form>
                      <el-form :model="formLabelAlign1.bscUserInfoAgentBasic" label-position="right" ref="formLabelAlign12" :inline="true" :rules="rules1" class="demo-ruleForm h-formbLine h-formbLine1">
                        <el-form-item label="公司代码" class="h-elformWrap-2 w-elformWrap other" prop="companyCode">
                          <brselectlazy :multiple="true" category="YlCompanyCode_agent" :v="formLabelAlign1.bscUserInfoAgentBasic.companyCode" v-model="formLabelAlign1.bscUserInfoAgentBasic.companyCode" :clearable="true" style="width:100%" @change="companyCodeChange" :disabled="flag==='2' || daqujl" />
                        </el-form-item>

                        <el-form-item label="附件" class="h-elformWrap-2" prop="upload9" v-if="isZhiDan && !quyuflag">
                          <brupload v-model="formLabelAlign1.bscUserInfoAgentBasic.upload9" v-if="fileShowFlag" :refid="refid" reftype="代理商注册-附件" :uploadflag="uploadflag" :delflag="delflag" @filecallback="fileBack4" :showtime="false">
                          </brupload>
                        </el-form-item>
                        <el-form-item label="请上传附件" class="h-elformWrap-2" prop="upload9" v-if="isZhiDan && quyuflag">
                          <el-upload v-model="formLabelAlign1.bscUserInfoAgentBasic.upload9" ref="formLabelAlign1i" class="upload-demo" action="" :http-request="httpRequestAgent1" :on-remove="handleRemoveAgent1" :before-remove="beforeRemove" :before-upload="beforeUpload" multiple :file-list="fileListAgent9" :auto-upload=true>
                            <el-button size="small" type="primary">点击上传</el-button>
                          </el-upload>
                        </el-form-item>

                        <!--isBlood  是否血站专用渠道（杨宝栋[01023980]）  1 是  0 不是-->
                        <!--                  <span  class="h-elformWrap-6"  v-if="agentType!=3&&this.agentType != 1" style="margin-left: 72px">-->
                        <!--                                        <el-switch style="margin-left: 20px;width: 100%"-->
                        <!--                                                   v-model="isBlood"-->
                        <!--                                                   disabled-->
                        <!--                                                   active-text="是否血站专用渠道">-->
                        <!--                                        </el-switch>-->
                        <!--                                    </span>-->

                      </el-form>
                    </div>
                  </div>
                </el-collapse-item>

              <el-collapse-item name="8" v-if="agentType!=3 && !quyuflag">
                <template slot="title">
                  <div style="display: flex;align-items: center" @click.stop>
                    <span class="collapseTitle" style="color:#0e75e9">修改附件记录</span>
                  </div>
                </template>
                <el-table ref="multipleTable" :data="fileList" stripe border  style="width: 100%">
                  <el-table-column type="index" fixed label="#" width="40">
                  </el-table-column>
                  <el-table-column prop="cuname" label="修改人名称" :show-overflow-tooltip="true" fixed min-width="90">
                  </el-table-column>
                  <el-table-column prop="cucode" label="修改人编码" :show-overflow-tooltip="true" fixed min-width="110">
                  </el-table-column>
                  <el-table-column prop="cdate" label="修改时间" :show-overflow-tooltip="true" fixed value-format="yyyy-MM-dd" min-width="110">
                  </el-table-column>
                  <el-table-column prop="reason" label="修改原因" :show-overflow-tooltip="true" fixed min-width="110">
                  </el-table-column>
                  <el-table-column label="修改附件" :show-overflow-tooltip="true" fixed min-width="110">
                    <template slot-scope="scope">
                      <brupload :refid="scope.row.fileId" reftype="代理商修改-修改附件" :uploadflag="false" :delflag="false" :showtime="false">
                      </brupload>
                    </template>
                  </el-table-column>
                </el-table>
                <div style="display:flex;justify-content: flex-end;align-items:center;">
                  <paginationmin :page="mf" @query="agentUpdateFile" />
                </div>
              </el-collapse-item>
            </el-collapse>

          </div>
        </div>
      </div>
      <div class="bannerBox" v-if="flag==='2'||flag==='3'||flag==='4'">
        <div class="h-row h-mrt1">
          <div class="h-rowIn">
            <div class="h-rowBox" v-show="flag != 2">
              <div class="h-rowCon">
                <div class="h-pieceIn2">
                  <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                  <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                    <h1>审核信息</h1>
                  </div>
                  <div>
                    <div class="h-formLine weekplandetail10" style="position: relative;">
                      <el-form :inline="true" :model="formLabelAlign1.bscUserInfoAgentSell" ref="formLabelAlign13" :rules="rules1">
                        <el-form-item label="审批意见" class="h-elformWrap-2 newBox" style="width: 80%" :required="true" prop="auditMind1">
                          <el-input v-model="formLabelAlign1.bscUserInfoAgentSell.auditMind1" placeholder="请输入"></el-input>
                        </el-form-item>
                      </el-form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="text-align: center;margin-top: 0.5rem">
        <el-button class="h-btn h-bBtn h-bgblueQ2" :class="{'h-bgwhite':flag!=='2'}" v-if="flag==='1'||flag==='2'||flag==='3'||flag==='4' ||flag==='5'" @click="goBack">返回
        </el-button>
        <el-button class="h-btn h-bBtn h-bggreen" @click="saveGYDls('formLabelAlign1')" v-if="flag==='1' && this.agentType == '3' && admin">暂存
        </el-button>
        <el-button class="h-btn h-bBtn h-bggreen" @click="insert('formLabelAlign1','暂存')" v-if="(flag==='1' || flag==='5') && agentType != '3'">暂存
        </el-button>
        <el-button class="h-btn h-bBtn h-bgblueQ2" @click="insert('formLabelAlign1','提交')" v-if="(flag==='1' || flag==='5') && !creatNewFlag">提交
        </el-button>
        <el-button class="h-btn h-bBtn h-bgblueQ2" v-if="(flag==='5'&& creatNewFlag) || creatNewFlag" @click="insertCreat('formLabelAlign1')">提交创建
        </el-button>
        <span style="margin-left: 0.1rem" v-if="this.$route.query.taskstatus !=1">
          <el-button class="h-btn h-bBtn h-bgred" v-if="flag==='3'||flag==='4'&& lastflag" @click="reject('formLabelAlign1')">驳回
          </el-button>
          <el-button class="h-btn h-bBtn h-bggreen" @click="updatePinggu('formLabelAlign1')" v-if="(flag==='3'||flag==='4') && lastflag">通过
          </el-button>
          <el-button class="h-btn h-bBtn h-bgred" @click="agentPassDaquBh(('formLabelAlign1'))" v-if="daquflag">驳回
          </el-button>
          <el-button class="h-btn h-bBtn h-bggreen" @click="agentPassDaqu()" v-if="daquflag">通过
          </el-button>
        </span>
        <el-button class="h-btn h-bBtn h-bgblueQ2" style="margin-left: 0.1rem;" @click="viewpress" v-if="flag==='3'||flag==='4'">
          审批跟踪
        </el-button>
      </div>
    </div>
    <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid" />
    <viewscoretable :visible.sync="showscoretable" v-if="showscoretable" @choseObj="getChoose" :usercodeInfo="usercodeInfo" :instid="instid" />
    <areaSelect :visible.sync="showflag2" @choseObj="choseObj2" v-if="showflag2" v-model="formLabelAlign1.bscUserInfoAgentBasic.cityStreetRoom" :readonly="flag==='2'||flag==='3'||flag==='4'" />
    <areaSelect :visible.sync="showflag" @choseObj="choseObj" v-if="showflag" v-model="formLabelAlign1.bscUserInfoAgentCompany.mailaddress" :readonly="flag==='2'||flag==='3'||flag==='4'" />
  </div>
</template>
<script>
import ss from '../../../api/SystemService';
import agentCopyService from "../../../api/loud/agent/agentCopyService";
import uploadFile from "../../../api/process/account_complainUploadService";

export default {
  data () {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.check.checkpassword !== '') {
          this.$refs.formLabelAlign1a.validateField('checkpassword');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.formLabelAlign1.bscUserInfo.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    var validateCompany = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入公司名称'));
      } else if (value !== '') {
        ss.SignService.checkCompany(value).then(response => {
          console.log(response, '验证公司信息')
          if (response.obj.status === '200') {
            this.companyData = response.obj.data;
            callback();
            this.formLabelAlign1.bscUserInfoAgentBasic.companyAddress = this.companyData.address;
            // this.formLabelAlign1.bscUserInfoAgentBasic.http = this.companyData.websites[0].web_url;
            this.formLabelAlign1.bscUserInfoAgentBasic.companytype = this.companyData.econ_kind;
            this.formLabelAlign1.bscUserInfoAgentBasic.founded = this.companyData.start_date;
            this.formLabelAlign1.bscUserInfoAgentBasic.regmoney = this.companyData.regist_capi;
            this.formLabelAlign1.bscUserInfoAgentBasic.legal = this.companyData.oper_name;
            this.formLabelAlign1.bscUserInfoAgentBasic.business = this.companyData.scope;
            this.formLabelAlign1.bscUserInfoAgentBasic.taxCode = this.companyData.credit_no;
            this.formLabelAlign1.bscUserInfoAgentBasic.streetRoom = this.companyData.address;
            this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber = this.companyData.contact.telephone;
          } else {
            callback(new Error('请输入正确的公司名称!'));
          }
        })

      }
    };
    return {
      isShowAllSelect: false,//判断是否展示全部群连并checkout
      haveThree6840: false,
      value1: true,
      value2: false,
      userName1: false,
      taxCode: false,
      phoneNumber: false,
      cityStreetRoom: false,
      bankBranchCode: false,
      bankName: false,
      accountHolderName: false,
      bankCountry: false,
      customerGroup1: false,
      changedParamList: [],
      isZhiDan: false,
      traditionalProducts: false,
      isExpandAuthority: true,//是否海外直单权限
      isFenxiao: false,
      isFenxiao2: false,
      isBlood: false,//是否血站
      isGoverment: false,
      mailreceiver: false,
      receiverphone: false,
      mailaddress: false,
      daquflag: false,
      quyuflag: false,
      lastflag: true,
      creatNewFlag: false,
      creatAgent: false,
      bitian: false,
      // isShowSkipLeader: false,
      isShangWei: false,
      isWh: false,
      admin:false,
      ctLevel: '',
      NA9Level: '',
      dealerType: '',
      qudaos: '',
      qudaosNotMain: '',
      citys: '',
      usercodeInfo: '',
      showscoretable: false,
      ct: true,
      NA9: true,
      isCt: false,
      isNA9: false,
      haiwairen: false,
      guanliren: false,
      daqujl: false,
      iszhuche: false,//是否是注册流程
      checkedlevels: [],
      oneAgentList: [],
      associatedCompanyList: [],
      fileList: [],
      lianqunList: [],
      lianqunListCt: [],
      levels: ['传统产品', 'U血液', 'U试剂', 'U疫苗'],
      checkAll: false,
      isIndeterminate: true,
      havepolicy2017: false,
      have6858: false,
      have6840: false,
      have6854: false,
      have1101: false,
      have2214: false,
      have2215: false,
      have2216: false,
      showhistory: false,
      instid: null,
      companyData: null,
      showflag: false,
      showflag2: false,
      have2: true,
      have3: false,
      options: [],
      value: [],
      listSelect: [],
      addli: [],
      loadingSelect: false,
      states: [],
      qudaoNotMain: [],
      qudao: [],
      salesCity: [],
      isShowMassage: true,
      isShowByHw: true,
      radio: '国内客户',
      fileShowFlag: false,
      uploadflag: true,
      delflag: true,
      refid: this.$util.getUuid(),
      loading: false,
      ind: null,
      index: ['c', 'd', 'i', 'f', 'e', 'w'],   //暂时注释'h',h是邮寄发票信息
      index1: ['c', 'd', 'i', 'f', 'e', '1', '2'], //暂时注释'h',h是邮寄发票信息
      list: ["我是经销商", "我是供应商"],
      fieldList: [
        { name: '医疗创新领域', code: 'L1' },
        { name: '生命科学领域', code: 'L2' }
      ],
      qudaoL1: [],
      qudaoL2: [],
      qudaoCt: [],
      qudaoND5:[],
      qudaoListL1: [],
      ptOptions: [
        { label: '省区', value: '省区' },
        { label: 'KA政企', value: 'KA政企' },
        { label: '大医疗', value: '大医疗' },
        { label: '大项目', value: '大项目' },
        { label: '方案', value: '方案' },
        { label: '产品', value: '产品' },
        { label: '市场部', value: '市场部' }
      ],
      MdmBankconfigInput: {},
      indx: 0,
      mf: {
        pageSize: 10,
        pageNo: 1,
        total: 0,
        userCode: null,
      },

      formLabelAlign1: {
        bscUserInfoAgentBasic: {
          usercode: null,
          customerNumber: null,
          accountGroup: null,// 科目组 , 配置项 , 调接口参数: YlCustomerAccountGroup , 字段输入限制:  0210 集团内客户 0260 海外客户 0280 国内客户 根据客户实际情况传入科目组代码  , 特殊限制:   付款条件销售平台更改
          customerName1: '',// 客户全称1 ,  ,   , 字段输入限制: 客户全名。国内客户要求与证件注册的名称相同 , 特殊限制:   更改账期接口（公司销售视图付款条件字段）
          customerTitle: null,// 客户标题 ,  ,   , 字段输入限制:  公司 先生 女士 先生和夫人 一般公司类客户数据，可以默认传入“公司”  ,
          searchTerm: null,// 搜索项 ,  ,   ,   ,
          postalCode: null,// 邮政编码 ,  ,   ,   ,
          country: null,// 国家代码 , 配置项 , 调接口参数: YlCountry , 字段输入限制: 传入国家的代码，在list中选择 ,
          region: null,// 地区 , 配置项 , 调接口参数: YlRegion , 字段输入限制: 传入地区的代码，在国家代码下的list中选择 ,
          cityStreetRoom: '',// 城市 ,  ,   , 字段输入限制: 客户所在的城市中文名 ,
          streetRoom: null,// 街道 ,  ,   , 字段输入限制: 客户证件上的注册地址 ,
          phoneNumber: null,// 电话 ,  ,   , 字段输入限制: 客户证件上注册的电话，开发票使用 , 特殊限制: 最多16位
          language: null,// 语言代码 , 配置项 , 调接口参数: YlLanguageType , 字段输入限制: 默认传入“ZH” ,
          faxNumber: null,// 传真 ,  ,   ,   , 特殊限制: 最多16位
          contactMobilePhone: null,// 移动电话 ,  ,   ,   , 特殊限制: 最多16位
          companyCodeGeneral: null,// 公司代码(记录0210账户组下客户公司对照关系) , 配置项 , 调接口参数: CompanyCode , 字段输入限制: 当建立集团内客户时，此字段不能为空，需传入集团4位公司代码 ,
          companyCode: null,// 公司代码 , 是否必填: 是 , 是否配置项: 是 , 值集代码: YlCompanyCode , 注释:
          goodsCategory: null,// 商品大类 , 是否必填：否 , 是否配置项：是 , 值集代码：YlGoodsCategory
          taxCode: null,// 纳税人登记号 ,  ,   , 字段输入限制: 客户证件注册的统一信用代码，开发票使用 ,
          name1: null,// 联系人名称 ,  ,   , 字段输入限制: 客户方联系人的名字 ,
          phoneNumber1: null,// 联系人电话1 ,  ,   , 字段输入限制: 客户方联系人的电话 , 特殊限制: 最多16位
          companyAddress: null,// 公司地址名 ,  ,   ,   ,
          contactCity: null,// 联系人城市 ,  ,   ,   ,
          appellation: null,// 称谓 ,  ,   , 字段输入限制:  女士 先生  ,
          partnerFlagSp: null,// 是否有售达方功能,1:有;0:无 ,  ,   , 字段输入限制: 默认传“1” , 特殊限制: 一旦创建不可修改
          partnerFlagSh: null,// 是否有送达方功能,1:有;0:无 ,  ,   , 字段输入限制: 默认传“1” , 特殊限制: 一旦创建不可修改
          partnerFlagBp: null,// 是否有开票方功能,1:有;0:无 ,  ,   , 字段输入限制: 默认传“1” , 特殊限制: 一旦创建不可修改
          partnerFlagPy: null,// 是否有付款方功能,1:有;0:无 ,  ,   , 字段输入限制: 默认传“1” , 特殊限制: 一旦创建不可修改
          cucode: null,//创建人编码
          cuname: null,//创建人名称
          cdate: null,//创建时间
          lucode: null,//修改人编码
          ldate: null,//最后更新时间
          delflag: null,//可用标志。1：可用，0：删除标志
          scale: null,//纳税人规模  0：小规模经营者   1：一般纳税人
          http: null,//公司网址
          companytype: null, //公司性质
          founded: null,//成立时间
          regmoney: null,//注册资本
          legal: null,//法人姓名
          introduce: null,//公司简介
          business: null,//主营
          achievement: null,//业绩
          personnelNum: null,//销售人员数量
          brand: null,//经营其他品牌
          legalPhone: null,//总经理联系方式
          resource: null,//资源
          email: null,//公司邮箱
          remark: null,//备注
          upload1: null,
          upload2: null,
          upload3: null,
          upload5: null,
          upload6: null,
          upload8: null,
          upload9: [],
          agentLevel: null,
          oneLevelAgent: null,
          oneLevelAgentName: null,
          isFenxiao: null,
          signingFenxiao: null,
          associatedCompanyName: null,//关联公司
          associatedCompanyCode: null,
          contractId: null,//经销商签约合同
          contractType: null,//合同类型   //经销商框架合同类型 一级经销商、分销商、专营商、高能合伙人、直单用户、异业联盟、战略合作对应1234567
          isIncrement:null,
          incrementPt:null,
        },
        bscUserInfoAgentBank: {
          usercode: null,//公司编码
          accountHolderName: null,// 银行帐户 ,  ,   , 字段输入限制: 开户许可证上的银行账号 ,
          bankCountry: null,// 银行所属国家 , 配置项 , 调接口参数: YlCountry , 字段输入限制: 从国家列表中选择 ,
          bankBranchCode: null,// 银行码 , 配置项 , 调接口参数: 从MDM开放的银行接口中选择 , 字段输入限制: 从MDM开放的银行接口中选择 ,
          cucode: null,//创建人编码
          cuname: null,//创建人名称
          cdate: null,//创建时间
          lucode: null,//修改人编码
          ldate: null,//最后更新时间
          delflag: null,//可用标志。1：可用，0：删除标志
          vatCode: null,//VAT税号
          bankName: null//银行名称
        },
        bscUserInfoAgentSell: {
          usercode: null,//公司编码
          distributionChannel: null,// 分销渠道 , 配置项 , 调接口参数: YlSalesChannel ,   ,
          division: null,// 产品组 , 配置项 , 调接口参数: YLProductGroup , 字段输入限制: 默认00 ,
          salesGroup: null,// 销售组织 , 配置项 , 调接口参数: YLSalesOrganization ,   ,
          salesRegion: '',// 销售地区 , 配置项 , 调接口参数: YlSalesArea ,   ,
          customerGroup: null,// 客户组(经销商级别) , 配置项 , 调接口参数: YlCustomerGroup , 字段输入限制: 内销必填 ,
          currencyCode: null,// 货币代码 , 配置项 , 调接口参数: YlCurrency ,   ,
          customerPricingProccess: null,// 客户定价过程 , 配置项 , 调接口参数: 默认传1 , 字段输入限制: 默认传1 ,
          customerSummaryGroup: null,// 客户统计组 , 配置项 , 调接口参数: 默认传1 , 字段输入限制: 默认传1 ,
          shipCondition: null,// 装运条件 , 配置项 , 调接口参数: 默认传01 , 字段输入限制: 默认传01 ,
          shipPlant: null,// 交货工厂 , 配置项 , 调接口参数: YlPLPlantCode ,   ,
          accountDistributeGroup: null,// 客户组的帐户分配 , 配置项 , 调接口参数: YlAccountDistributeGroup ,   ,
          custTaxCategory: null,// 客户的税分类 , 配置项 , 调接口参数: 默认传1 , 字段输入限制: 默认传1 ,
          paymentTerms1: null,// 付款条件-未包含在最近模板 , 配置项 , 调接口参数: YlPayTerm , 字段输入限制: 默认传0000 ,
          podRelation: null,// 与 POD 处理相关 ,  ,   , 字段输入限制: 传X或空  默认传空 ,
          orderPossibility: null,// 订单可能性 ,  ,   ,   ,
          intCommercialTerms: null,// 国际贸易条件 , 配置项 , 调接口参数: YlCommercialTerms , 字段输入限制: 外销必填 ,
          intCommercialTerms2: null,// 国际贸易条件(部分2) ,  ,   , 字段输入限制: 外销必填 ,
          fullDelivery: null,// 全部交货 ,  ,   , 字段输入限制: 传X或空  默认传空 ,
          partDelivery: null,// 每个项目允许的部分交货最大数 ,  ,   , 字段输入限制: 默认传9 ,
          orderComposeIdentif: null,// 订单组合标识 ,  ,   , 字段输入限制: 传X或空  默认传X ,
          customerGroup1: null,// 客户组 1(开票类型) , 配置项 , 调接口参数: YlCustomerGroup1 , 字段输入限制: 内销必填 ,
          customerGroup2: null,// 客户组 2(经销商类型) , 配置项 , 调接口参数: YlCustomerGroup2 , 字段输入限制: 内销必填 ,
          customerGroup3: "",// 客户组 3(渠道类型) , 配置项 , 调接口参数: YlCustomerGroup3 , 字段输入限制: 内销必填 ,
          customerGroup3NotMain: "",//客户组 3(渠道类型 非主渠道)
          inEmail: null, //邮箱
          rebate: null,// 回扣 ,  ,   , 字段输入限制: 传X或空  默认传空 ,
          closeRoundingOff: null,// 关闭舍入 ,  ,   , 字段输入限制: 传X或空  默认传空 ,
          permit: null,//资质标识 1二级 2三级
          cucode: null,//创建人编码
          cuname: null,//创建人名称
          cdate: null,//创建时间
          lucode: null,//修改人编码
          ldate: null,//最后更新时间
          delflag: null,//可用标志。1：可用，0：删除标志
          customerAssignGroup: '0210', //客户分配账户组: 10内销-集团内 20内销-集团外
          auditMind1: null, //审核意见
          auditMind2: null, //审核意见
          haveThree6840: null,//   是否包含三类6840(体外诊断试剂)
          licenseNumber: null,//   许可证号
          oneLevelAgent: null,
          invInformation: null,//开票信息
          xkzEffectiveDate: null
        },
        bscUserInfoAgentCompany: {
          usercode: null,//公司编码
          companyCode: null,// 公司代码 , 配置项 , 调接口参数: YlCompanyCode ,   ,
          hq: null,// 总部 ,  ,   ,   ,
          reconcileAccount: null,// 统驭科目 , 配置项 , 调接口参数: YLReconcileAccount , 字段输入限制:  0230、0260、0280账户组默认1122002000 0210默认1122001000  ,
          sequenceNo: null,// 排序码 , 配置项 , 调接口参数: YlOrderCode , 字段输入限制: 默认001 ,
          paymentTerm: null,// 付款条款 , 配置项 , 调接口参数: YlPayTerm , 字段输入限制: 默认0000 ,
          cucode: null,//创建人编码
          cuname: null,//创建人名称
          cdate: null,//创建时间
          lucode: null,//修改人编码
          ldate: null,//最后更新时间
          delflag: null,//可用标志。1：可用，0：删除标志
          mailreceiver: null,//邮寄接收人
          receiverphone: null,//接收人电话
          mailaddress: null,//邮寄地址
        },
        bscUserInfo: {
          usercode: null,//员工编码/公司编码
          password: '',//密码
          usertype: null,//用户类别: 0-内部员工  1-经销商  2-供应商
          username: '',//公司名称/员工姓名username
          email: null,//邮箱
          phone: null,//联系人电话
          deptcode: null,//所属部门编码deptcode  公司用户为空
          userdept: null,//用户详细部门userdept  公司用户为空
          deptname: null,//部门名称deptname  公司用户为空
          firstline: null,//一线经理firstline  公司用户为空
          secondline: null,//二线经理secondline  公司用户为空
          status: null,//用户状态: 0--禁用/冻结  1--正常  2--用户被删除
          organization: null,//公司地址/住址机构
          cdate: null,//创建时间
          ldate: null,//更新时间
          logintimes: null,//登录次数: 记录登录尝试失败次数，登录失败5次就将status改为禁止，联系运维解开
          lastlogintime: null,//最后登录时间: 记录最后登录时间
          accountdate: null,//账户有效期
          area: null,//负责区域
          lucode: null,//更新人编码
          countrytype: null,//1- 国内  /  2- 国外   账户
          fileId: null,
          aaa: null,
          taskid: null,
        },
        bscUserInfoAgentScore: {
          usercode: null,
          customerName1: null, //客户全称1
          staffing: "",
          scale: "",
          qualification: "",
          brandPower: "",
          businessPower: "",
          conclusion: "",
          daquConfirm: "",
          quyuConfirm: "",
        },
        ctList: [{
          field: '',//领域
          channelList: [],//渠道
          channel: '',//渠道
          level: this.priceLevel,//等级
          flType: '',
          num: null,
          lianqun: '',
          lianqunList: [],//链群
          industry:'',
          showLq: false,
        }],
        NA9Channel: '',
        isZc:null,
        NA9List: [{
          channel: '',//渠道
          level: '',//等级
          num: null,
        }],
        levelMap: {},
        contractList: []
      },
      fields: [],
      data: {},
      priceLevel: '',
      check: {
        checkpassword: ''
      },

      rules: {
        //纳税人登记号
        taxCode: [
          { required: this.isShowByHw, message: '请填写必填项', trigger: 'blur' },
        ],
        //银行编号
        bankBranchCode: [
          { required: this.isShowByHw, message: '请填写必填项', trigger: 'blur' },
        ],
        //银行名称
        bankName: [
          { required: this.isShowByHw, message: '请填写必填项', trigger: 'blur' },
        ],
        //银行账户号
        accountHolderName: [
          { required: this.isShowByHw, message: '请填写必填项', trigger: 'blur' },
        ],
        //银行所属国家
        bankCountry: [
          { required: this.isShowByHw, message: '请填写必填项', trigger: 'blur' },
        ],
        username: [
          { required: true, message: '请填写必填项', trigger: 'blur' },
        ],
        isZhidan: [
          { required: true, message: '请填写必填项', trigger: 'blur' },
        ],
        customerGroup1: [
          { required: this.isShowByHw, message: '请填写必填项', trigger: 'blur' },
        ],
        companyAddress: [
          { required: true, message: '请填写必填项', trigger: 'blur' },
        ],
        // email: [
        //   { required: true, message: '请填写公司', trigger: 'blur' },
        //   {
        //     validator: function (rule, value, callback) {
        //       if (
        //         /^([a-zA-Z0-9_\.-]+)@[a-zA-Z0-9\-]{1,256}(\.[a-z]{2,6}){1,2}$/i.test(
        //           value
        //         ) == false
        //       ) {
        //         callback(new Error("邮箱格式错误"));
        //       } else {
        //         callback();
        //       }
        //     },
        //     trigger: "blur"
        //   }
        // ],
        contactCity: [
          { required: true, message: '请填写必填项', trigger: 'blur' },
        ],
        currencyCode: [
          { required: true, message: '请填写必填项', trigger: 'blur' },
        ],
        accountDistributeGroup: [
          { required: true, message: '请填写必填项', trigger: 'blur' },
        ],
        customerGroup2: [
          { required: true, message: '请填写必填项', trigger: 'blur' },
        ],
        customerGroup3: [
          { required: true, message: '请填写必填项', trigger: 'blur' },
        ],
        salesRegion: [
          { required: true, message: '请填写必填项', trigger: 'blur' },
        ],
        distributionChannel: [
          { required: true, message: '请填写必填项', trigger: 'blur' },
        ],
        companyCode: [
          { required: true, message: '请填写必填项', trigger: 'blur' },
        ],
        contactMobilePhone: [
          { required: true, message: '请填写必填项', trigger: 'blur' },
        ],
        //主要业绩
        achievement:
          [
            { required: this.bitian, message: '请填写主要业绩', trigger: 'blur' },
          ],
        //法人代表
        legal:
          [
            { required: this.bitian, message: '请填写法人代表', trigger: 'blur' },
          ],
        //公司性质
        companytype:
          [
            { required: this.bitian, message: '请选择公司性质', trigger: 'change' },
          ],
        //成立时间
        founded:
          [
            { required: this.bitian, type: 'object', message: '请选择成立时间', trigger: 'blur' },
          ],
        //总经理联系方式
        legalPhone:
          [
            { required: this.bitian, message: '请填写总经理联系方式', trigger: 'blur' },
          ],
        //经营其他品牌
        brand:
          [
            { required: this.bitian, message: '请填写经营其他品牌', trigger: 'blur' },
          ],
        //请填写销售人员数量
        personnelNum:
          [
            { required: this.bitian, message: '请填写销售人员数量', trigger: 'blur' },
          ],
        password:
          [
            { required: true, validator: validatePass, trigger: 'blur' },
          ],
        checkpassword:
          [
            { required: true, validator: validatePass2, trigger: 'blur' },
          ],
        customerName1:
          [
            { required: true, message: '请填写必填项', trigger: 'blur' },
          ],
        country:
          [
            { required: true, message: '请填写必填项', trigger: 'blur' },
          ],
        region:
          [
            { required: true, message: '请填写必填项', trigger: 'blur' },
          ],
        cityStreetRoom:
          [
            { required: false, message: '请填写必填项', trigger: 'blur' },
          ],
        streetRoom:
          [
            { required: true, message: '请填写必填项', trigger: 'blur' },
          ],
        isTrade:
          [
            { required: true, message: '请填写必填项', trigger: 'blur' },
          ],
        phoneNumber:
          [
            { required: false, message: '请填写必填项', trigger: 'blur' },
          ],
        name1:
          [
            { required: true, message: '请填写必填项', trigger: 'blur' },
          ],
        phoneNumber1:
          [
            { required: true, message: '请填写必填项', trigger: 'blur' },
          ],
        companyCodeGeneral:
          [
            { required: true, message: '请填写必填项', trigger: 'blur' },
          ],
        reconcileAccount:
          [
            { required: true, message: '请填写必填项', trigger: 'blur' },
          ],
        salesGroup:
          [
            { required: true, message: '请填写必填项', trigger: 'blur' },
          ],
        intCommercialTerms:
          [
            { required: true, message: '请填写必填项', trigger: 'blur' },
          ],
        intCommercialTerms2:
          [
            { required: true, message: '请填写必填项', trigger: 'blur' },
          ],
        upload1:
          [
            { required: this.bitian, message: '请上传资料', trigger: 'blur' },
          ],
        upload2:
          [
            { required: this.bitian, message: '请上传资料', trigger: 'blur' },
          ],
        upload3:
          [
            { required: this.bitian, message: '请上传资料', trigger: 'blur' },
          ],
        upload5:
          [
            { required: this.bitian, message: '请上传资料', trigger: 'blur' },
          ],
        upload6:
          [
            { required: this.bitian, message: '请上传资料', trigger: 'blur' },
          ],
        upload8:
          [
            { required: this.bitian, message: '请上传资料', trigger: 'blur' },
          ],
        licenseNumber: [
          { required: this.bitian, message: '请输入许可证号', trigger: 'blur' },
        ],
        xkzEffectiveDate:
          [
            { required: this.bitian, message: '请选择日期', trigger: 'blur' },
          ],
        yyzzEffectiveDate:
          [
            { required: this.bitian, message: '请选择日期', trigger: 'blur' },
          ],
      },
      rules1: {
        distributionChannel: [
          { required: true, message: '请填写必填项', trigger: 'blur' },
        ],
        accountDistributeGroup: [
          { required: true, message: '请填写必填项', trigger: 'blur' },
        ],
        agentLevel: [
          { required: true, message: '请填写必填项', trigger: 'blur' },
        ],
        oneLevelAgentName: [
          { required: true, message: '请填写必填项', trigger: 'blur' },
        ],
        customerGroup1: [
          { required: true, message: '请填写必填项', trigger: 'blur' },
        ],
        customerGroup2: [
          { required: true, message: '请填写必填项', trigger: 'blur' },
        ],
        customerGroup3: [
          { required: true, message: '请填写必填项', trigger: 'blur' },
        ],
        salesRegion: [
          { required: true, message: '请填写必填项', trigger: 'blur' },
        ],
        auditMind1: [
          { required: true, message: '请填写必填项', trigger: 'blur' },
        ],
        companyCode: [
          { required: true, message: '请填写必填项', trigger: 'blur' },
        ],
        isIncrement: [
          { required: true, message: '请选择必填项', trigger: 'blur' },
        ],
        incrementPt: [
          { required: true, message: '请填写必填项', trigger: 'blur' },
        ],
      },
      flag: '',
      modelList: [],
      agentType: 1,
      rules1Index: ['1', '2', '3'],
      rules1Index1: ['3'],

      reftypeAgent9: '代理商注册-附件',
      fileListAgent9: [],
      idList: [],
      LQcheckList: [],// 选中的链群
      LQList: [],// 渲染链群
      checkLQAfterList: [],// 选中链群之后渲染的列表
      addForm: {},// 链群对象数据
      bankList: [],
      cardName: '总部',
      activeNames: ['1','7']
    }
  },
  created () {
    console.log(this.$route.query, 'query');
    this.getLqList();// 获取链群数据
    this.formLabelAlign1.bscUserInfoAgentBasic.scale = this.data.scaleBas;
    this.findAddress();
    this.isExpandAuthority = 'true'
    this.guanliren = this.$store.getters.hasRole("swyl_admin,swyl_xiaoshoujl_honghu,swyl_xiaoshoujl_hsj,swyl_xiaoshoujl_kangsheng,hh_shichangneiqin,yx_shichangneiqin,swyl_xiaoshoujl_yx,swyl_xiaoshoujl_yx_wx,yx_waimaoneiqin,yx_shouhoujl");
    this.haiwairen = this.$store.getters.hasRole("swyl_waixiaogly,swyl_xiaoshoujl_wx,xiaoshoujingli-waixiao,swyl_haiwailq_xiaoweizhu,hwxsybgly,swyl_xiaoshoujl_wx_hsj,yx_shichangneiqin");
    this.creatNewFlag = this.$store.getters.hasRole("swyl_waixiaogly");
    this.creatAgent = this.$store.getters.hasRole("swyl_xiaoshoujl_kangsheng,swyl_xiaoshoujl_hh,yx_shichangneiqin,swyl_xiaoshoujl_yx,swyl_xiaoshoujl_yx_wx,yx_waimaoneiqin,yx_shouhoujl");
    this.bitian = this.$store.getters.hasRole("swyl_xiaoshoujl_hh,yx_shichangneiqin,swyl_xiaoshoujl_yx,swyl_xiaoshoujl_yx_wx,yx_waimaoneiqin,yx_shouhoujl");
    this.isWh = this.$store.getters.hasRole("swyl_xiaoshoujl_kangsheng,swyl_admin,swyl_xiaoshoujl_hsj,swyl_xiaoshoujl_honghu,swyl_agent_wh,hh_shichangneiqin,yx_shichangneiqin,swyl_xiaoshoujl_yx,swyl_xiaoshoujl_yx_wx,yx_waimaoneiqin,yx_shouhoujl");
    this.admin = this.$store.getters.hasRole("swyl_admin");
    if(this.bitian){
      this.formLabelAlign1.bscUserInfoAgentBank.bankCountry = '';
    }
    ss.Dictservice.listbycategory("sales_region").then(response => {
      console.log(response, "sales_chanle")
      this.qudaoNotMain = response;
      this.qudao = response;
    })
    ss.Dictservice.listbycategory("sales_region_ct").then(response => {
      this.qudaoCt = response;
    })
    ss.Dictservice.listbycategory("sales_region_nd5").then(response => {
      this.qudaoND5 = response;
    })
    //创建经销商进入
    if (this.$route.query.index == '1') {
      this.refid = this.$util.getUuid();
      this.formLabelAlign1.bscUserInfo.fileId = this.refid;
      this.fileShowFlag = true;
      this.formLabelAlign1.bscUserInfoAgentBasic.country = 'CN';
      this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122001000';
      this.formLabelAlign1.bscUserInfoAgentCompany.sequenceNo = '001';
      this.formLabelAlign1.bscUserInfoAgentCompany.paymentTerm = '0000';
      this.formLabelAlign1.bscUserInfoAgentSell.division = '00';
      this.formLabelAlign1.bscUserInfoAgentSell.currencyCode = 'CNY';
      this.formLabelAlign1.bscUserInfoAgentSell.customerPricingProccess = '1';
      this.formLabelAlign1.bscUserInfoAgentSell.customerSummaryGroup = '1';
      this.formLabelAlign1.bscUserInfoAgentSell.shipCondition = '01';
      this.formLabelAlign1.bscUserInfoAgentSell.custTaxCategory = '1';
      this.formLabelAlign1.bscUserInfoAgentSell.paymentTerms1 = '0000';
      this.formLabelAlign1.OperateType = 'CREATE';
      this.formLabelAlign1.OPERATOR = this._user.username;
      this.formLabelAlign1.bscUserInfoAgentBank.bankCountry = 'CN';
      this.formLabelAlign1.bscUserInfoAgentBasic.partnerFlagSp = '1';
      this.formLabelAlign1.bscUserInfoAgentBasic.partnerFlagBp = '1';
      this.formLabelAlign1.bscUserInfoAgentBasic.partnerFlagPy = '1';
      this.formLabelAlign1.bscUserInfoAgentBasic.partnerFlagSh = '1';

      this.agentType = 2;
      this.isShowMassage = true;
      //创建经销商默认是国内经销商  客户分配账户组默认是20(内销集团外)
      this.formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup = '20';
      this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = '0280';
      this.formLabelAlign1.bscUserInfoAgentBasic.country = 'CN';
      this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122002000';
      this.formLabelAlign1.bscUserInfoAgentSell.currencyCode = 'CNY';
      this.formLabelAlign1.bscUserInfoAgentBasic.accountGroup = '0280';
      this.formLabelAlign1.bscUserInfoAgentBasic.agentType = '1';
      this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategory = '';
      ss.Dictservice.listbycategory("sales_region").then(response => {
        console.log(response, "sales_chanle")
        this.options = response;
        this.qudaoNotMain = response;
        this.qudao = response;
      })
      if (this.haiwairen) {
        this.radio = '海外客户';
        this.changeType("海外客户");
      }
    } else if (this.$route.query.index === '2' || this.$route.query.index === '3') {
      this.refid = this.$route.query.fileidInfo;
      this.uploadflag = false;
      this.delflag = false;
      this.fileShowFlag = true;
      if (this.$route.query.agentTypeBas == '3') {
        this.radio = '海外客户';
        this.agentType = 3;
        this.changeType(this.radio);
        // } else if (this.$route.query.customerassigngroupSell === '0280') {
      } else if (this.$route.query.agentTypeBas == '1') {
        this.radio = '国内客户';
        this.agentType = 2;
        this.changeType(this.radio);
        // } else if (this.$route.query.customerassigngroupSell === '0210') {
      } else if (this.$route.query.agentTypeBas == '2') {
        this.radio = '上海直销';
        this.agentType = 1;
      }
      if (this.$route.query.permitSell == 5) {
        this.have2 = true;
        this.have3 = true;
      } else if (this.$route.query.permitSell == 2) {
        this.have2 = true;
      } else if (this.$route.query.permitSell == 3) {
        this.have3 = true;
      }
      console.log("查看");
      if (this.$route.query.statusInfo == 4 || this.$route.query.statusInfo == 5 || this.$route.query.statusInfo == 6) {
        this.queryLevelZc(this.$route.query.customergroupSell);
        this.queryLevelZcList(this.$route.query.customergroupSell);
      } else {
        this.queryLevel(this.$route.query.customergroupSell);
        this.queryLevelList(this.$route.query.customergroupSell);
      }
    } else if (this.$route.query.taskid != null) {
      console.log("审批进入页面")
      console.log(this.$store.getters.roles, 'store')
      for (var i = 0; i < this.$store.getters.roles.length; i++) {
        if (this.$store.getters.roles[i].id == 'swyl_dingdgly') {
          this.isShangWei = true;
          agentCopyService.checkWhatChange(this.$route.query.ywid).then(res => {
            this.changedParamList = res;
            this.userName1 = this.changedParamList.includes("customerName1")
            this.taxCode = this.changedParamList.includes("taxCode")
            this.phoneNumber = this.changedParamList.includes("phoneNumber")
            this.cityStreetRoom = this.changedParamList.includes("cityStreetRoom")
            this.bankBranchCode = this.changedParamList.includes("bankBranchCode")
            this.bankName = this.changedParamList.includes("bankName")
            this.accountHolderName = this.changedParamList.includes("accountHolderName")
            this.bankCountry = this.changedParamList.includes("bankCountry")
            this.customerGroup1 = this.changedParamList.includes("customerGroup1")
            this.mailreceiver = this.changedParamList.includes("mailreceiver")
            this.receiverphone = this.changedParamList.includes("receiverphone")
            this.mailaddress = this.changedParamList.includes("mailaddress")
          })
        }
      }
      var id = this.$route.query.ywid;
      this.instid = this.$route.query.instid;
      this.formLabelAlign1.bscUserInfo.taskid = this.$route.query.taskid;
      // agentCopyService.getNowTask(this.$route.query.taskid).then(res => {
      //     this.isShowSkipLeader = res;
      // });
      console.log(id, "////////////");
      ss.Dictservice.listbycategory("sales_region").then(response => {
        console.log(response, "sales_chanle")
        this.qudaoNotMain = response;
        this.qudao = response;
      })
      agentCopyService.queryOnesh(id).then(response => {
        console.log(response, 'response1111')
        this.data = response.obj;
        this.uploadflag = false;
        this.delflag = false;
        this.rules = {};
        this.flag = '4';
        this.refid = this.data.fileidInfo;
        this.fileShowFlag = true;
        console.log(this.data, "结果如何");
        this.checkDetail();
        console.log(this.refid, 'refid')
        console.log(response.obj.agentTypeBas, "group");

        // if (response.obj.customerassigngroupSell == '0280' || response.obj.agentTypeBas == '1') {
        if (response.obj.agentTypeBas == '1') {
          this.radio = '国内客户';
          this.agentType = 2;
          this.isShowMassage = true;
          //若国内客户没有客户分配账户组  则默认是20(内销集团外)
          if (!response.obj.accountdistributegroupSell || response.obj.accountdistributegroupSell == '') {
            this.formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup = '20';
          }

          // } else if (response.obj.customerassigngroupSell == '0210' || response.obj.agentTypeBas == '2') {
        } else if (response.obj.agentTypeBas == '2') {
          this.radio = '上海直销';
          this.agentType = 1;
          this.isShowMassage = true;
          this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategory = '';
          // } else if (response.obj.customerassigngroupSell == '0260') {
        } else if (response.obj.agentTypeBas == '3') {
          this.radio = '海外客户';
          this.agentType = 3;
          this.isShowMassage = false;
          //若海外客户没有客户分配账户组  则默认是40(外销集团外)
          if (!response.obj.accountdistributegroupSell || response.obj.accountdistributegroupSell == '') {
            this.formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup = '40';
          }
        }
        if (response.obj.permitSell === 5) {
          this.have2 = true;
          this.have3 = true;
        } else if (response.obj.permitSell === 2) {
          this.have2 = true;
        } else if (response.obj.permitSell === 3) {
          this.have3 = true;
        }
        //判断是不是进入的审批审批状态下取暂存表的数据
        if (null != this.$route.query.taskid) {
          //获取审批节点
          ss.taskservice.getTaskByTaskid(this.$route.query.taskid).then(result => {
            console.log("resultresultresult", result.name);
            //如果是新增流程
            if (result.beizhu.indexOf("账号注册") != -1) {
              this.iszhuche = true;
            }
            //判断大区经理审批节点控制审批按钮
            if (result.name == '省区经理审核' || result.name == '大区经理审核' || result.name == '总监审核'
                    || result.name == '网络运营经理'  || result.name == '省区总'  || result.name == '运营管理') {
              this.daquflag = true;
              this.daqujl = true;
              this.lastflag = false;
              this.queryLevelZc(response.obj.customergroupSell);
              this.queryLevelZcList(response.obj.customergroupSell);
            }
            if (result.name == '区域经理审核' || result.name == '渠道经理') {
              this.quyuflag = true;
              this.lianqunList = ["X09", "X01", "X08", "X02", "X10", "X11"];
              //如果为直单产品价格默认为直单
              if (this.isZhiDan == true) {
                this.traditionalProducts = false
                this.isZhidanAgent()
              }
              this.getAgentByContract(response.obj.customername1Bas);
            }
            if (result.name == '传统产品审批' || result.name == 'U血液审批' || result.name == 'U疫苗审批' || result.name == 'U试剂审批') {
              console.log('暂存')
              this.queryLevelZc(response.obj.customergroupSell);
              this.queryLevelZcList(response.obj.customergroupSell);
            }
          })
        } else {
          console.log('经销商', this.levelZc)
          this.queryLevel(response.obj.customergroupSell);
          this.queryLevelList(response.obj.customergroupSell);
        }
        console.log('公司默认赋值', this.formLabelAlign1.bscUserInfoAgentBasic.companyCode)
        //审批页面签约公司默认选择
        if (this.radio == '海外客户' && this.isZhiDan == false
          && this.formLabelAlign1.bscUserInfoAgentBasic.companyCode == null || this.formLabelAlign1.bscUserInfoAgentBasic.companyCode == '') {
          this.formLabelAlign1.bscUserInfoAgentBasic.companyCode = '64W0'
        }
        if (this.radio == '海外客户' && this.isZhiDan == true
          && this.formLabelAlign1.bscUserInfoAgentBasic.companyCode == null || this.formLabelAlign1.bscUserInfoAgentBasic.companyCode == '') {
          this.formLabelAlign1.bscUserInfoAgentBasic.companyCode = '0HL0'
        }
        if (this.radio == '国内客户' && this.formLabelAlign1.bscUserInfoAgentBasic.companyCode == null || this.formLabelAlign1.bscUserInfoAgentBasic.companyCode == '') {
          this.formLabelAlign1.bscUserInfoAgentBasic.companyCode = '0HL0'
          //判断分销商渠道默认值
          this.formLabelAlign1.bscUserInfoAgentSell.distributionChannel = '00'
        }
        //判断分销商渠道默认值
        if (this.radio == '海外客户' && this.isExpandAuthority == false) {
          this.formLabelAlign1.bscUserInfoAgentSell.distributionChannel = 'X1'
        }
        if (this.radio == '海外客户' && this.isExpandAuthority == true || this.radio == '国内客户' && this.isExpandAuthority == true) {
          this.formLabelAlign1.bscUserInfoAgentSell.distributionChannel = '00'
        }
        this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel = this.data.agentLevelBas + ""
      });
    }
    this.formLabelAlign1.bscUserInfoAgentSell.auditMind1 = "";
    ss.UserService.getUserAuth("18").then(rd=>{
      const array = rd.msg;
      const cardMap = {'1S00':'厚宏','1R60':'康盛','1JC0':'航空温控','0PN0':'海盛杰','44U0':'元析'};

      if(this.$store.getters.hasRole('swyl_admin')){

      }else {
        this.cardName = array.find(code => code in cardMap) ? cardMap[array.find(code => code in cardMap)] : '总部';
      }
    })
  },
  beforeRouteLeave (to, from, next) {
    if (to.path == '/agent/agentCopy' && from.path == '/agentDetail' || to.path == '/personal/dealCenter'
    ) {
      to.meta.keepAlive = true;
    } else {
      to.meta.keepAlive = false;
    }
    next();
  },
  methods: {
    findAddress () {
      ss.SignService.selectAddress().then(response => {
        this.addli = response;
      })
    },
    isZhidanAgent () {
      this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel = '4'
      this.ctLevel = '04';
      this.ctSelect();
      //处理链群
      this.lianqunList = ["X09", "X01", "X08", "X02", "X10", "X11"];
      console.log("11111111111", this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategory)
    },

    chooseZhiDan () {
      if (this.isZhiDan) {
        this.formLabelAlign1.bscUserInfoAgentBasic.isZhidan = 1;
        if (this.agentType == '3') {
          if (this.ctLevel != '' && this.ctLevel != null && this.ctLevel != "undefined") {
            this.formLabelAlign1.levelMap['ct'] = '04';
          }
        }
      } else {
        this.isGoverment = false;
        this.formLabelAlign1.bscUserInfoAgentBasic.companytype = "";
        this.formLabelAlign1.bscUserInfoAgentBasic.isZhidan = 0;
        if (this.agentType == '3') {
          if (this.ctLevel != '' && this.ctLevel != null && this.ctLevel != "undefined") {
            this.formLabelAlign1.levelMap['ct'] = '01';
          }
        }
      }
    },
    //是否开通海外下单权限
    chooseAddAbroad () {
      if (this.data.isExpandAuthorityBas) {
        if (this.data.isExpandAuthorityBas == '1') {
          this.isExpandAuthority = true
        } else {
          this.isExpandAuthority = false
        }
        //this.formLabelAlign1.bscUserInfoAgentBasic.isExpandAuthorityBas = 1;
        //this.formLabelAlign1.bscUserInfoAgentBasic.isExpandAuthority = '开通'
      } else {
        if (this.isExpandAuthority == true) {
          this.formLabelAlign1.bscUserInfoAgentBasic.isExpandAuthorityBas = 1;
          this.formLabelAlign1.bscUserInfoAgentBasic.isExpandAuthority = '1';
          console.log("开通权限")
        } else {
          this.formLabelAlign1.bscUserInfoAgentBasic.isExpandAuthorityBas = 0;
          this.formLabelAlign1.bscUserInfoAgentBasic.isExpandAuthority = '0';
          console.log("暂不开通")
        }
      }
    },
    //是否开通体外试剂
    chooseIVD () {
      this.formLabelAlign1.bscUserInfoAgentSell.haveThree6840 = this.haveThree6840? 1: 0
    },
    //是否开通国内下单权限  仅针对海外客户
    chooseDomestic () {
      this.isShowByHw = this.isExpandAuthority
      this.formLabelAlign1.bscUserInfoAgentBasic.isExpandAuthority = this.isExpandAuthority? 1:0
    },
    //是否开通血站 国内和上海特有
    chooseIsBlood () {
      this.formLabelAlign1.bscUserInfoAgentBasic.isBlood = this.isBlood? 1:0;
    },
    chooseGoverment () {
      this.formLabelAlign1.bscUserInfoAgentBasic.companytype = this.isGoverment? '政府/军工企业':'';
    },
    // changeCountry(attr){
    //     if (attr == "CN" || attr == "中国") {
    //        this.shifouTrade = true;
    //     }else{
    //        this.shifouTrade = false;
    //     }
    // },
    changeTrade (attr) {
      if (attr == "1" || attr == "是") {
        this.isShowByHw = true;
      } else {
        this.isShowByHw = false;
      }
    },
    queryLevel (v) {
      agentCopyService.queryLevel(v).then(response => {
        console.log(response, 'levelmap')
        if (response.ct != undefined) {
          this.checkedlevels.push("传统产品");
          this.ctLevel = response.ct;
          this.ct = true;
          if (this.data.iszhidanBas == 1 && this.ctLevel != '' && this.ctLevel != '04') {
            this.ctLevel = '';
          } else {
            this.formLabelAlign1.levelMap['ct'] = this.ctLevel;
          }
        }
      })
    },
    queryLevelZc (v) {
      agentCopyService.queryLevelZc(v).then(response => {
        console.log(response, 'levelmap')
        if (response.ct != undefined) {
          this.checkedlevels.push("传统产品");
          this.ctLevel = response.ct;
          this.ct = true;
          this.formLabelAlign1.levelMap['ct'] = this.ctLevel;
        }
      })
    },

    queryLevelZcList (v) {
      agentCopyService.queryLevelZcList(v).then(response => {
        let filteredObject = {};
        let p = new Set(Object.keys(response));
        let blacklist = ['ct'];
        blacklist.forEach(a => p.delete(a));
        [...p].forEach(k => filteredObject[k] = response[k]);
        this.addForm = filteredObject;
        if (response.ct != undefined) {
          this.checkedlevels.push("传统产品");
          if (response.ct.length >= 1) {
            this.formLabelAlign1.ctList = response.ct;
            for (var item in this.formLabelAlign1.ctList) {
              var m = this.formLabelAlign1.ctList[item].channel.split(',');
              if (m.length <= 0) {
                this.formLabelAlign1.ctList[item].channelList = '';
              } else {
                this.formLabelAlign1.ctList[item].channelList = m;
                //第一个医疗创新,生命科学领域展示链群
                var one = "";
                for (var i = 0; i < this.formLabelAlign1.ctList.length; i++) {
                  if (i == 0) {
                    this.formLabelAlign1.ctList[i].showLq = true;
                    one = this.formLabelAlign1.ctList[i].field
                  }
                  if (this.formLabelAlign1.ctList[i].field != one) {
                    this.formLabelAlign1.ctList[i].showLq = true;
                    break;
                  }
                }
              }
            }
            this.ct = true;
            this.formLabelAlign1.levelMap['ct'] = this.ctLevel;
            this.lianqunListCt.push("ct");
            this.getQudaoCt();
            this.getLianqunTickct(this.lianqunListCt);
          }
        }
      })
    },

    queryLevelList (v) {
      agentCopyService.queryLevelList(v).then(response => {
        let filteredObject = {};
        let p = new Set(Object.keys(response));
        let blacklist = ['ct'];
        blacklist.forEach(a => p.delete(a));
        [...p].forEach(k => filteredObject[k] = response[k]);
        this.addForm = filteredObject;
        if (response.ct != undefined) {
          this.checkedlevels.push("传统产品");
          if (response.ct.length >= 1) {
            this.formLabelAlign1.ctList = response.ct;
            this.lianqunListCt.push("ct");
            this.getLianqunTickct(this.lianqunListCt);
            for (var item in this.formLabelAlign1.ctList) {
              var m = this.formLabelAlign1.ctList[item].channel.split(',');
              if (m.length <= 0) {
                this.formLabelAlign1.ctList[item].channelList = '';
              } else {
                this.formLabelAlign1.ctList[item].channelList = m;
                //第一个医疗创新,生命科学领域展示链群
                var one = "";
                for (var i = 0; i < this.formLabelAlign1.ctList.length; i++) {
                  if (i == 0) {
                    this.formLabelAlign1.ctList[i].showLq = true;
                    one = this.formLabelAlign1.ctList[i].field
                  }
                  if (this.formLabelAlign1.ctList[i].field != one) {
                    this.formLabelAlign1.ctList[i].showLq = true;
                    break;
                  }
                }
              }
            }
            this.ct = true;
            this.getQudaoCt();
            this.formLabelAlign1.levelMap['ct'] = this.ctLevel;
          }
        }
      })
    },

    ctSelect () {
      this.formLabelAlign1.levelMap['ct'] = this.ctLevel;
    },
    handleCheckAllChange (val) {
      console.log(val, '全选')
      if (val) {
        this.ct = true;
      } else {
        this.ct = false;
      }
      this.checkedlevels = val ? this.levels : [];
      this.isIndeterminate = false;

    },
    handleCheckedCitiesChange (value) {
      console.log(value, '级别分类')
      this.ct = false;
      this.formLabelAlign1.levelMap = {};
      for (var i = 0; i < value.length; i++) {
        if (value[i] == '传统产品') {
          this.ct = true;
          this.formLabelAlign1.levelMap['ct'] = this.ctLevel;
        }
      }
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.levels.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.levels.length;
    },
    choseObj2 (obj) {
      console.log(obj)
      this.showflag2 = false;
      if (obj.zhenobj && obj.zhenobj.name) {
        this.formLabelAlign1.bscUserInfoAgentBasic.cityStreetRoom = obj.shengobj.name + ' ' + obj.shiobj.name + ' ' + obj.quobj.name + ' ' + obj.zhenobj.name + ' ' + obj.addrdetail;
      } else {
        this.formLabelAlign1.bscUserInfoAgentBasic.cityStreetRoom = obj.shengobj.name + ' ' + obj.shiobj.name + ' ' + obj.quobj.name + ' ' + obj.addrdetail;
      }
    },
    getChoose (obj) {
      this.showscoretable = obj.showscoretable;
    },

    viewpress () {
      this.showhistory = true;
    },
    pinggu () {
      this.showscoretable = true;
      this.usercodeInfo = this.formLabelAlign1.bscUserInfoAgentBasic.usercode;
    },
    fileBack1 (v) {
      console.log(v)
      this.formLabelAlign1.bscUserInfoAgentBasic.upload5 = v.length;
    },
    fileBack2 (v) {
      console.log(v)
      this.formLabelAlign1.bscUserInfoAgentBasic.upload6 = v.length;
    },
    fileBack3 (v) {
      console.log(v)
      this.formLabelAlign1.bscUserInfoAgentBasic.upload8 = v.length;
    },
    fileBack4 (v) {
      console.log(v)
      this.formLabelAlign1.bscUserInfoAgentBasic.upload9 = v.length;
    },
    fileBack5 (v) {
      console.log(v)
      this.formLabelAlign1.bscUserInfoAgentBasic.upload1 = v.length;
    },
    fileBack6 (v) {
      console.log(v)
      this.formLabelAlign1.bscUserInfoAgentBasic.upload2 = v.length;
    },
    fileBack7 (v) {
      console.log(v)
      this.formLabelAlign1.bscUserInfoAgentBasic.upload3 = v.length;
    },
    fieldSelect (index) {
      this.formLabelAlign1.ctList[index].channelList = '';
      this.fields = [];
      //循环一遍是不是选择了领域
      //如果不是null就不需要在显示链群了
      var isF = true;
      //获取签约的领域
      var ly = []
      for (var i = 0; i < this.formLabelAlign1.ctList.length; i++) {
        if (i != index) {
          ly.push(this.formLabelAlign1.ctList[i].field);
        }
      }
      console.log("ly", ly)
      console.log("this.formLabelAlign1.ctList[index]", this.formLabelAlign1.ctList[index].field)
      if (ly.includes(this.formLabelAlign1.ctList[index].field)) {
        this.formLabelAlign1.ctList[index].showLq = false;
      } else {
        this.formLabelAlign1.ctList[index].showLq = true;
      }
      console.log(this.formLabelAlign1.ctList[index].showLq);
      //更新领域的时候
      for (var i = 0; i < this.formLabelAlign1.ctList.length; i++) {
        if (this.formLabelAlign1.ctList[i].field != null && this.formLabelAlign1.ctList[i].field != '') {
          this.fields.push(this.formLabelAlign1.ctList[i].field);
        }
      }
      //进行强制数据渲染
      this.$forceUpdate();
    },
    handleIconClick () {
      this.showflag = true;
    },
    handleIconClick2 () {
      this.showflag2 = true;
    },
    hasIncludeField (arr = [], item) {
      return arr.includes(item)
    },
    choseObj (obj) {
      console.log(obj)
      this.showflag = false;
      if (obj.zhenobj && obj.zhenobj.name) {
        this.formLabelAlign1.bscUserInfoAgentCompany.mailaddress = obj.shengobj.name + ' ' + obj.shiobj.name + ' ' + obj.quobj.name + ' ' + obj.zhenobj.name + ' ' + obj.addrdetail;
      } else {
        this.formLabelAlign1.bscUserInfoAgentCompany.mailaddress = obj.shengobj.name + ' ' + obj.shiobj.name + ' ' + obj.quobj.name + ' ' + obj.addrdetail;
      }
    },
    changeType (v) {
      this.isExpandAuthority = false
      if (v === '海外客户') {
        this.agentType = 3;
        this.isShowMassage = false;
        this.isShowByHw = false;
        this.formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup = '40';
        this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = '0260';
        this.formLabelAlign1.bscUserInfoAgentBasic.country = '';
        this.formLabelAlign1.bscUserInfoAgentSell.currencyCode = '';
        this.formLabelAlign1.bscUserInfoAgentBank.bankCountry = '';
        this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122002000';
        this.formLabelAlign1.bscUserInfoAgentBasic.accountGroup = '0260';
        this.formLabelAlign1.bscUserInfoAgentBasic.agentType = '3';
        this.formLabelAlign1.bscUserInfoAgentBasic.isZhidan = '1';
        this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategory = '';
        this.creatNewFlag = false;
        //进行强制数据渲染
        this.$forceUpdate();
      } else if (v === '上海直销') {
        this.agentType = 1;
        this.isShowMassage = true;
        this.isShowByHw = true;
        // this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = '0210';
        // // this.formLabelAlign1.bscUserInfoAgentBasic.country = 'CN';
        // this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122001000';
        // this.formLabelAlign1.bscUserInfoAgentSell.currencyCode = 'CNY';
        // this.formLabelAlign1.bscUserInfoAgentBasic.accountGroup = '0210';
        if (!this.formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup || this.formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup == '') {
          this.formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup = '20';
        }
        this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = '0280';
        // this.formLabelAlign1.bscUserInfoAgentBasic.country = 'CN';
        this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122002000';
        this.formLabelAlign1.bscUserInfoAgentSell.currencyCode = 'CNY';
        this.formLabelAlign1.bscUserInfoAgentBasic.accountGroup = '0280';
        this.formLabelAlign1.bscUserInfoAgentBasic.agentType = '2';
        this.creatNewFlag = false;
      } else if (v === '国内客户') {
        this.agentType = 2;
        this.isShowMassage = true;
        this.isShowByHw = true;
        if (!this.formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup || this.formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup == '') {
          this.formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup = '20';
        }
        this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = '0280';
        // this.formLabelAlign1.bscUserInfoAgentBasic.country = 'CN';
        this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122002000';
        this.formLabelAlign1.bscUserInfoAgentSell.currencyCode = 'CNY';
        this.formLabelAlign1.bscUserInfoAgentBasic.accountGroup = '0280';
        this.formLabelAlign1.bscUserInfoAgentBasic.agentType = '1';
        this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategory = '';
        this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3 = '';
        this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain = '';
        this.formLabelAlign1.bscUserInfoAgentSell.salesCity = '';
        this.formLabelAlign1.bscUserInfoAgentBasic.isZhidan = "0";
        this.creatNewFlag = false;
      } else if (v === "维护经销商") {
        this.agentType = 2;
        this.isShowMassage = true;
        this.isShowByHw = true;
        if (!this.formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup || this.formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup == '') {
          this.formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup = '20';
        }
        this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = '0280';
        // this.formLabelAlign1.bscUserInfoAgentBasic.country = 'CN';
        this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122002000';
        this.formLabelAlign1.bscUserInfoAgentSell.currencyCode = 'CNY';
        this.formLabelAlign1.bscUserInfoAgentBasic.accountGroup = '0280';
        this.formLabelAlign1.bscUserInfoAgentBasic.agentType = '1';
        this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategory = '';
        this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3 = '';
        this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain = '';
        this.formLabelAlign1.bscUserInfoAgentSell.salesCity = '';
        this.formLabelAlign1.bscUserInfoAgentBasic.isZhidan = "0";
        this.creatNewFlag = true;
      }
    },
    //大区经理审批推动节点,无更改
    agentPassDaqu () {
      //如果是分销商2.0,新增流程
      if (this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel == 2 && this.iszhuche) {
        this.updateFenxiao();
        return;
      }
      this.formLabelAlign1.bscUserInfo.aaa = 1;
      this.formLabelAlign1.ywid = this.$route.query.ywid;
      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3 = '';
      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain = '';
      this.formLabelAlign1.bscUserInfoAgentSell.salesCity = '';
      this.changDealer(this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel);
      let levelMapNew = JSON.parse(JSON.stringify(this.formLabelAlign1.levelMap))

      let levelObjNew = Object.assign({}, levelMapNew, this.addForm);

      for (let key in levelObjNew) {
        if (key == 'ct') {

        } else {
          if (Array.isArray(levelObjNew[key])) {
            console.log(levelObjNew[key], "是数组")
            levelObjNew[key] = levelObjNew[key].join()
          }
        }
      }
      this.formLabelAlign1.levelMap = levelObjNew;

      var isDs = false;
      //判断地市直营商
      for (var i = 0; i < this.formLabelAlign1.ctList.length; i++) {
        if (this.formLabelAlign1.ctList[i].flType == '06') {
          isDs = true;
        }
      }
      if (isDs) {
        this.$msg.confirm("是否确认签约合同为地市直营商?", () => {
          agentCopyService.agentPassDaqu(this.formLabelAlign1).then(rd => {
            this.$msg.alerts("提交成功！", () => {
              //刷新右上角的代办个数
              this.$store.dispatch("searchTasktotal")
              //跳转回系统的代办列表
              this.$router.push({
                path: '/personal/dealCenter'
              })
            })
          });
        });
      } else {
        agentCopyService.agentPassDaqu(this.formLabelAlign1).then(rd => {
          this.$msg.alerts("提交成功！", () => {
            //刷新右上角的代办个数
            this.$store.dispatch("searchTasktotal")
            //跳转回系统的代办列表
            this.$router.push({
              path: '/personal/dealCenter'
            })
          })
        });
      }
    },
    //大区经理驳回
    agentPassDaquBh () {
      this.formLabelAlign1.bscUserInfo.aaa = 2;
      this.formLabelAlign1.ywid = this.$route.query.ywid;
      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3 = '';
      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain = '';
      this.formLabelAlign1.bscUserInfoAgentSell.salesCity = '';
      agentCopyService.agentPassDaqu(this.formLabelAlign1).then(rd => {
        this.$msg.alerts("提交成功！", () => {
          //刷新右上角的代办个数
          this.$store.dispatch("searchTasktotal")
          //跳转回系统的代办列表
          this.$router.push({
            path: '/personal/dealCenter'
          })
        })
      });
    },

     updatePinggu (formName) {
      //如果是分销2.0
      if (this.isFenxiao2) {
        var agentLevel = this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel;

        if (agentLevel != "2") {
          this.$message({
            message: "经销商类型请选择分销商2.0",
            type: 'error'
          });
        }
        this.update(formName);
        return;
      }
      //先判断一级经销商是否填写引入评估表
      if (this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel == "1" ) {
        let query = { usercode: this.formLabelAlign1.bscUserInfoAgentBasic.usercode }
        ss.SignService.selectScore(query).then(res => {
          if (res.obj == 0) {
            //校验是否经销商类型是否和合同一致
            //获取经销商等级
            var agentLevel = this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel;
            var agentLevely = null;
            var contractType = this.formLabelAlign1.bscUserInfoAgentBasic.contractType;
            if (contractType == 1) {
              agentLevely = '1';
            } else if (contractType == 3) {
              agentLevely = '3';
            } else if (contractType == 2) {
              agentLevely = '2';
            } else if (contractType == 5 || contractType == 6) {
              agentLevely = '4';
            } else if (contractType == 8) {
              agentLevely = '5';
            } else if (contractType == 9) {
              agentLevely = '6';
            } else if (contractType == 4) {
              agentLevely = '8';
            } else if (contractType == 7) {
              agentLevely = '7';
            }else if (contractType == 11) {
              agentLevely = '11';
            }else if (contractType == 12) {
              agentLevely = '12';
            }else if (contractType == 13) {
              agentLevely = '13';
            }else if (contractType == 10) {
              agentLevely = '10';
            }
            if (agentLevely != agentLevel) {
              this.$message({
                message: "当前所选经销商类别和经销商合同类型不匹配!请修改经销商合同或重新选择经销商类别!",
                type: 'error'
              });
              return;
            }
            this.update(formName);
          } else if (res.obj == 1) {
            this.$message({
              message: "请完善代理列表内引入评估表!",
              type: 'error'
            });
            return;
          }else if (res.obj == 3) {
            this.$message({
              message: "引入评估表被驳回,请重新提交!",
              type: 'error'
            });
            return;
          }else if (res.obj == 4) {
            this.$message({
              message: "引入评估表审核中,请审核通过后再提交!",
              type: 'error'
            });
            return;
          }
        })
      } else {
        //校验是否经销商类型是否和合同一致
        //获取经销商等级
        var agentLevel = this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel;
        var agentLevely = null;
        var contractType = this.formLabelAlign1.bscUserInfoAgentBasic.contractType;
        if (contractType == 1) {
          agentLevely = '1';
        } else if (contractType == 3) {
          agentLevely = '3';
        } else if (contractType == 2) {
          agentLevely = '2';
        } else if (contractType == 5 || contractType == 6) {
          agentLevely = '4';
        } else if (contractType == 8) {
          agentLevely = '5';
        } else if (contractType == 9) {
          agentLevely = '6';
        } else if (contractType == 4) {
          agentLevely = '8';
        } else if (contractType == 7) {
          agentLevely = '7';
        }else if (contractType == 11) {
          agentLevely = '11';
        }else if (contractType == 12) {
          agentLevely = '12';
        }else if (contractType == 13) {
          agentLevely = '13';
        }else if (contractType == 10) {
          agentLevely = '10';
        }
        if (agentLevely != agentLevel) {
          this.$message({
            message: "当前所选经销商类别和经销商合同类型不匹配!请修改经销商合同或重新选择经销商类别!",
            type: 'error'
          });
          return;
        }
        this.update(formName);
      }
    },
    //通过审批按钮功能
    update (formName) {
      this.changDealer(this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel)
/*      if (!this.isShangWei) {
        var flag = 0;
        for (var i = 0; i < this.rules1Index.length; i++) {
          this.ind = this.rules1Index[i];
          var form = formName + this.ind;
          this.$refs[form].validate((valid) => {
            if (valid) {

            } else {
              flag = flag + 1;
              return false;
            }
          });
        }
        if (flag !== 0) {
          return false;
        }
      }*/
      var jsonObj = this.lianqunList
      var jStr = '';
      for (var item in jsonObj) {
        jStr += jsonObj[item] + ",";
      }
      this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategory = jStr.substring(0, jStr.lastIndexOf(','))
      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3 = this.qudaos;
      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain = this.qudaosNotMain
      this.formLabelAlign1.bscUserInfoAgentSell.salesCity = this.citys
      this.formLabelAlign1.bscUserInfo.aaa = 1;
      this.formLabelAlign1.bscUserInfo.fileId = this.refid;
      var ctList = this.formLabelAlign1.ctList;
      for (var i = 0; i < ctList.length; i++) {
        var qudaoL = this.getQudaoL(ctList[i].channelList);
        this.formLabelAlign1.ctList[i].channel = qudaoL;
        var lianqunL = this.getQudaoL(ctList[i].lianqunList);
        this.formLabelAlign1.ctList[i].lianqun = lianqunL;
      }
      //处理一下传统的签约链群
      //获取有链群的
      var havaLq = [];
      for (var i = 0; i < ctList.length; i++) {
        if (ctList[i].lianqunList.length > 0) {
          havaLq.push(ctList[i])
        }
      }
      for (var i = 0; i < ctList.length; i++) {
        if (ctList[i].lianqun == null || ctList[i].lianqun == '') {
          for (var item in havaLq) {
            if (ctList[i].field == havaLq[item].field) {
              ctList[i].lianqun = havaLq[item].lianqun
            }
          }
        }
      }
      this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategoryNew = this.LQcheckList.join(',')
      let levelMapNew = JSON.parse(JSON.stringify(this.formLabelAlign1.levelMap))

      let levelObjNew = Object.assign({}, levelMapNew, this.addForm);

      for (let key in levelObjNew) {
        if (key == 'ct') {

        } else {
          if (Array.isArray(levelObjNew[key])) {
            console.log(levelObjNew[key], "是数组")
            levelObjNew[key] = levelObjNew[key].join()
          }
        }
      }
      this.formLabelAlign1.levelMap = levelObjNew;
      console.log(this.formLabelAlign1, "提交修改数据")
      console.log("1111", this.formLabelAlign1);

      var isDs = false;
      //判断地市直营商
      for (var i = 0; i < this.formLabelAlign1.ctList.length; i++) {
        if (this.formLabelAlign1.ctList[i].flType == '06') {
          isDs = true;
        }
      }
      if (isDs) {
        this.$msg.confirm("是否确认签约合同为地市直营商?", () => {
          agentCopyService.agentPass(this.formLabelAlign1).then(response => {
            if (response.f) {
              this.$msg.alerts("提交成功！", () => {
                //刷新右上角的代办个数
                this.$store.dispatch("searchTasktotal")
                //跳转回系统的代办列表
                this.$router.push({ path: '/personal/dealCenter' })
              })
            }
          })
        });
      } else {
        agentCopyService.agentPass(this.formLabelAlign1).then(response => {
          if (response.f) {
            this.$msg.alerts("提交成功！", () => {
              //刷新右上角的代办个数
              this.$store.dispatch("searchTasktotal")
              //跳转回系统的代办列表
              this.$router.push({ path: '/personal/dealCenter' })
            })
          }
        })
      }
    },
    //通过审批按钮功能
    updateFenxiao () {
      // this.formLabelAlign1.bscUserInfo.status = '4';
      // this.modelList.push(this.formLabelAlign1);
      // ss.SignService.update(this.modelList).then(response => {
      //     console.log(response)
      // })
      this.formLabelAlign1.bscUserInfoAgentBasic.isBlood = this.isBlood? 1:0;
      this.formLabelAlign1.bscUserInfo.aaa = 1;
      this.formLabelAlign1.ywid = this.$route.query.ywid;
      // this.formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms = 'CFR';
      // this.formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms2 = 'CIF';
      this.formLabelAlign1.bscUserInfoAgentSell.salesCity = this.citys
      this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategoryNew = this.LQcheckList.join(',')
      let levelMapNew = JSON.parse(JSON.stringify(this.formLabelAlign1.levelMap))
      let levelObjNew = Object.assign({}, levelMapNew, this.addForm);
      for (let key in levelObjNew) {
        if (key == 'ct') {

        } else {
          if (Array.isArray(levelObjNew[key])) {
            console.log(levelObjNew[key], "是数组")
            levelObjNew[key] = levelObjNew[key].join()
          }
        }
      }
      this.formLabelAlign1.levelMap = levelObjNew;
      console.log(this.formLabelAlign1, "提交修改数据")
      console.log("1111", this.formLabelAlign1);

      var isDs = false;
      //判断地市直营商
      for (var i = 0; i < this.formLabelAlign1.ctList.length; i++) {
        if (this.formLabelAlign1.ctList[i].flType == '06') {
          isDs = true;
        }
      }
      if (isDs) {
        this.$msg.confirm("是否确认签约合同为地市直营商?", () => {
          agentCopyService.agentPass2(this.formLabelAlign1).then(rd => {
            this.$msg.alerts("提交成功！", () => {
              //刷新右上角的代办个数
              this.$store.dispatch("searchTasktotal")
              //跳转回系统的代办列表
              this.$router.go(-1);
              // this.$router.push({
              //     path: '/personal/dealCenter'
              // })
            })
          });
        });
      } else {
        agentCopyService.agentPass2(this.formLabelAlign1).then(rd => {
          this.$msg.alerts("提交成功！", () => {
            //刷新右上角的代办个数
            this.$store.dispatch("searchTasktotal")
            //跳转回系统的代办列表
            this.$router.go(-1);
            // this.$router.push({
            //     path: '/personal/dealCenter'
            // })
          })
        });
      }

    },
    //驳回按钮功能
    reject (formName) {
      this.changDealer(this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel)
      var jsonObj = this.lianqunList
      var jStr = '';
      for (var item in jsonObj) {
        jStr += jsonObj[item] + ",";
      }
      this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategory = jStr.substring(0, jStr.lastIndexOf(','))
      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3 = this.qudaos;
      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain = this.qudaosNotMain
      this.formLabelAlign1.bscUserInfoAgentSell.salesCity = this.citys
      var flag = 0;
      for (var i = 0; i < this.rules1Index1.length; i++) {
        this.ind = this.rules1Index1[i];
        var form = formName + this.ind;
        // console.log(form)
        this.$refs[form].validate((valid) => {
          if (valid) {

          } else {
            flag = flag + 1;
            return false;
          }
        });
      }
      if (flag !== 0) {
        return false;
      }
      this.formLabelAlign1.bscUserInfo.aaa = 2;
      agentCopyService.agentPass(this.formLabelAlign1).then(response => {
        if (response.f) {
          this.$msg.alerts("提交成功！", () => {
            //刷新右上角的代办个数
            this.$store.dispatch("searchTasktotal")
            //跳转回系统的代办列表
            this.$router.push({ path: '/personal/dealCenter' })
          })
        }
      })
    },
    //经销商查看功能对应展示数据功能
      checkDetail () {
      console.log("---------------");
      console.log(this.data);
      this.isExpandAuthority = this.data.isExpandAuthority
      this.isBloodBas = this.data.isBloodBas
      this.formLabelAlign1.bscUserInfo.usercode = this.data.usercodeInfo
      this.formLabelAlign1.bscUserInfoAgentBasic.usercode = this.data.usercodeBas? this.data.usercodeBas:this.data.usercodeInfo;
      this.formLabelAlign1.bscUserInfoAgentBank.usercode = this.data.usercodeBank
      this.formLabelAlign1.bscUserInfoAgentCompany.usercode = this.data.usercodeCom
      this.formLabelAlign1.bscUserInfoAgentSell.usercode = this.data.usercodeSell
      this.formLabelAlign1.bscUserInfo.username = this.data.usernameInfo
      this.formLabelAlign1.bscUserInfo.password = this.data.passwordInfo
      this.formLabelAlign1.bscUserInfoAgentBasic.customerName1 = this.data.customername1Bas?this.data.customername1Bas:this.data.usernameInfo;
      if (this.data.scaleBas !== undefined) {
        this.formLabelAlign1.bscUserInfoAgentBasic.scale = this.data.scaleBas + ""
      }
      if (this.data.companyaddressBas && this.data.companyaddressBas != '') {
        this.formLabelAlign1.bscUserInfoAgentBasic.companyAddress = this.data.companyaddressBas
      } else {
        this.formLabelAlign1.bscUserInfoAgentBasic.companyAddress = this.data.streetroomBas
      }
      this.formLabelAlign1.bscUserInfoAgentBasic.isTrade = this.data.isTradeBas
      this.formLabelAlign1.bscUserInfoAgentBasic.postalCode = this.data.postalcodeBas
      this.formLabelAlign1.bscUserInfoAgentBasic.faxNumber = this.data.faxnumberBas
      this.formLabelAlign1.bscUserInfoAgentBasic.http = this.data.httpBas
      this.formLabelAlign1.bscUserInfoAgentBasic.companytype = this.data.companytypeBas
      this.formLabelAlign1.bscUserInfoAgentBasic.isExpandAuthority = this.data.isExpandAuthorityBas
      this.isExpandAuthority = this.data.isExpandAuthorityBas == '1'
      this.formLabelAlign1.bscUserInfoAgentBasic.isBlood = this.data.isBloodBas
      this.isBlood = this.data.isBloodBas == '1'
      this.formLabelAlign1.bscUserInfoAgentBasic.founded = this.data.foundedBas
      this.formLabelAlign1.bscUserInfoAgentBasic.regmoney = this.data.regmoneyBas
      this.formLabelAlign1.bscUserInfoAgentBasic.legal = this.data.legalBas
      this.formLabelAlign1.bscUserInfoAgentBasic.introduce = this.data.introduceBas
      this.formLabelAlign1.bscUserInfoAgentBasic.business = this.data.businessBas
      this.formLabelAlign1.bscUserInfoAgentBasic.achievement = this.data.achievementBas
      this.formLabelAlign1.bscUserInfoAgentBasic.resource = this.data.resourceBas
      this.formLabelAlign1.bscUserInfoAgentBasic.name1 = this.data.name1Bas
      this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber1 = this.data.phonenumber1Bas
      this.formLabelAlign1.bscUserInfoAgentBasic.contactMobilePhone = this.data.contactmobilephoneBas
      //this.formLabelAlign1.bscUserInfoAgentBasic.customerName1 = this.data.customername1Bas
      this.formLabelAlign1.bscUserInfoAgentBasic.cityStreetRoom = this.data.citystreetroomBas
      this.formLabelAlign1.bscUserInfoAgentBasic.streetRoom = this.data.streetroomBas
      this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber = this.data.phonenumberBas
      this.formLabelAlign1.bscUserInfoAgentBasic.postalCode = this.data.postalcodeBas
      this.formLabelAlign1.bscUserInfoAgentBasic.name1 = this.data.name1Bas
      this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber1 = this.data.phonenumber1Bas
      this.formLabelAlign1.bscUserInfoAgentBasic.isZhidan = this.data.iszhidanBas
      this.formLabelAlign1.bscUserInfoAgentBasic.associatedCompanyName = this.data.associatedCompanyNameBas
      this.formLabelAlign1.bscUserInfoAgentBasic.associatedCompanyCode = this.data.associatedCompanyCodeBas
      this.formLabelAlign1.bscUserInfoAgentBasic.contractId = this.data.contractIdBas
      this.formLabelAlign1.bscUserInfoAgentBasic.legalPhone = this.data.legalPhoneBas
      this.formLabelAlign1.bscUserInfoAgentBasic.brand = this.data.brandBas
      this.formLabelAlign1.bscUserInfoAgentBasic.personnelNum = this.data.personnelNumBas

      this.formLabelAlign1.bscUserInfoAgentBasic.remark = this.data.remark
      this.formLabelAlign1.bscUserInfoAgentBasic.agentType = this.data.agentTypeBas
      if (this.data.iszhidanBas == 1) {
        this.isZhiDan = true;
      }
      this.formLabelAlign1.bscUserInfoAgentBank.vatCode = this.data.vatcodeBank
      this.formLabelAlign1.bscUserInfoAgentBank.bankBranchCode = this.data.bankbranchcodeBank
      this.formLabelAlign1.bscUserInfoAgentBank.bankName = this.data.banknameBank
      this.formLabelAlign1.bscUserInfoAgentBank.accountHolderName = this.data.accountholdernameBank
      if (this.data.scaleBas !== undefined) {
        this.formLabelAlign1.bscUserInfoAgentSell.customerGroup1 = this.data.customergroup1Sell
      }
      this.formLabelAlign1.bscUserInfoAgentBasic.email = this.data.emailBas
      this.formLabelAlign1.bscUserInfoAgentCompany.mailreceiver = this.data.mailreceiverCom
      this.formLabelAlign1.bscUserInfoAgentCompany.receiverphone = this.data.receiverphoneCom
      this.formLabelAlign1.bscUserInfoAgentCompany.mailaddress = this.data.mailaddressCom
      this.formLabelAlign1.bscUserInfoAgentSell.auditMind1 = this.data.auditmind1Sell
      this.formLabelAlign1.bscUserInfoAgentSell.auditMind2 = this.data.auditmind2Sell
      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup = this.data.customergroupSell
      this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = this.data.customerassigngroupSell
      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup1 = this.data.customergroup1Sell
      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup2 = this.data.customergroup2Sell
      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3 = this.data.customergroup3Sell
      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain = this.data.customergroup3NotMainSell
      this.formLabelAlign1.bscUserInfoAgentSell.salesRegion = this.data.salesregionSell
      this.formLabelAlign1.bscUserInfoAgentBasic.contactCity = this.data.contactcityBas
      this.formLabelAlign1.bscUserInfoAgentBasic.appellation = this.data.appellationBas
      this.formLabelAlign1.bscUserInfoAgentBasic.country = this.data.countryBas
      this.formLabelAlign1.bscUserInfoAgentBasic.region = this.data.regionBas
      this.formLabelAlign1.bscUserInfoAgentBasic.companyCodeGeneral = this.data.companycodegeneralBas
      this.formLabelAlign1.bscUserInfoAgentBasic.companyCode = this.data.companycodeBas
      this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel = this.data.agentLevelBas
      this.formLabelAlign1.bscUserInfoAgentBasic.oneLevelAgentName = this.data.oneLevelAgentNameBas
      this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategory = this.data.goodsCategoryBas || ''
      this.formLabelAlign1.bscUserInfoAgentBasic.taxCode = this.data.taxcodeBas
      this.formLabelAlign1.bscUserInfoAgentBasic.isFenxiao = this.data.isFenxiaoBas;
      this.isFenxiao = this.data.isFenxiaoBas == '1'
      this.isFenxiao2 = this.data.isFenxiaoBas == '2'
      this.formLabelAlign1.bscUserInfoAgentBasic.statusFenxiao = this.data.statusFenxiaoBas;
      this.formLabelAlign1.bscUserInfoAgentBasic.instidFenxiao = this.data.instidFenxiaoBas;
      this.formLabelAlign1.bscUserInfoAgentBasic.signingFenxiao = this.data.signingFenxiaoBas;
      this.formLabelAlign1.bscUserInfoAgentBasic.isIncrement = this.data.isIncrementBas;
      this.formLabelAlign1.bscUserInfoAgentBasic.incrementPt = this.data.incrementPtBas;
      this.formLabelAlign1.bscUserInfoAgentBank.bankCountry = this.data.bankcountryBank
      this.formLabelAlign1.bscUserInfoAgentSell.distributionChannel = this.data.distributionchannelSell
      this.formLabelAlign1.bscUserInfoAgentSell.salesGroup = this.data.salesgroupSell
      this.formLabelAlign1.bscUserInfoAgentSell.currencyCode = this.data.currencycodeSell
      this.formLabelAlign1.bscUserInfoAgentSell.inEmail = this.data.inEmailSell
      this.formLabelAlign1.bscUserInfoAgentSell.xkzEffectiveDate = this.data.xkzEffectiveDateSell
      this.formLabelAlign1.bscUserInfoAgentSell.yyzzEffectiveDate = this.data.yyzzEffectiveDateSell
      this.formLabelAlign1.bscUserInfoAgentSell.salesCity = this.data.salesCitySell
      if (this.data.accountdistributegroupSell && this.data.accountdistributegroupSell != '') {
        this.formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup = this.data.accountdistributegroupSell
      }
      this.formLabelAlign1.bscUserInfoAgentSell.havepolicy2017 = this.data.havepolicy2017Sell
      this.formLabelAlign1.bscUserInfoAgentSell.have6840 = this.data.have6840Sell
      this.formLabelAlign1.bscUserInfoAgentSell.have6854 = this.data.have6854Sell
      this.formLabelAlign1.bscUserInfoAgentSell.have6858 = this.data.have6858Sell
      this.formLabelAlign1.bscUserInfoAgentSell.have1101 = this.data.have1101Sell
      this.formLabelAlign1.bscUserInfoAgentSell.have2214 = this.data.have2214Sell
      this.formLabelAlign1.bscUserInfoAgentSell.have2215 = this.data.have2215Sell
      this.formLabelAlign1.bscUserInfoAgentSell.have2216 = this.data.have2216Sell
      this.formLabelAlign1.bscUserInfoAgentSell.permit = this.data.permitSell
      this.formLabelAlign1.bscUserInfoAgentSell.licenseNumber = this.data.licenseNumberSell
      this.formLabelAlign1.bscUserInfoAgentSell.invInformation = this.data.invInformation
      if (this.data.agentTypeBas == '3' || this.data.isExpandAuthorityBas == '1') {
        this.formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms = this.data.intcommercialtermsSell;
        this.formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms2 = this.data.intcommercialterms2Sell;
      }
      this.formLabelAlign1.bscUserInfoAgentScore.staffing = this.data.staffingSco
      this.formLabelAlign1.bscUserInfoAgentScore.scale = this.data.scaleSco
      this.formLabelAlign1.bscUserInfoAgentScore.qualification = this.data.qualificationSco
      this.formLabelAlign1.bscUserInfoAgentScore.brandPower = this.data.brandPowerSco
      this.formLabelAlign1.bscUserInfoAgentScore.businessPower = this.data.businessPowerSco
      this.formLabelAlign1.bscUserInfoAgentScore.conclusion = this.data.conclusionSco
      this.formLabelAlign1.bscUserInfoAgentScore.daquConfirm = this.data.daquConfirmSco
      this.formLabelAlign1.bscUserInfoAgentScore.quyuConfirm = this.data.quyuConfirmSco
      this.have6840 = this.data.have6840Sell == 1
      this.have6854 = this.data.have6854Sell == 1
      this.have6858 = this.data.have6858Sell == 1
      this.have1101 = this.data.have1101Sell == 1
      this.have2214 = this.data.have2214Sell == 1
      this.have2215 = this.data.have2215Sell == 1
      this.have2216 = this.data.have2216Sell == 1
      this.havepolicy2017 = this.data.havepolicy2017Sell == 1
      this.formLabelAlign1.bscUserInfoAgentSell.haveThree6840 = this.data.haveThree6840Sell
      this.haveThree6840 = this.data.haveThree6840Sell == 1
      if (this.data.goodsCategoryBas != null && this.data.goodsCategoryBas != '' && typeof (this.data.goodsCategoryBas) != "undefined") {
        let s = this.data.goodsCategoryBas;
        this.getLianquns(s)
        this.getLQs(s)
      }

      if (this.data.customergroup3Sell != null && this.data.customergroup3Sell != '' && typeof (this.data.customergroup3Sell) != "undefined") {
        var s2 = this.data.customergroup3Sell
        var m = s2.split(',');
        if (m.length <= 0) {
          this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3 = ''
        } else {
          this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3 = m
          this.getQudao(this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3)
        }
      }
      if (this.data.customergroup3NotMainSell != null && this.data.customergroup3NotMainSell != '' && typeof (this.data.customergroup3NotMainSell) != "undefined") {
        var s1 = this.data.customergroup3NotMainSell
        var m = s1.split(',');
        if (m.length <= 0) {
          this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain = ''
        } else {
          this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain = m
          this.getQudaoNotMain(this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain)
        }
      }
      if (this.data.salesCitySell != null && this.data.salesCitySell != '' && typeof (this.data.salesCitySell) != "undefined") {
        var s1 = this.data.salesCitySell
        var m = s1.split(',');
        if (m.length <= 0) {
          this.formLabelAlign1.bscUserInfoAgentSell.salesCity = ''
        } else {
          this.formLabelAlign1.bscUserInfoAgentSell.salesCity = m
          this.getCity(this.formLabelAlign1.bscUserInfoAgentSell.salesCity)
        }
      }
      this.agentUpdateFile();
      //获取合同信息
      if (this.agentType != 3) {
        ss.contractService.getContractByUsercode(this.formLabelAlign1.bscUserInfoAgentBasic.usercode).then(rd => {
          if (rd.f) {
            console.log("rd", rd);
            this.formLabelAlign1.contractList = rd.msg;
          }
        })
      }
      if (null != this.formLabelAlign1.bscUserInfoAgentSell.salesRegion && '' != this.formLabelAlign1.bscUserInfoAgentSell.salesRegion) {
        if (this.agentType != 3) {
          this.getAreaCity();
        }
      }
      if(this.$route.query.statusInfo == 5 || this.$route.query.statusInfo == 6){
        this.flag = '5'

        this.fileShowFlag = true;
        this.formLabelAlign1.bscUserInfoAgentBasic.country = 'CN';
        this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122001000';
        this.formLabelAlign1.bscUserInfoAgentCompany.sequenceNo = '001';
        this.formLabelAlign1.bscUserInfoAgentCompany.paymentTerm = '0000';
        this.formLabelAlign1.bscUserInfoAgentSell.division = '00';
        this.formLabelAlign1.bscUserInfoAgentSell.currencyCode = 'CNY';
        this.formLabelAlign1.bscUserInfoAgentSell.customerPricingProccess = '1';
        this.formLabelAlign1.bscUserInfoAgentSell.customerSummaryGroup = '1';
        this.formLabelAlign1.bscUserInfoAgentSell.shipCondition = '01';
        this.formLabelAlign1.bscUserInfoAgentSell.custTaxCategory = '1';
        this.formLabelAlign1.bscUserInfoAgentSell.paymentTerms1 = '0000';
        this.formLabelAlign1.OperateType = 'CREATE';
        this.formLabelAlign1.OPERATOR = this._user.username;
        this.formLabelAlign1.bscUserInfoAgentBank.bankCountry = 'CN';
        this.formLabelAlign1.bscUserInfoAgentBasic.partnerFlagSp = '1';
        this.formLabelAlign1.bscUserInfoAgentBasic.partnerFlagBp = '1';
        this.formLabelAlign1.bscUserInfoAgentBasic.partnerFlagPy = '1';
        this.formLabelAlign1.bscUserInfoAgentBasic.partnerFlagSh = '1';

        this.agentType = 2;
        this.isShowMassage = true;
        //创建经销商默认是国内经销商  客户分配账户组默认是20(内销集团外)
        this.formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup = '20';
        this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = '0280';
        this.formLabelAlign1.bscUserInfoAgentBasic.country = 'CN';
        this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122002000';
        this.formLabelAlign1.bscUserInfoAgentSell.currencyCode = 'CNY';
        this.formLabelAlign1.bscUserInfoAgentBasic.accountGroup = '0280';
        this.formLabelAlign1.bscUserInfoAgentBasic.agentType = '1';
        this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategory = '';
        ss.Dictservice.listbycategory("sales_region").then(response => {
          console.log(response, "sales_chanle")
          this.options = response;
          this.qudaoNotMain = response;
          this.qudao = response;
        })
        if (this.haiwairen) {
          this.radio = '海外客户';
          this.changeType("海外客户");
        }
      }
    },
    getLianquns (s) {
      var m = s.split(',');
      if (m.length <= 0) {
        this.lianqunList = [];
      } else {
        this.lianqunList = m
      }
    },
    getLQs (s) {
      let that = this;
      agentCopyService.getLqSelectList().then(res => {
        that.LQList = res
        var m = s.split(',');
        if (m.length <= 0) {
          that.LQcheckList = []
        } else {
          that.LQcheckList = [...new Set(m)];
          this.LQSelect()
        }
      });
    },
    goBack () {
      this.$router.push({ path: '/agent/agentCopy' })
    },
    insert (formName,type) {
      this.formLabelAlign1.bscUserInfoAgentBasic.signingFenxiao = 0;
      this.formLabelAlign1.bscUserInfoAgentBasic.isFenxiao = 0;
      this.changDealer(this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel)
      this.formLabelAlign1.bscUserInfoAgentSell.salesCity = this.citys
      var flag = 0;
      //非海外经销商注册
      if (this.isShowMassage === true) {
        for (var i = 0; i < this.index.length; i++) {
          this.ind = this.index[i];
          var form = formName + this.ind;
          // console.log(form)
          this.$refs[form].validate((valid) => {
            if (valid) {
              console.log("sdfsd")
            } else {
              flag = flag + 1;
              return false;
            }
          });
        }
        //海外经销商注册
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3 = this.qudaos
        this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain = this.qudaosNotMain
        var indlog = [];
        indlog = this.index1;
        if (this.isShowByHw == false) {
          if (this.formLabelAlign1.bscUserInfoAgentBasic.upload5 == null) {
            indlog = ['c', 'd', 'f', '1', '2', '3'];
          } else {
            indlog = ['c', 'd', 'i', 'f', '1', '2', '3'];
          }
        }
        console.log(indlog);
        console.log("------------------------------");
        for (var i = 0; i < indlog.length; i++) {
          this.ind = indlog[i];
          var form = formName + this.ind;
          console.log(form, "梁婕")
          this.$refs[form].validate((valid) => {
            console.log(valid, "/////////////");
            if (valid) {

            } else {
              flag = flag + 1;
              return false;
            }
          });
        }
      }
      if (flag !== 0) {
        return false;
      }
      // this.loading = true;
      if (this.agentType == '3' && this.formLabelAlign1.bscUserInfoAgentBasic.upload5 > 0) {
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 5;
      } else if (this.have2 === true && this.have3 === false) {
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 2;
      } else if (this.have2 === false && this.have3 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 3;
      } else if (this.have2 === true && this.have3 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 5;
      } else if (this.have2 === false && this.have3 === false) {
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 0;
      } else if (this.agentType == '3') {
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 5;
      }

      if (this.agentType == '3' || this.agentType == '1') {
        if (this.isZhiDan) {
          this.formLabelAlign1.bscUserInfoAgentBasic.isZhidan = '1';
          this.formLabelAlign1.levelMap['ct'] = '04';
        } else {
          this.formLabelAlign1.bscUserInfoAgentBasic.isZhidan = '0';
          this.formLabelAlign1.levelMap['ct'] = '01';
        }
      }

      if (this.agentType == '3') {
        if (!this.isExpandAuthority) {
          this.formLabelAlign1.bscUserInfoAgentBasic.region = this.formLabelAlign1.bscUserInfoAgentBasic.country;
        } else {
          this.formLabelAlign1.bscUserInfoAgentBasic.region = this.formLabelAlign1.bscUserInfoAgentBasic.region;
        }
      } else {
        this.formLabelAlign1.bscUserInfoAgentBasic.region = this.formLabelAlign1.bscUserInfoAgentBasic.region;
      }
      this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber1 = this.formLabelAlign1.bscUserInfoAgentCompany.receiverphone;
      console.log(this.formLabelAlign1, "//////////");
      this.formLabelAlign1.bscUserInfoAgentSell.have6858 = this.have6858? 1:0;
      this.formLabelAlign1.bscUserInfoAgentSell.have6840 = this.have6840? 1:0;
      this.formLabelAlign1.bscUserInfoAgentSell.have6854 = this.have6854? 1:0;
      this.formLabelAlign1.bscUserInfoAgentBasic.isExpandAuthority = this.isExpandAuthority? '1':'0';
      this.formLabelAlign1.bscUserInfoAgentSell.have1101 = this.have1101? 1:0;
      this.formLabelAlign1.bscUserInfoAgentSell.have2214 = this.have2214? 1:0;
      this.formLabelAlign1.bscUserInfoAgentSell.have2215 = this.have2215? 1:0;
      this.formLabelAlign1.bscUserInfoAgentSell.have2216 = this.have2216? 1:0;
      this.formLabelAlign1.bscUserInfoAgentSell.havepolicy2017 = this.havepolicy2017? 1:0;

      this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategoryNew = this.LQcheckList.join(',')
      let levelMapNew = JSON.parse(JSON.stringify(this.formLabelAlign1.levelMap))

      let levelObjNew = Object.assign({}, levelMapNew, this.addForm);

      for (let key in levelObjNew) {
        if (key == 'ct') {

        } else {
          if (Array.isArray(levelObjNew[key])) {
            console.log(levelObjNew[key], "是数组")
            levelObjNew[key] = levelObjNew[key].join()
          }
        }
      }
      this.formLabelAlign1.levelMap = levelObjNew;
      console.log(this.formLabelAlign1, "提交修改数据")


      if (this.formLabelAlign1.bscUserInfoAgentBasic.contactMobilePhone && this.formLabelAlign1.bscUserInfoAgentBasic.contactMobilePhone.length > 16) {
        this.$msg.msge("联系人手机号过长！");
      } else if (this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber && this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber.length > 30) {
        this.$msg.msge("开票电话过长！");
      } else {
        console.log(this.formLabelAlign1)
        if (this.agentType == '3' || this.agentType == '1') {
          ss.SignService.insertGYDls(this.formLabelAlign1).then(response => {
            this.loading = false;
            if (response.f) {
              // this.loading = false;
              this.$message({
                type: "success",
                message: response.msg
              });
              if (this.flag === '1' || this.flag === '3' || this.flag === '4') {
                this.$router.push({ path: '/agent/agentCopy' })
              } else {
                this.$router.push({ path: '/login' })
              }
            } else {
              this.$message({
                type: "error",
                message: response.msg
              });
              this.loading = false;
            }
          })
        } else {
          if (this.creatAgent) {
            //判断是否是暂存
            if(type == '暂存'){
              this.formLabelAlign1.isZc = '暂存'
            }else {
              this.formLabelAlign1.isZc = '提交'
            }
            //康盛创建用新的审批流
            ss.SignService.insertKs(this.formLabelAlign1).then(response => {
              this.loading = false;
              if (response.f) {
                // this.loading = false;
                this.$message({
                  type: "success",
                  message: response.msg
                });
                if (this.flag === '1' || this.flag === '3' || this.flag === '4' || this.flag === '5') {
                  this.$router.push({ path: '/agent/agentCopy' })
                } else {
                  this.$router.push({ path: '/login' })
                }
              } else {
                this.$message({
                  type: "error",
                  message: response.msg
                });
                this.loading = false;
              }
            })
          } else {
            ss.SignService.insertDls(this.formLabelAlign1).then(response => {
              this.loading = false;
              if (response.f) {
                // this.loading = false;
                this.$message({
                  type: "success",
                  message: response.msg
                });
                if (this.flag === '1' || this.flag === '3' || this.flag === '4') {
                  this.$router.push({ path: '/agent/agentCopy' })
                } else {
                  this.$router.push({ path: '/login' })
                }
              } else {
                this.$message({
                  type: "error",
                  message: response.msg
                });
                this.loading = false;
              }
            })
          }
        }
      }
    },
    saveGYDls (formName) {
      this.changDealer(this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel)
      if (this.formLabelAlign1.bscUserInfoAgentBasic.customerName1 == '') {
        this.$msg.msge("请输入客户名称！");
        return false;
      }


      if (this.agentType == '3' && this.formLabelAlign1.bscUserInfoAgentBasic.upload5 > 0) {
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 5;
      } else if (this.have2 === true && this.have3 === false) {
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 2;
      } else if (this.have2 === false && this.have3 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 3;
      } else if (this.have2 === true && this.have3 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 5;
      } else if (this.have2 === false && this.have3 === false) {
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 0;
      } else if (this.agentType == '3') {
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 5;
      }

      if (this.agentType == '3') {
        if (this.isExpandAuthority) {
          this.formLabelAlign1.bscUserInfoAgentBasic.isExpandAuthority = '1';
        } else {
          this.formLabelAlign1.bscUserInfoAgentBasic.isExpandAuthority = '0';
        }
        if (this.isZhiDan) {
          this.formLabelAlign1.bscUserInfoAgentBasic.isZhidan = '1';
          this.formLabelAlign1.levelMap['ct'] = '04';
        } else {
          this.formLabelAlign1.bscUserInfoAgentBasic.isZhidan = '0';
          this.formLabelAlign1.levelMap['ct'] = '01';
        }
      }
      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3 = this.qudaos
      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain = this.qudaosNotMain
      this.formLabelAlign1.bscUserInfoAgentSell.salesCity = this.citys
      if (this.agentType == '3') {
        if (!this.isExpandAuthority) {
          this.formLabelAlign1.bscUserInfoAgentBasic.region = this.formLabelAlign1.bscUserInfoAgentBasic.country;
        } else {
          this.formLabelAlign1.bscUserInfoAgentBasic.region = this.formLabelAlign1.bscUserInfoAgentBasic.region;
        }
      } else {
        this.formLabelAlign1.bscUserInfoAgentBasic.region = this.formLabelAlign1.bscUserInfoAgentBasic.region;
      }

      this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber1 = this.formLabelAlign1.bscUserInfoAgentCompany.receiverphone;
      console.log(this.formLabelAlign1, "//////////");
      if (this.have6858 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.have6858 = 1;
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.have6858 = 0;
      }
      if (this.have6840 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.have6840 = 1;
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.have6840 = 0;
      }
      if (this.have6854 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.have6854 = 1;
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.have6854 = 0;
      }
      if (this.have1101 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.have1101 = 1;
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.have1101 = 0;
      }
      if (this.have2214 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.have2214 = 1;
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.have2214 = 0;
      }
      if (this.have2215 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.have2215 = 1;
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.have2215 = 0;
      }
      if (this.have2216 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.have2216 = 1;
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.have2216 = 0;
      }
      if (this.havepolicy2017 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.havepolicy2017 = 1;
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.havepolicy2017 = 0;
      }

      if (this.formLabelAlign1.bscUserInfoAgentBasic.contactMobilePhone && this.formLabelAlign1.bscUserInfoAgentBasic.contactMobilePhone.length > 16) {
        this.$msg.msge("联系人手机号过长！");
      } else if (this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber && this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber.length > 30) {
        this.$msg.msge("开票电话过长！");
      } else {
        if (this.isExpandAuthority) {
          this.formLabelAlign1.bscUserInfoAgentBasic.isExpandAuthority = '1';
        } else {
          this.formLabelAlign1.bscUserInfoAgentBasic.isExpandAuthority = '0';
        }
        ss.SignService.saveGYDls(this.formLabelAlign1).then(response => {
          this.loading = false;
          if (response.f) {
            // this.loading = false;
            this.$message({
              type: "success",
              message: response.msg
            });
            if (this.flag === '1' || this.flag === '3' || this.flag === '4') {
              this.$router.push({ path: '/agent/agentCopy' })
            } else {
              this.$router.push({ path: '/login' })
            }
          } else {
            this.$message({
              type: "error",
              message: response.msg
            });
            this.loading = false;
          }
        })
      }
    },
    //用户直接添加经销商
    insertCreat (formName) {
      var flag = 0;
      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3 = this.qudaos;
      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain = this.qudaosNotMain
      this.formLabelAlign1.bscUserInfoAgentSell.salesCity = this.citys
      //非海外经销商注册
      if (this.isShowMassage === true) {
        for (var i = 0; i < this.index.length; i++) {
          this.ind = this.index[i];
          var form = formName + this.ind;
          console.log(form,'进这个数据结构了吗')
          this.$refs[form].validate((valid) => {
            if (valid) {

            } else {
              flag = flag + 1;
              return false;
            }
          });
        }
        var ctList = this.formLabelAlign1.ctList;
        for (var i = 0; i < ctList.length; i++) {
          var qudaoL = this.getQudaoL(ctList[i].channelList);
          this.formLabelAlign1.ctList[i].channel = qudaoL;
          var lianqunL = this.getQudaoL(ctList[i].lianqunList);
          this.formLabelAlign1.ctList[i].lianqun = lianqunL;
        }
        //海外经销商注册
      } else {
        if (this.isShowByHw == false) {
          this.index1 = ['c', 'd', 'i', 'f', '1', '2'];
        }
        console.log(this.index1);
        console.log("------------------------------");
        for (var i = 0; i < this.index1.length; i++) {
          this.ind = this.index1[i];
          var form = formName + this.ind;
          console.log(form, "梁婕")
          this.$refs[form].validate((valid) => {
            console.log(valid, "/////////////");
            if (valid) {

            } else {
              flag = flag + 1;
              return false;
            }
          });
        }
      }
      if (flag !== 0) {
        return false;
      }
      // this.loading = true;
      if (this.agentType == '3' && this.formLabelAlign1.bscUserInfoAgentBasic.upload5 > 0) {
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 5;
      } else if (this.have2 === true && this.have3 === false) {
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 2;
      } else if (this.have2 === false && this.have3 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 3;
      } else if (this.have2 === true && this.have3 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 5;
      } else if (this.have2 === false && this.have3 === false) {
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 0;
      } else if (this.agentType == '3') {
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 5;
      }

      if (this.agentType == '3') {
        //海外经销商指只会是直销
        this.formLabelAlign1.bscUserInfoAgentBasic.isZhidan = '1';
        // if (this.formLabelAlign1.bscUserInfoAgentBasic.isZhidan && this.formLabelAlign1.bscUserInfoAgentBasic.isZhidan == '1') {
        this.formLabelAlign1.levelMap['ct'] = '04';
      }

      if (this.agentType == '3') {
        this.formLabelAlign1.bscUserInfoAgentBasic.region = this.formLabelAlign1.bscUserInfoAgentBasic.country;
      }
      this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber1 = this.formLabelAlign1.bscUserInfoAgentCompany.receiverphone;
      if (this.have6858 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.have6858 = 1;
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.have6858 = 0;
      }
      if (this.have6840 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.have6840 = 1;
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.have6840 = 0;
      }
      if (this.have6854 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.have6854 = 1;
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.have6854 = 0;
      }
      console.log(this.formLabelAlign1, "//////////");
      var jsonObj = this.lianqunList
      var jStr = '';
      for (var item in jsonObj) {
        jStr += jsonObj[item] + ",";
      }
      this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategoryNew = this.LQcheckList.join(',')
      let levelMapNew = JSON.parse(JSON.stringify(this.formLabelAlign1.levelMap))

      let levelObjNew = Object.assign({}, levelMapNew, this.addForm);

      for (let key in levelObjNew) {
        if (key == 'ct') {

        } else {
          if (Array.isArray(levelObjNew[key])) {
            console.log(levelObjNew[key], "是数组")
            levelObjNew[key] = levelObjNew[key].join()
          }
        }
      }
      this.formLabelAlign1.levelMap = levelObjNew;
      console.log(this.formLabelAlign1, "提交修改数据")

      this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategory = jStr.substring(0, jStr.lastIndexOf(','))
      if (this.formLabelAlign1.bscUserInfoAgentBasic.contactMobilePhone && this.formLabelAlign1.bscUserInfoAgentBasic.contactMobilePhone.length > 16) {
        this.$msg.msge("联系人手机号过长！");
      } else if (this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber && this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber.length > 30) {
        this.$msg.msge("开票电话过长！");
      } else {
        //判断编码是否维护
        if (this.formLabelAlign1.bscUserInfoAgentBasic.usercode == null || this.formLabelAlign1.bscUserInfoAgentBasic.usercode == '') {
          this.$msg.msge("客户编码请维护88码！");
          return
        }
        ss.SignService.insertXjDls(this.formLabelAlign1).then(response => {
          this.loading = false;
          if (response.f) {
            // this.loading = false;
            this.$message({
              type: "success",
              message: response.msg
            });
            this.$router.push({ path: '/agent/agentCopy' })
          } else {
            this.$message({
              type: "error",
              message: response.msg
            });
            this.loading = false;
          }
        })
      }
    },
    go (index) {
      this.indx = index;
    },
    handleRemove (file, fileList) {
      console.log(file, fileList);
    },
    handlePreview (file) {
      console.log(file);
    },
    getAreaCity () {
      let areas = this.formLabelAlign1.bscUserInfoAgentSell.salesRegion.split(",");
      console.log(areas, "areasareasareasareasareasareas")
      let ss1 = [];
      let promises = []; // 创建一个存储异步操作的Promise数组
      for (var i = 0; i < areas.length; i++) {
        let promise = ss.Dictservice.getDictByCateCode("YlSalesArea_chanpin", areas[i])
          .then(response => {
            ss1.push(response.refid);
          });
        promises.push(promise); // 将每个异步操作的Promise添加到数组中
      }

      Promise.all(promises) // 等待所有异步操作完成
        .then(() => {
          var s2 = ss1.join(",");
          ss.UserService.getCityByArea(s2).then(rd => {
            this.salesCity = rd.msg;
          });
        });
    },
    beforeRemove (file) {
      if (file && file.status === "success") {
        return this.$confirm(`确定移除 ${file.name}？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        });
      }
    },
    beforeUpload (file) {
      const isFile = file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'application/pdf';
      const isLt5M = file.size / 1024 / 1024 < 5;
      console.log(isFile, file.type)

      if (!isFile) {
        this.$message.error('上传文件的格式只能是 JPG或PNG或PDF 格式!');
        return false;
      }
      if (!isLt5M) {
        this.$message.error('上传文件的大小不能超过 5M!');
        return false;
      }
    },
    toLogin () {
      this.$router.push({ path: '/login' })
    },
    //公司代码改变回掉
    companyCodeChange (obj) {
      console.log("obj", obj);
      console.log("obj", this.formLabelAlign1.bscUserInfoAgentBasic.companyCode);
      //经销商签约公司增加1RK0,前台选择1RK0时内销经销商,默认带出9390,9370,外销默认带出,9390,6200,其他公司不做处理
      if (obj && obj.length > 0) {
        let bool = false;
        for (let item of obj) {
          if (item.code == '1RK0') {
            bool = true;
          }
        }
        if (bool) {
          let s = this.formLabelAlign1.bscUserInfoAgentBasic.companyCode;
          s = s.split(',');
          console.log("s", this.agentType);
          if (s && s.length > 0 && s[s.length - 1] == '1RK0') {
            if (s.findIndex(item => item == 9390) == -1) {
              s.push("9390");
            }
            if (this.agentType == 2) { //内销判断9370
              if (s.findIndex(item => item == '0HL0') == -1) {
                s.push("0HL0");
              }
            }
            if (this.agentType == 3) { //外销判断6200
              if (s.findIndex(item => item == '64W0') == -1) {
                s.push("64W0");
              }
            }
            var codes = s.join(",");
            this.formLabelAlign1.bscUserInfoAgentBasic.companyCode = codes;
          }
        }
      }
      /*  if (obj && obj.length > 0) {
          let bool = false;
          for (let item of obj) {
            if (item.code == '9390') {
              bool = true;
            }
          }
          if (bool) {
            this.isShowAllSelect = true;//判断是否展示全部群连并checkbox
            let s = this.formLabelAlign1.bscUserInfoAgentBasic.companyCode;
            s = s.split(',');
            if (s && s.length > 0 && s[s.length - 1] == '9390') {
              ss.Dictservice.listbycategory('YlGoods_category').then(res => {
                let arr = []
                for (let item of res) {
                  arr.push(item.code)
                }
                this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategory = arr.toString() || '';
              })
            }

          } else {
            this.isShowAllSelect = false;//判断是否展示全部群连并checkbox
          }
        } else {
          this.isShowAllSelect = false;//判断是否展示全部群连并checkbox
          this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategory = '';
        }*/
    },
    showAgentList (value) {
      ss.UserService.selectAgentByName(value).then(rd => {
        console.log(rd);
        this.oneAgentList = rd.msg;
      })
      this.isShowAllSelect = false
      this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategory = '';
      this.lianqunList = [];
    },
    addIndustry(){
      //判断是不是选择了领域
      for (var i = 0; i < this.formLabelAlign1.ctList.length; i++) {
        if (this.formLabelAlign1.ctList[i].field == null || this.formLabelAlign1.ctList[i].field == ''
            || this.formLabelAlign1.ctList[i].channelList == null || this.formLabelAlign1.ctList[i].channelList == ''
            || this.formLabelAlign1.ctList[i].level == null || this.formLabelAlign1.ctList[i].level == ''
        ) {
          this.$msg.msge("请先完善后在新增!")
          return;
        }
      }
      this.formLabelAlign1.ctList.push({
        field: '',//领域
        channel: '',//渠道
        channelList: [],//渠道
        level: '',//等级
        num: null,
        lianqun: '',
        lianqunList: [],//链群
      })
      console.log(this.formLabelAlign1.ctList.length)
      this.fields = [];
      for (var i = 0; i < this.formLabelAlign1.ctList.length; i++) {
        if (this.formLabelAlign1.ctList[i].field != null && this.formLabelAlign1.ctList[i].field != '') {
          this.fields.push(this.formLabelAlign1.ctList[i].field);
        }
      }
    },
    deleteIndustry(index){
      if (this.formLabelAlign1.ctList.length != 1) {
        this.formLabelAlign1.ctList.splice(this.formLabelAlign1.ctList.length - 1, 1)
        this.fields = [];
        for (var i = 0; i < this.formLabelAlign1.ctList.length; i++) {
          console.log(this.formLabelAlign1.ctList[i].field)
          if (this.formLabelAlign1.ctList[i].field != null && this.formLabelAlign1.ctList[i].field != '') {
            this.fields.push(this.formLabelAlign1.ctList[i].field);
          }
        }
      }
    },
    addCtList () {
      //判断是不是选择了领域
      for (var i = 0; i < this.formLabelAlign1.ctList.length; i++) {
        if (this.formLabelAlign1.ctList[i].field == null || this.formLabelAlign1.ctList[i].field == ''
          || this.formLabelAlign1.ctList[i].channelList == null || this.formLabelAlign1.ctList[i].channelList == ''
          || this.formLabelAlign1.ctList[i].level == null || this.formLabelAlign1.ctList[i].level == ''
        ) {
          this.$msg.msge("请先完善后在新增!")
          return;
        }
      }
      this.formLabelAlign1.ctList.push({
        field: '',//领域
        channel: '',//渠道
        channelList: [],//渠道
        level: '',//等级
        num: null,
        lianqun: '',
        lianqunList: [],//链群
      })
      console.log(this.formLabelAlign1.ctList.length)
      this.fields = [];
      for (var i = 0; i < this.formLabelAlign1.ctList.length; i++) {
        if (this.formLabelAlign1.ctList[i].field != null && this.formLabelAlign1.ctList[i].field != '') {
          this.fields.push(this.formLabelAlign1.ctList[i].field);
        }
      }
    },
    deleteCtList () {
      if (this.formLabelAlign1.ctList.length != 1) {
        this.formLabelAlign1.ctList.splice(this.formLabelAlign1.ctList.length - 1, 1)
        this.fields = [];
        for (var i = 0; i < this.formLabelAlign1.ctList.length; i++) {
          console.log(this.formLabelAlign1.ctList[i].field)
          if (this.formLabelAlign1.ctList[i].field != null && this.formLabelAlign1.ctList[i].field != '') {
            this.fields.push(this.formLabelAlign1.ctList[i].field);
          }
        }
      }
    },
    changeAgent (value) {
      console.log(value)
      this.formLabelAlign1.bscUserInfoAgentSell.salesRegion = value.salesRegion
      this.formLabelAlign1.bscUserInfoAgentSell.salesGroup = value.salesGroup
      this.formLabelAlign1.bscUserInfoAgentSell.saleChannel = value.saleChannel
      this.formLabelAlign1.bscUserInfoAgentSell.distributionChannel = value.distributionChannel

      this.formLabelAlign1.bscUserInfoAgentSell.companyCode = value.companyCode
      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup2 = value.customerGroup2
      this.formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup = value.accountDistributeGroup + ""
      this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategory = value.goodsCategory
      if (value.goodsCategory == '') {
        this.lianqunList = []
      }
      this.formLabelAlign1.bscUserInfoAgentBasic.companyCode = value.companyCode
      this.formLabelAlign1.bscUserInfoAgentBasic.oneLevelAgent = value.usercode
      this.formLabelAlign1.bscUserInfoAgentBasic.oneLevelAgentName = value.customerName

      if (value.customerGroup3 != null && value.customerGroup3 != '') {
        let s = value.customerGroup3
        var m = s.split(',');
        if (m.length <= 0) {
          this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3 = ''
          this.qudao = []
        } else {
          this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3 = m
          this.getQudao(m)
        }
      }

      if (value.customerGroup3NotMain != null && value.customerGroup3NotMain != '') {
        let s = value.customerGroup3NotMain
        var m = s.split(',');
        if (m.length <= 0) {
          this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain = ''
        } else {
          this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain = m
          this.getQudaoNotMain(m)
          console.log(this.qudaoNotMain)
        }
      }
      this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategory = value.goodsCategory
      let s = value.goodsCategory
      if (s != null && s != '' && typeof (s) != "undefined") {
        this.getLianquns(s)
        this.getLQs(s)
        this.lianqunOptions(s)
      }

    },
    changDealer (value) {
      this.ctSelect()
    },

    changDealer1 (value) {
      console.log(value.code, "value")
      console.log("this.ctLevel", this.ctLevel);
      if (value.code == 4 || value.code == 7 || value.code == 8) {
        this.isZhiDan = true;
        this.data.iszhidanBas = '1'
        this.formLabelAlign1.bscUserInfoAgentBasic.isZhidan = 1;
      } else {
        this.isZhiDan = false;
        this.data.iszhidanBas = ''
        this.formLabelAlign1.bscUserInfoAgentBasic.isZhidan = 0;
        if (this.formLabelAlign1.ctList.length >= 1) {
          for (var item in this.formLabelAlign1.ctList) {
            if (this.formLabelAlign1.ctList[item].level != null && this.formLabelAlign1.ctList[item].channel != null
              && this.formLabelAlign1.ctList[item].level != '' && this.formLabelAlign1.ctList[item].channel != ''
            ) {
              if (this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel == '3') {
                this.formLabelAlign1.ctList[item].flType = '';
              }
            }
          }
        }
      }
      if (value.code == 1) {
        if (this.ctLevel != '' && this.ctLevel != null && this.ctLevel != "undefined") {
          this.ctLevel = '01';
        }
      } else if (value.code == 2) {
        if (this.ctLevel != '' && this.ctLevel != null && this.ctLevel != "undefined") {
          this.ctLevel = '05';
        }
      } else if (value.code == 3) {
        if (this.ctLevel != '' && this.ctLevel != null && this.ctLevel != "undefined") {
          this.ctLevel = '02';
        }
      } else if (value.code == 4) {
        if (this.ctLevel != '' && this.ctLevel != null && this.ctLevel != "undefined") {
          this.ctLevel = '04';
        }
      }
      this.ctSelect()
    },
    lianqunOptions (value) {
      if (value.indexOf("X02") != -1 || value.indexOf("X01") != -1
        || value.indexOf("X08") != -1 || value.indexOf("X09") != -1
        || value.indexOf("X10") != -1 || value.indexOf("X07") != -1
        || value.indexOf("X11") != -1) {
      } else {
        this.formLabelAlign1.ctList = [{
          field: '',//领域
          channel: '',//渠道
          channelList: [],//渠道
          level: this.priceLevel,//等级
          num: null,
          lianqun: '',
          lianqunList: [],//链群
        }];
      }
    },
    getLianqunTickct (query) {
      console.log("lianquns", query);
      this.isCt = true;
      if (query.indexOf("ct") != -1) {
        this.isCt = true;
      } else {
        this.isCt = false;
        this.formLabelAlign1.ctList = [{
          field: '',//领域
          channel: '',//渠道
          channelList: [],//渠道
          level: this.priceLevel,//等级
          num: null,
          lianqun: '',
          lianqunList: [],//链群
        }]
      }
    },
    getQudao (value) {
      var jsonObj = value
      var jStr = '';
      for (var item in jsonObj) {
        jStr += jsonObj[item] + ",";
      }
      this.qudaos = jStr.substring(0, jStr.lastIndexOf(','))
    },
    getQudaoL (value) {
      var jsonObj = value
      var jStr = '';
      for (var item in jsonObj) {
        jStr += jsonObj[item] + ",";
      }
      return jStr.substring(0, jStr.lastIndexOf(','))
    },
    getQudaoCt (qudaos) {
      console.log("qudao", qudaos)
      this.qudaoListL1 = [];
      //获取所有渠道
      var jso = this.formLabelAlign1.ctList;
      for (var item in jso) {
        var jsoElement = jso[item].channelList;
        for (var item in jsoElement) {
          this.qudaoListL1.push(jsoElement[item])
        }
      }
      this.formLabelAlign1.beUpdate++;
      console.log("qudaoListL1", this.qudaoListL1)
    },
    getQudaoNotMain (value) {
      console.log(value)
      var jsonObj = value
      var jStr = '';
      for (var item in jsonObj) {
        jStr += jsonObj[item] + ",";
        console.log(jsonObj[item])
      }
      this.qudaosNotMain = jStr.substring(0, jStr.lastIndexOf(','))
    },
    getCity (value) {
      this.citys = value.join(",")
      console.log(this.citys);
    },
    hasInclude (arr = [], item) {
      return arr.includes(item)
    },
    showAssociationAgent (value) {
      console.log('value', value);
      agentCopyService.getOverseasAgent(value).then(rd => {
        console.log(rd);
        this.associatedCompanyList = rd.obj;
      })
    },
    changeAssociationAgent (value) {
      this.formLabelAlign1.bscUserInfoAgentBasic.associatedCompanyName = value.username;
      this.formLabelAlign1.bscUserInfoAgentBasic.associatedCompanyCode = value.usercode;
    },
    httpRequestAgent1 (params) {
      // console.log(params,"1111111111")
      const loading = this.$msg.loading("上传中...");
      uploadFile.upload(params.file, { companycode: this.refid, reftype: this.reftypeAgent9 }).then(rd => {
        console.log("上传完毕后", rd);
        loading.close();
        this.fileListAgent9.unshift(rd.obj);
        this.idList.push(rd.obj.id);
        this.formLabelAlign1.bscUserInfoAgentBasic.upload9.unshift("1");
      }).catch(error => {
        alert(1111)
        loading.close();
        this.fileListAgent9.splice(0, 1);
        return Promise.reject(error);
      });
      return false;
    },
    handleRemoveAgent1 (file) {
      console.log(file, "aaaaa");
      //删除文件
      var id = file.id;
      uploadFile.deleteById(id).then(response => {
        // console.log(response,"删除")
      })
      //删除fileList数据
      // console.log(this.fileList);
      for (var i = 0; i < this.fileListAgent9.length; i++) {
        if (this.fileListAgent9[i].id === id) {
          this.fileListAgent9.splice(i, 1);
          // console.log(this.fileList)
        }
      }
    },
    changeAreaLevel (query) {
      console.log(query);
      console.log(this.formLabelAlign1.bscUserInfoAgentSell.salesRegion);
      let salesRegions = this.formLabelAlign1.bscUserInfoAgentSell.salesRegion.split(",");
      console.log(this.formLabelAlign1.bscUserInfoAgentSell.salesRegion.indexOf(query.code) == -1);
      if (this.formLabelAlign1.bscUserInfoAgentSell.salesRegion.indexOf(query.code) == -1) {
        salesRegions.push(query.code);
        console.log(salesRegions);
        this.formLabelAlign1.bscUserInfoAgentSell.salesRegion = salesRegions.join(",");
        this.getAreaCity();
      }
    },
    //根据经销商名称获取合同号
    getAgentByContract (query) {
      ss.SignService.getAgentByContract(query).then(response => {
        console.log("response", response);
        this.formLabelAlign1.bscUserInfoAgentBasic.contractId = response.msg.id;
        //根据合同类型关联经销商类型
        //经销商框架合同类型 一级经销商、分销商、专营商、高能合伙人、直单用户、异业联盟、战略合作对应1234567
        //地市直营商 9
        //经销商等级 一级经销商1 分销商2 专营商3 直单4
        if (response.msg.contractAgent == 1) {
          this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel = '1';
          this.data.iszhidanBas = ''
          this.priceLevel = '01';
          //根据签约渠道
        } else if (response.msg.contractAgent == 3) {
          this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel = '3';
          this.data.iszhidanBas = ''
          this.priceLevel = '02';
        } else if (response.msg.contractAgent == 2) {
          this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel = '2';
          this.data.iszhidanBas = ''
          this.priceLevel = '02';
        } else if (response.msg.contractAgent == 5 || response.msg.contractAgent == 4 || response.msg.contractAgent == 6 || response.msg.contractAgent == 7) {
          this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel = '4';
          this.isZhiDan = true;
          this.data.iszhidanBas = '1'
          this.priceLevel = '04';
          this.formLabelAlign1.bscUserInfoAgentBasic.isZhidan = 1;
        } else if (response.msg.contractAgent == 8) {
          this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel = '5';
          this.data.iszhidanBas = ''
          this.isZhiDan = false;
          this.formLabelAlign1.bscUserInfoAgentBasic.oneLevelAgent = response.msg.oneLevelAgent;
          this.formLabelAlign1.bscUserInfoAgentBasic.oneLevelAgentName = response.msg.oneLevelAgentName;
          this.priceLevel = '03';
          this.formLabelAlign1.ctList = [{
            field: '',//领域
            channelList: [],//渠道
            channel: '',//渠道
            level: this.priceLevel,//等级
            num: null,
            lianqun: '',
            lianqunList: [],//链群
            showLq: false,
          }];
        } else if (response.msg.contractAgent == 9) {
          this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel = '6';
          this.data.iszhidanBas = ''
          this.priceLevel = '01';
        }else if (response.msg.contractAgent == 11) {
          this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel = '11';
          this.data.iszhidanBas = ''
          this.priceLevel = '01';
        }else if (response.msg.contractAgent == 12) {
          this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel = '12';
          this.data.iszhidanBas = ''
          this.priceLevel = '02';
        }else if (response.msg.contractAgent == 13) {
          this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel = '13';
          this.data.iszhidanBas = ''
          this.priceLevel = '03';
        }

        if(response.msg.industryList.length > 0){
          console.log(response.msg.industryList,"response.msg.industryList")
          for(var i=0;i<response.msg.industryList.length;i++){

            if(i >= 1){
              this.formLabelAlign1.ctList.push({
                field: response.msg.industryList[i].industry,
                channel: '',//渠道
                channelList: response.msg.industryList[i].channelList,//渠道
                level: this.priceLevel,//等级
                num: null,
                lianqun: '',
                lianqunList: [],//链群
              })
            }
            this.formLabelAlign1.ctList[i].field = response.msg.industryList[i].industry;
            this.formLabelAlign1.ctList[i].channelList = response.msg.industryList[i].channelList;

            if(this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel == '6'){
              this.formLabelAlign1.ctList[i].flType = "06";
            }else if(this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel == '5'){
              this.formLabelAlign1.ctList[i].flType = "03";
            }else {
              this.formLabelAlign1.ctList[i].flType = "01";
            }

            this.formLabelAlign1.ctList[i].level = this.priceLevel;
          }
        }
        console.log(  this.formLabelAlign1.ctList,"response.msg.industryList")
        //签约性质默认
        this.formLabelAlign1.bscUserInfoAgentSell.customerGroup2 = '02';
        this.formLabelAlign1.bscUserInfoAgentBasic.contractType = response.msg.contractAgent;
        //销售地区
        this.formLabelAlign1.bscUserInfoAgentSell.salesRegion = response.msg.saleareaCode;
        ss.UserService.getCityByAreaXsxz(response.msg.saleareaCode).then(rd => {
          console.log(rd);
          this.salesCity = rd.msg;
        })
        this.formLabelAlign1.bscUserInfoAgentBasic.oneLevelAgentName = response.msg.oneLevelAgentName;
        this.formLabelAlign1.bscUserInfoAgentBasic.oneLevelAgent = response.msg.oneLevelAgent;
        //销售地市
        if (response.msg.salesCitys.length <= 0) {
          this.formLabelAlign1.bscUserInfoAgentSell.salesCity = ''
        } else {
          this.formLabelAlign1.bscUserInfoAgentSell.salesCity = response.msg.salesCitys
          this.getCity(this.formLabelAlign1.bscUserInfoAgentSell.salesCity)
        }
      })
    },
    // 获取修改记录
    agentUpdateFile () {
      this.mf.userCode = this.formLabelAlign1.bscUserInfoAgentBasic.usercode;
      console.log("this.mf", this.mf);
      //更新到期时间
      agentCopyService.agentUpdateFile(this.mf).then(rd => {
        console.log("agentUpdateFile", rd)
        this.fileList = rd.records
        this.mf.total = rd.total
      });
    },
    // 查询链群list
    getLqList () {
      agentCopyService.getLqSelectList().then(res => {

        this.LQList = res
        console.log(this.LQList, "获取获取获取")
      });
    },
    LQSelect () {
      this.checkLQAfterList = [];
      let map = new Map();
      for (let item of this.LQList) {
        if (!map.has(item.lianqun)) {
          map.set(item.lianqun, item);
        };
      };
      console.log(this.LQList)
      console.log(this.LQcheckList)
      this.checkLQAfterList = [...map.values()].filter(item => this.LQcheckList.includes(item.lianqun))
      console.log(this.checkLQAfterList, 'hauifhdshfisdfhais')
      // 取消勾选项清空输入值
      let otherArr = [];
      for (let i = 0; i < this.LQList.length; i++) {
        let isExist = false;
        for (let j = 0; j < this.LQcheckList.length; j++) {
          if (this.LQList[i].lianqun === this.LQcheckList[j]) {
            isExist = true;
            break;
          }
        }
        if (!isExist) {
          otherArr.push(this.LQList[i]);
        }
      }
      if (this.addForm) {
        otherArr.forEach((el, index) => {
          this.addForm[el.companyCode] = '';
          this.addForm[el.companyCode + 'Channel'] = ''
        })
      }
      console.log(this.addForm)
      // this.$forceUpdate();
    },
    changeQudao () {
      this.formLabelAlign1.beUpdate++;
      this.$forceUpdate();
    },
    // 切换是否为增量时的处理逻辑
    handleIncrementChange(val) {
      // 选择no时，清空增量赋能平台的值
      if (val === '0') {
        this.formLabelAlign1.bscUserInfoAgentBasic.incrementPt = ''
      }
    },
    changeArea (query) {
      //如果是内销
      if (this.agentType != '3') {
        console.log("queryqueryquery", query);
        let areaList = query;
        var areas = [];
        for (var i = 0; i < areaList.length; i++) {
          areas.push(areaList[i].refid)
        }
        console.log(areas);
        ss.UserService.getCityByArea(areas).then(rd => {
          console.log(rd);
          this.salesCity = rd.msg;
        })
        this.formLabelAlign1.beUpdate++;
      }
    },
    getBackNameSupply () {
      this.MdmBankconfigInput.bankBranchCode = this.formLabelAlign1.bscUserInfoAgentBank.bankBranchCode;
      if (this.MdmBankconfigInput.bankBranchCode == null || this.MdmBankconfigInput.bankBranchCode == '') {
        return;
      }
      ss.SignService.getBackName(this.MdmBankconfigInput).then(response => {
        console.log(response, '银行名称对象')
        if (response.obj.bankTable.value.bankItem.length === 0) {
          this.$msg.msge("当前银行编号未查询到银行名称,请先填写名称查询");
          this.formLabelAlign1.bscUserInfoAgentBank.bankBranchCode = null;
          this.formLabelAlign1.bscUserInfoAgentBank.bankName = null;
          return;
        }
        this.formLabelAlign1.bscUserInfoAgentBank.bankName = response.obj.bankTable.value.bankItem[0].bankName;
      })
    },
    // 移除银行编号
    clearBackCode () {
      this.formLabelAlign1.bscUserInfoAgentBank.bankBranchCode = ''
    },
    //选择银行
    changeBackCodeSupply (val) {
      this.formLabelAlign1.bscUserInfoAgentBank.bankName = this.bankList.find(item => item.bankBranchCode == val).bankName
      this.formLabelAlign1.bscUserInfoAgentBank.bankBranchCode = val
    },
    //模糊搜索银行
    getBackCodeSupply (value) {
      // this.MdmBankconfigInput.bankName = this.formLabelAlign1.bscUserInfoAgentBank.bankName;
      // if (this.MdmBankconfigInput.bankName == null || this.MdmBankconfigInput.bankName == '') {
      //   return;
      // }
      ss.SignService.getBackName({
        bankName: value
      }).then(response => {
        console.log(response, '银行名称对象')
        // if (response.obj.bankTable.value.bankItem.length === 0) {
        //   this.$msg.msge("当前银行名称mdm不存在,请修改名称!");
        //   this.formLabelAlign1.bscUserInfoAgentBank.bankBranchCode = null;
        //   this.formLabelAlign1.bscUserInfoAgentBank.bankName = null;
        //   return;
        // }
        this.bankList = response.obj.bankTable.value.bankItem
        // this.formLabelAlign1.bscUserInfoAgentBank.bankBranchCode = response.obj.bankTable.value.bankItem[0].bankBranchCode;
      })
    },
    getMdmAgent () {
      let userName = this.formLabelAlign1.bscUserInfoAgentBasic.customerName1;

      if (null != userName && '' != userName) {
        ss.SignService.getMdmAgent("CUSTOMER_NAME1", userName).then(response => {
          if (response.f && response.obj) {
            let obj = response.obj;
            console.log(obj)
            if (response.f && response.obj) {
              if (!this.creatNewFlag) {
                this.$msg.msge("当前公司名称已注册,请走维护功能,客户编码为:" + response.obj.CUSTOMER_NUMBER);
              }
              this.formLabelAlign1.bscUserInfoAgentBasic.usercode = response.obj.CUSTOMER_NUMBER;
              this.formLabelAlign1.bscUserInfoAgentBasic.taxCode = response.obj.TAX_CODE;
              return;
            }
          }
        })
      }
    },
    //根据邮箱和名称查询驳回的经销商信息
    getBackUserInfo () {
      let userName = this.formLabelAlign1.bscUserInfoAgentBasic.customerName1;
      let email = this.formLabelAlign1.bscUserInfoAgentBasic.email;
      //如果公司名称和邮箱都不为空
      if (userName && email) {
        ss.SignService.getBackUserInfo(userName, email).then(response => {
          if (response.f && response.obj) {
            let obj = response.obj;

            /*********************************radio start******************************/
            //radio 交互代码已写 不太完整 暂时注释
            /* this.formLabelAlign1.bscUserInfoAgentSell.have6858 = obj.bscUserInfoAgentSell.have6858;
             if (obj.bscUserInfoAgentSell.have6858 == 1) {
               this.have6858 = true;
             }
             this.formLabelAlign1.bscUserInfoAgentSell.have6840 = obj.bscUserInfoAgentSell.have6840;
             if (obj.bscUserInfoAgentSell.have6840 == 1) {
               this.have6840 = true;
             }
             this.formLabelAlign1.bscUserInfoAgentSell.have6854 = obj.bscUserInfoAgentSell.have6854;
             if (obj.bscUserInfoAgentSell.have6854 == 1) {
               this.have6854 = true;
             }
             this.formLabelAlign1.bscUserInfoAgentSell.haveThree6840 = obj.bscUserInfoAgentSell.haveThree6840;
             if(obj.bscUserInfoAgentSell.haveThree6840 ==1){
                this.haveThree6840 = true;
             }
             //否是直单用户
             if(obj.bscUserInfoAgentBasic.isZhidan==1){
                this.isZhiDan = true;
                if(obj.bscUserInfoAgentBasic.companytype = "政府/军工企业"){
                  this.isGoverment =true;
                }

             }else{
               this.isZhiDan = false;

             }
             this.chooseZhiDan()

             //是否开通海外下单权限
             if(obj.bscUserInfoAgentBasic.isExpandAuthority==1){
               this.isExpandAuthority = true;
             }else{
               this.isExpandAuthority = false;
             }
             this.chooseAddAbroad();


              if (obj.bscUserInfoAgentSell.permit === 5) {
                  this.have2 = true;
                  this.have3 = true;
              } else if (obj.bscUserInfoAgentSell.permit === 2) {
                  this.have2 = true;
              }else if (obj.bscUserInfoAgentSell.permit === 3) {
                  this.have3 = true;
              }*/


            /*********************************radio end******************************/

            /*客户资质信息*/
            this.formLabelAlign1.bscUserInfoAgentBasic.customerName1 = obj.bscUserInfoAgentBasic.customerName1;
            if (obj.bscUserInfoAgentBasic.scale !== undefined) {
              this.formLabelAlign1.bscUserInfoAgentBasic.scale = obj.bscUserInfoAgentBasic.scale.toString();
            }
            this.formLabelAlign1.bscUserInfoAgentBasic.companyAddress = obj.bscUserInfoAgentBasic.companyAddress;
            this.formLabelAlign1.bscUserInfoAgentBasic.faxNumber = obj.bscUserInfoAgentBasic.faxNumber;
            this.formLabelAlign1.bscUserInfoAgentBasic.email = obj.bscUserInfoAgentBasic.email;
            this.formLabelAlign1.bscUserInfoAgentBasic.companytype = obj.bscUserInfoAgentBasic.companytype;
            this.formLabelAlign1.bscUserInfoAgentBasic.founded = obj.bscUserInfoAgentBasic.founded;
            this.formLabelAlign1.bscUserInfoAgentBasic.regmoney = obj.bscUserInfoAgentBasic.regmoney;
            this.formLabelAlign1.bscUserInfoAgentBasic.legal = obj.bscUserInfoAgentBasic.legal;
            this.formLabelAlign1.bscUserInfoAgentBasic.introduce = obj.bscUserInfoAgentBasic.introduce;
            this.formLabelAlign1.bscUserInfoAgentBasic.business = obj.bscUserInfoAgentBasic.business;
            this.formLabelAlign1.bscUserInfoAgentBasic.achievement = obj.bscUserInfoAgentBasic.achievement;
            this.formLabelAlign1.bscUserInfoAgentBasic.resource = obj.bscUserInfoAgentBasic.resource;
            this.formLabelAlign1.bscUserInfoAgentBasic.name1 = obj.bscUserInfoAgentBasic.name1;
            this.formLabelAlign1.bscUserInfoAgentBasic.contactMobilePhone = obj.bscUserInfoAgentBasic.contactMobilePhone;
            //如果开通海外下单权限
            /* if(obj.bscUserInfoAgentBasic.isExpandAuthority==1){
               this.formLabelAlign1.bscUserInfoAgentBasic.country = obj.bscUserInfoAgentBasic.country;
             }*/

            this.formLabelAlign1.bscUserInfoAgentBasic.region = obj.bscUserInfoAgentBasic.region;
            this.formLabelAlign1.bscUserInfoAgentBasic.contactCity = obj.bscUserInfoAgentBasic.contactCity;
            this.formLabelAlign1.bscUserInfoAgentBasic.businessScale = obj.bscUserInfoAgentBasic.businessScale;
            this.formLabelAlign1.bscUserInfoAgentBasic.staffing = obj.bscUserInfoAgentBasic.staffing;

            /*开票信息*/
            /*this.formLabelAlign1.bscUserInfoAgentBasic.customerName1 = obj.bscUserInfoAgentBasic.customerName1*/
            this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber = obj.bscUserInfoAgentBasic.phoneNumber;
            this.formLabelAlign1.bscUserInfoAgentBasic.cityStreetRoom = obj.bscUserInfoAgentBasic.cityStreetRoom;
            this.formLabelAlign1.bscUserInfoAgentBasic.taxCode = obj.bscUserInfoAgentBasic.taxCode;
            this.formLabelAlign1.bscUserInfoAgentBank.bankBranchCode = obj.bscUserInfoAgentBank.bankBranchCode;
            this.formLabelAlign1.bscUserInfoAgentBank.bankName = obj.bscUserInfoAgentBank.bankName;
            this.formLabelAlign1.bscUserInfoAgentBank.accountHolderName = obj.bscUserInfoAgentBank.accountHolderName;
            this.formLabelAlign1.bscUserInfoAgentBank.bankCountry = obj.bscUserInfoAgentBank.bankCountry;
            this.formLabelAlign1.bscUserInfoAgentSell.customerGroup1 = obj.bscUserInfoAgentSell.customerGroup1;
            //如果开通海外下单权限
            /*if(obj.bscUserInfoAgentBasic.isExpandAuthority==1){
               this.formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms  = obj.bscUserInfoAgentSell.intCommercialTerms;
               this.formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms2 = obj.bscUserInfoAgentSell.intCommercialTerms2;
            }*/

            this.formLabelAlign1.bscUserInfoAgentSell.currencyCode = obj.bscUserInfoAgentSell.currencyCode;

            /*邮寄发票信息*/
            this.formLabelAlign1.bscUserInfoAgentCompany.mailreceiver = obj.bscUserInfoAgentCompany.mailreceiver;
            this.formLabelAlign1.bscUserInfoAgentCompany.receiverphone = obj.bscUserInfoAgentCompany.receiverphone;
            this.formLabelAlign1.bscUserInfoAgentCompany.mailaddress = obj.bscUserInfoAgentCompany.mailaddress;


          } else {
            this.formLabelAlignNull.bscUserInfoAgentBasic.customerName1 = this.formLabelAlign1.bscUserInfoAgentBasic.customerName1;
            this.formLabelAlignNull.bscUserInfoAgentBasic.email = this.formLabelAlign1.bscUserInfoAgentBasic.email;
            this.formLabelAlign1 = this.formLabelAlignNull;
          }

        })
      }
    }
  },
  mounted () {
    this.flag = this.$route.query.index;

    if (this.flag === '2') {
      this.uploadflag = false;
      this.delflag = false;
      this.data = this.$route.query;
      this.rules = {};
      this.checkDetail();
    } else if (this.flag === '3') {
      this.uploadflag = false;
      this.delflag = false;
      this.data = this.$route.query;
      this.rules = {};
      this.checkDetail();
    }
    let str = this.formLabelAlign1.bscUserInfoAgentBasic.companyCode;
    if (str && str.split(',').indexOf('9390') >= 0) {
      this.isShowAllSelect = true;//判断是否展示全部群连并checkbox
    }

  },

}
</script>
<style>
.border1 {
  border-bottom: none;
  border-top: none;
  border-left: none;
  border-right: none;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
.qudoa {
  font-size: 0.18rem;
  color: #868686;
  line-height: 0.28rem;
  width: 0.5rem;
}
.foundation-box {
  font-size: 0.18rem;
  color: #868686;
  line-height: 0.28rem;
}
.Yangbiao .h-elformWrap-3 {
  width: 85% !important;
  padding-right: 0.5rem !important;
}
.Yangbiao .h-elformWrap-3 .el-form-item__label {
  width: 12% !important;
  text-align: right !important;
}
</style>
<style scoped>
.imgBox {
  margin: 20px;
}

.bannerBox {
  width: 100%;
  margin: 0 auto;
}

.whiteBox {
  padding: 0.22rem 0.26rem;
  background-color: #ffffff;
}

.titles {
  font-size: 0.16rem;
  color: #0e75e9;
  position: relative;
  padding-left: 9px;
  border-left: 0.05rem solid #0e75e9;
  font-weight: bold;
}

::v-deep .weekplandetail10 .h-formbLine .h-elformWrap-2 {
  width: 33% !important;
}
::v-deep .weekplandetail10 .h-formbLine .h-elformWrap-5 {
  width: 39% !important;
  margin-left: 10%;
}
::v-deep .weekplandetail10 .h-formbLine .h-elformWrap-5 .el-form-item__content {
  width: 90%;
}
::v-deep .weekplandetail10 .h-formbLine .h-elformWrap-2 .el-form-item__label {
  width: 50%;
}
::v-deep.weekplandetail10
  .h-formbLine
  .el-form-item.HAVES-2
  .el-form-item__label {
  width: 10%;
}

::v-deep
  .weekplandetail10
  .h-formbLine
  .el-form-item.HAVES-2
  .el-form-item__content {
  width: 90%;
}

.weekplandetail10 .h-formbLine .h-elformWrap-1 .el-form-item__content {
  width: 70%;
}

::v-deep .weekplandetail10 .h-formbLine .h-elformWrap-1 .el-form-item__label {
  width: 22.5%;
}

 ::v-deep .newBox .el-form-item__content {
  width: 77.5%;
}

::v-deep .newBox .el-form-item__label {
  width: 12%;
  text-align: right;
}
::v-deep.signsign .h-formbLine .other .el-form-item__label {
  width: 9.7%;
  text-align: right;
}
::v-deep.signsign .h-formbLine .other .el-form-item__content {
  width: 88%;
}

.passfollow {
  position: absolute;
  right: 0;
  bottom: 0.3rem;
  background-color: #2785e7;
  color: white;
}

::v-deep .zhanghu .h-formbLine .el-form-item__label {
  width: 42%;
}

::v-deep .signsign .h-formbLine .el-form-item__label {
  width: 41%;
}

::v-deep .zhanghu .h-formbLine .el-form-item__content,
::v-deep .signsign .h-formbLine .el-form-item__content {
  width: 52%;
}

::v-deep .zhanghu .h-formbLine .h-elformWrap-2,
::v-deep .signsign .h-formbLine .h-elformWrap-2 {
  width: 25%;
  padding-right: 0;
}

::v-deep.weekplandetail10 .h-formbLine .el-form-item__label {
  width: 48%;
}

::v-deep.weekplandetail10 .h-formbLine .el-form-item__content {
  width: 50%;
}

.bannerBox .el-form-item__content {
  width: 85%;
}

.bannerBox .el-input__inner {
  border: none;
  border-bottom: 1px solid #dcdfe6;
}
::v-deep .el-input__inner{
  border: none;
  border-radius: 0;
  border-bottom: 1px solid #dcdfe6;
}

::v-deep .width .h-formbLine .el-form-item__content .el-select {
  width: 100%;
}

::v-deep .signsign .h-formbLine .h-elformWrap-1 .el-form-item__label {
  width: 0%;
}

::v-deep .signsign .h-formbLine .h-elformWrap-1 .el-form-item__content {
  width: 100%;
}

.gccolor .el-form-item__label {
  color: rgb(255, 36, 36);
}
.w-elformWrap {
  width: 100% !important;
}
.w-elformWrap .el-form-item__label {
  width: 11% !important;
}
.w-elformWrap .el-form-item__content {
  width: 89% !important;
}
.collapseTitle {
  font-size: 0.16rem;
  font-weight: bold;
  line-height: 1.11;
  padding-left: 10px;
  border-left: 0.05rem solid #0e75e9;
}
::v-deep.el-tabs--border-card  {
  border:none;
  box-shadow: none;
}
::v-deep .el-tabs--border-card>.el-tabs__header{
  border: 1px solid #E4E7ED;
}
</style>
